const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postSmartDeviceCommandRequestURL = endpointHelias+'/Helias/V0/SmartDevices/postSmartDeviceCommand'
const postInstallerSharedInstallationDetail = endpointHelias+'/Helias/V0/General/postInstallerSharedInstallationDetail'
const updateTankLevelFull = endpointHelias+'/Helias/V0/Configuration/updateTankLevelFull'
const postManageDynamicCarCharge = endpointHelias+'/Helias/V0/Rules/postManageDynamicCarCharge'
const postUpdateSolarWallet = endpointHelias+'/Helias/V0/Configuration/postUpdateSolarWallet'
const postListInstallationRules = endpointHelias+'/Helias/V0/Rules/postListInstallationRules'
const putInstallationRules = endpointHelias+'/Helias/V0/Rules/putInstallationRules'
const updateAccountIDInstallation = endpointHelias+'/Helias/V0/Configuration/updateAccountIDInstallation';
const getHelias3pCredentials = endpointHelias+"/3rdParty/V0/Credentials/getHelias3pCredentials"
const postManageDynamicBatteriesNightCharge = endpointHelias+'/Helias/V0/Rules/postManageDynamicBatteriesNightCharge'
const postRetrieveDailyFees = endpointHelias+'/Helias/V0/General/postRetrieveDailyFees'

var initialConfigCommonJS = require("../js/initialConfigCommon.js")
var rulesCommonJS = require("../js/rulesCommon.js")
var generalCommonJS = require("../js/generalCommon.js")

exports.comprobarPropiedadInstalacion = function(){

  var instalacionesDisponibles = localStorage.getItem("availableInstallations").split("|")

  var esPropietario = false

  try{
    if(generalCommonJS.obtenerEmailUsuario() !== "soporte@fevergy.com"){
      for(var x=0; x < instalacionesDisponibles.length; x++){
        if( (localStorage.getItem("installationId") === instalacionesDisponibles[x].split("·")[0]) && (instalacionesDisponibles[x].split("·")[3] === "true") ){
          esPropietario = true          
          break
        }
      }
    }
    else{ //Usuario de soporte
      esPropietario = true          
    }
  }
  catch(error){
    esPropietario = true          
  }

  return esPropietario

}

exports.setearColorKPI = function(tipoKpi, kpi, valorActual){

  if(tipoKpi === "autoconsumo"){

    if( parseFloat(valorActual) < 10.0){
      document.getElementById(kpi).className += " red"
    }
    else if( (parseFloat(valorActual) >= 10.0) && (parseFloat(valorActual) < 40.0) ){
      document.getElementById(kpi).className += " orange"
    }
    else if( (parseFloat(valorActual) >= 40.0) && (parseFloat(valorActual) < 60.0) ){
      document.getElementById(kpi).className += " lime"
    }
    else if( (parseFloat(valorActual) >= 60.0) && (parseFloat(valorActual) < 100.0) ){
      document.getElementById(kpi).className += " green"
    }
    else if( parseInt(valorActual) === 100){
      document.getElementById(kpi).className += " gold"
    }     

  }
  else if(tipoKpi === "gasto"){

    if(parseFloat(valorActual) < 0.0){      
      if(document.getElementById("literal"+kpi) !== null){ document.getElementById("literal"+kpi).innerHTML = "Gasto mes" }
      document.getElementById("figure"+kpi).className += " red"
    }
    else if(parseFloat(valorActual) === 0.0){
      if(document.getElementById("literal"+kpi) !== null){ document.getElementById("literal"+kpi).innerHTML = "Gasto mes" }
      document.getElementById("figure"+kpi).className += " cyan"
    }
    else if(parseFloat(valorActual) > 0.0){
      if(JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyGridConnected === "true" ){
        if(document.getElementById("literal"+kpi) !== null){ document.getElementById("literal"+kpi).innerHTML = "Ganado mes" }
      }
      else{
        if(document.getElementById("literal"+kpi) !== null){ document.getElementById("literal"+kpi).innerHTML = "Ahorro mes" }
      }
      
      document.getElementById("figure"+kpi).className += " green"
    }
  }
  else if(tipoKpi === "aprovechamiento"){

    if(parseFloat(valorActual) < 50.0){            
      document.getElementById(kpi).className += " red"
    }
    else if( (parseFloat(valorActual) >= 50.0) && (parseFloat(valorActual) < 80.0) ){      
      document.getElementById(kpi).className += " orange"
    }
    else if( (parseFloat(valorActual) >= 80.0) && (parseFloat(valorActual) < 100.0) ){      
      document.getElementById(kpi).className += " green"
    }
    else if(parseInt(valorActual) === 100){      
      document.getElementById(kpi).className += " gold"
    }
  }

  else if(tipoKpi === "reactiva"){

    if(parseFloat(valorActual) >= 30.0){            
      document.getElementById(kpi).className += " red"
    }
    else if( (parseFloat(valorActual) >= 20.0) && (parseFloat(valorActual) < 30.0) ){      
      document.getElementById(kpi).className += " orange"
    }
    else if( (parseFloat(valorActual) > 0.0) && (parseFloat(valorActual) < 20.0) ){      
      document.getElementById(kpi).className += " green"
    }
    else if(parseInt(valorActual) === 0){      
      document.getElementById(kpi).className += " gold"
    }
  }

}

exports.setearColorValorFactura = function(instalacionAutoconsumo, campo){

  if(document.getElementById(campo) !== null){

    if(instalacionAutoconsumo){
      if(campo.includes("EurosMonederoSolar")){
        document.getElementById(campo).style="color: #FFC300;" //Mostaza
      }
      else if( (document.getElementById(campo).innerHTML.includes("-")) || (document.getElementById(campo).id.includes("Grupo")) ){ //Cargo
        
        if(parseFloat(document.getElementById(campo).innerHTML).toFixed(2) === 0.00){
          document.getElementById(campo).style="color: var(--green-300)"          
        }
        else{
          document.getElementById(campo).style="color: var(--red-300)" //Rojo oscuro          
        }        

      }
      else{ //Abono
        document.getElementById(campo).style="color: var(--green-300)"
      }
    }
    else{
      document.getElementById(campo).style="color: #00CCCC;" //Cyan
    }
  }

}

exports.precalentarLambda = function(nombreLambda){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  //Petición de datos para el paso actual    
  var jsonPeticion = {"INIT": "true"}

  var metodoPeticion = ""
  var urlLambda = ""

  if(nombreLambda === "postSmartDeviceCommand"){
    metodoPeticion = "POST"
    urlLambda = postSmartDeviceCommandRequestURL
  }
  else if(nombreLambda === "postListInstallationRules"){
    metodoPeticion = "POST"
    urlLambda = postListInstallationRules
  }
  else if(nombreLambda === "putInstallationRules"){
    metodoPeticion = "PUT"
    urlLambda = putInstallationRules
  }  
  else if(nombreLambda === "updateAccountIDInstallation"){
    metodoPeticion = "POST"
    urlLambda = updateAccountIDInstallation
  } 
  else if(nombreLambda === "getHelias3pCredentials"){
    metodoPeticion = "POST"
    urlLambda = getHelias3pCredentials    
  } 

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open(metodoPeticion, urlLambda, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {          
        console.log("Precalentamiento realizado correctamente.")        
      }      
    }
    xhttp.send(data);
}

exports.obtenerCantidadEnergiaDimensionadaFront = function(cantidad, numeroDecimales){

  //La cantidad siempre viene en W

  var literalResultado = ""

  if(cantidad > 1000000){

    if( parseInt((parseFloat(cantidad)/1000000)) > 100){ //Cuando son cientos de megawatios no muestro decimales
      numeroDecimales = 0
    }
    else{ //Si son menos de cien muestro 2 decimales
      numeroDecimales = 2
    }

    literalResultado = new Intl.NumberFormat('en-DE').format(parseFloat((parseFloat(cantidad)/1000000)).toFixed(numeroDecimales)) + " M"
  }
  else{

    if( parseInt((parseFloat(cantidad)/1000)) > 100){ //Cuando son cientos de kilowatios no muestro decimales
      numeroDecimales = 0
    }

    literalResultado = new Intl.NumberFormat('en-DE').format(parseFloat((parseFloat(cantidad)/1000)).toFixed(numeroDecimales)) + " k"
  }

  return literalResultado

}

exports.cargarScoring = function(jsonObjRespuestaDashboard, idInstalacion){

  if(Object.keys(jsonObjRespuestaDashboard).length > 0){ // Si tengo datos
    
    //* ************************************************************************************************************************************************************************************** */
    // [ LÓGICA COMÚN A TODAS LAS CASUÍSTICAS ]
    //* ************************************************************************************************************************************************************************************** */

    var fechaRegistro = new Date(parseInt(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationlastUpdate)*1000)      
    var dia = fechaRegistro.getDate()
    var mes = fechaRegistro.getMonth()+1
    var hora = fechaRegistro.getHours()
    var minutos = fechaRegistro.getMinutes()

    if(dia.toString().length === 1){ dia = "0"+dia }
    if(mes.toString().length === 1){ mes = "0"+mes }
    if(hora.toString().length === 1){ hora = "0"+hora }
    if(minutos.toString().length === 1){ minutos = "0"+minutos }
    
    if(Object.keys(jsonObjRespuestaDashboard.GeneratorData).length > 0){
      document.getElementById("etiquetaEnergiaAutoconsumoHoy").innerHTML = "Cantidad"
      document.getElementById("etiquetaEnergiaAutoconsumoMes").innerHTML = "Cantidad"
      document.getElementById("etiquetaEnergiaAutoconsumoAño").innerHTML = "Cantidad"
      document.getElementById("etiquetaEnergiaAutoconsumoDesdeRegistro").innerHTML = "Cantidad"
    }

    // [HOY]      
    document.getElementById("valorHoyAutoconsumo").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayselfConsumption.Value).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayselfConsumption.Unit      
    document.getElementById("valorHoyAprovechamiento").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayEnergeticUse.Value).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayEnergeticUse.Unit      
    document.getElementById("valorHoyConsumidaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.Todayconsumption.Value, 2) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.Todayconsumption.Unit + "h"
    document.getElementById("valorHoyValorEnergiaConsumida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayusedEnergyCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayusedEnergyCost.Unit            
    document.getElementById("valorPestañaAutoconsumoHoy").innerHTML = document.getElementById("valorHoyValorEnergiaConsumida").innerHTML

    module.exports.setearColorKPI("autoconsumo","iconoAutoconsumoHoy", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayselfConsumption.Value)
    module.exports.setearColorKPI("aprovechamiento","iconoAprovechamientoHoy", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayEnergeticUse.Value)
    
    // [MES]      
    document.getElementById("valorMesAutoconsumo").innerHTML = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Value).toFixed(0) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Unit      
    document.getElementById("valorMesAprovechamiento").innerHTML = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthEnergeticUse.Value).toFixed(0) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthEnergeticUse.Unit
    document.getElementById("valorMesConsumidaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthconsumption.Value, 2) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthconsumption.Unit + "h"
    document.getElementById("valorMesValorEnergiaConsumida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthusedEnergyCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthusedEnergyCost.Unit
    document.getElementById("valorPestañaAutoconsumoMes").innerHTML = document.getElementById("valorMesValorEnergiaConsumida").innerHTML

    module.exports.setearColorKPI("autoconsumo","iconoAutoconsumoMes", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Value)
    module.exports.setearColorKPI("aprovechamiento","iconoAprovechamientoMes", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthEnergeticUse.Value)

    // [AÑO]
    document.getElementById("valorAñoAutoconsumo").innerHTML = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearselfConsumption.Value).toFixed(0) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearselfConsumption.Unit      
    document.getElementById("valorAñoAprovechamiento").innerHTML = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearEnergeticUse.Value).toFixed(0) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearEnergeticUse.Unit
    document.getElementById("valorAñoConsumidaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.Yearconsumption.Value, 2) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.Yearconsumption.Unit + "h"
    document.getElementById("valorAñoValorEnergiaConsumida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearusedEnergyCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearusedEnergyCost.Unit
    document.getElementById("valorPestañaAutoconsumoAño").innerHTML = document.getElementById("valorAñoValorEnergiaConsumida").innerHTML

    module.exports.setearColorKPI("autoconsumo","iconoAutoconsumoAño", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearselfConsumption.Value)
    module.exports.setearColorKPI("aprovechamiento","iconoAprovechamientoAño", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearEnergeticUse.Value)

    // [DESDE REGISTRO]            
    
    document.getElementById("valorFechaDesdeRegistro").innerHTML = dia + "/"+ mes +"/"+fechaRegistro.getFullYear() + " - "+ hora + ":" + minutos

    document.getElementById("valorDesdeRegistroAutoconsumo").innerHTML = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationselfConsumption.Value).toFixed(0) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationselfConsumption.Unit      
    document.getElementById("valorDesdeRegistroAprovechamiento").innerHTML = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationEnergeticUse.Value).toFixed(0) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationEnergeticUse.Unit
    document.getElementById("valorDesdeRegistroConsumidaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationconsumption.Value, 2) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationconsumption.Unit + "h"
    document.getElementById("valorDesdeRegistroValorEnergiaConsumida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationusedEnergyCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationusedEnergyCost.Unit
    document.getElementById("valorPestañaAutoconsumoDesdeRegistro").innerHTML = document.getElementById("valorDesdeRegistroValorEnergiaConsumida").innerHTML

    module.exports.setearColorKPI("autoconsumo","iconoAutoconsumoDesdeRegistro", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationselfConsumption.Value)
    module.exports.setearColorKPI("aprovechamiento","iconoAprovechamientoDesdeRegistro", jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationEnergeticUse.Value)

    // GRUPO ELECTRÓGENO:

    if(Object.keys(jsonObjRespuestaDashboard.GeneratorData).length > 0){ //Hay grupo configurado

      document.getElementById("trGrupoHoy").className = document.getElementById("trGrupoHoy").className.replaceAll(" hidden", "")
      document.getElementById("trGrupoMes").className = document.getElementById("trGrupoMes").className.replaceAll(" hidden", "")
      document.getElementById("trGrupoAño").className = document.getElementById("trGrupoAño").className.replaceAll(" hidden", "")
      document.getElementById("trGrupoDesdeRegistro").className = document.getElementById("trGrupoDesdeRegistro").className.replaceAll(" hidden", "")

      document.getElementById("valorLitrosConsumidosGrupoHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.TodayGeneratorLitersConsumed.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.TodayGeneratorLitersConsumed.Unit
      document.getElementById("valorEurosGastadosGrupoHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.TodayGeneratorConsumptionCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.TodayGeneratorConsumptionCost.Unit
      document.getElementById("valorPestañaAutoconsumoHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayselfConsumptionBalance.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayselfConsumptionBalance.Unit      

      document.getElementById("valorLitrosConsumidosGrupoMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.CurrentMonthGeneratorLitersConsumed.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.CurrentMonthGeneratorLitersConsumed.Unit
      document.getElementById("valorEurosGastadosGrupoMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.CurrentMonthGeneratorConsumptionCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.CurrentMonthGeneratorConsumptionCost.Unit        
      document.getElementById("valorPestañaAutoconsumoMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Unit      

      document.getElementById("valorLitrosConsumidosGrupoAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.YearGeneratorLitersConsumed.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.YearGeneratorLitersConsumed.Unit
      document.getElementById("valorEurosGastadosGrupoAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.YearGeneratorConsumptionCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.YearGeneratorConsumptionCost.Unit        
      document.getElementById("valorPestañaAutoconsumoAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearselfConsumptionBalance.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearselfConsumptionBalance.Unit      

      document.getElementById("valorLitrosConsumidosGrupoDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.SinceRegistrationGeneratorLitersConsumed.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.SinceRegistrationGeneratorLitersConsumed.Unit
      document.getElementById("valorEurosGastadosGrupoDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.GeneratorData.SinceRegistrationGeneratorConsumptionCost.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.GeneratorData.SinceRegistrationGeneratorConsumptionCost.Unit        
      document.getElementById("valorPestañaAutoconsumoDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationselfConsumptionBalance.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationselfConsumptionBalance.Unit      
      
    }
    else{
      document.getElementById("trGrupoHoy").className = document.getElementById("trGrupoHoy").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trGrupoMes").className = document.getElementById("trGrupoMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trGrupoAño").className = document.getElementById("trGrupoAño").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trGrupoDesdeRegistro").className = document.getElementById("trGrupoDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
    }
    

    if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){

      try{
        document.getElementById("botonTarifasDiarias").className = document.getElementById("botonTarifasDiarias").className.replaceAll(" hidden", "")
      }
      catch(error){}
      
      //* ************************************************************************************************************************************************************************************** */
      // [ ECONOMICS ]: COMPROBACIÓN TARIFAS
      //* ************************************************************************************************************************************************************************************** */

      if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
        
        document.getElementById("botonCompararTarifas").className = document.getElementById("botonCompararTarifas").className.replaceAll(" hidden", "") 

        var datosUltimaComprobacionTarifas = []

        try{
          datosUltimaComprobacionTarifas = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.LastBillingFeesCheck.split("|")
          //"LastBillingFeesCheck": "1711616646|Naturgy - Solar|-1.67|-20.32|FA_VERY_LOW_SAVINGS|FA_WALLET_POSITIVE",
        }
        catch(error){
          console.log(error)
          datosUltimaComprobacionTarifas[0] = ""
        }

        var literalComprobacionTarifas = ""
        var literalComprobacionTarifasDashboard = ""

        //Meter casuisticas
        if(datosUltimaComprobacionTarifas[0] === ""){
          literalComprobacionTarifas = initialConfigCommonJS.obtenerLiteralAtributo("FA_NO_CHECK")   
          literalComprobacionTarifasDashboard = initialConfigCommonJS.obtenerLiteralAtributo("FA_NO_CHECK")   
        }
        else{
          
          var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
          var billingCheckDate = (new Date(new Date(datosUltimaComprobacionTarifas[0] * 1000) - tzoffset)).toISOString();     
          billingCheckDate = billingCheckDate.split("T")
          var elementosFechaBillingCheckDate = billingCheckDate[0].split("-")
          var elementosHoraBillingDate = billingCheckDate[1].split(":")

          billingCheckDate = elementosFechaBillingCheckDate[2]+"/"+elementosFechaBillingCheckDate[1]+"/"+elementosFechaBillingCheckDate[0] + " - " + elementosHoraBillingDate[0] + ":" + elementosHoraBillingDate[1]

          new Intl.NumberFormat('en-DE').format(datosUltimaComprobacionTarifas[3]*-1)

          if(datosUltimaComprobacionTarifas[5] === "FA_CHANGE"){
            literalComprobacionTarifas = "<p class='size-s'>" + billingCheckDate + "</p><p> Ahorrarías "+ new Intl.NumberFormat('en-DE').format(datosUltimaComprobacionTarifas[3]*-1) + " € al año con " + datosUltimaComprobacionTarifas[1] + "</p>"            
            literalComprobacionTarifasDashboard = "Ahorrarías "+ new Intl.NumberFormat('en-DE').format(datosUltimaComprobacionTarifas[3]*-1) + " € al año"
            document.getElementById("linkAhorroTarifasDashboard"+idInstalacion).className = document.getElementById("linkAhorroTarifasDashboard"+idInstalacion).className.replaceAll(" hidden", "")
            
          }
          else{
            literalComprobacionTarifas = "<p>" + billingCheckDate + "</p><p>" + initialConfigCommonJS.obtenerLiteralAtributo(datosUltimaComprobacionTarifas[5]) + "</p>"
            literalComprobacionTarifasDashboard =initialConfigCommonJS.obtenerLiteralAtributo(datosUltimaComprobacionTarifas[5])
            document.getElementById("linkAhorroTarifasDashboard"+idInstalacion).className = document.getElementById("linkAhorroTarifasDashboard"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
          }

        }

        // PROVISIONAL HASTA ACLARAR QUÉ HACEMOS CON EL ANALIZADOR DE TARIFAS.

        try{
          var jsonDashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))

          console.log(jsonDashboardData.GeneralData.InstallationType)

          if(jsonDashboardData.GeneralData.InstallationType === "EMPRESA"){
            document.getElementById("linkAhorroTarifasDashboard").className = document.getElementById("linkAhorroTarifasDashboard").className.replaceAll(" hidden","") + " hidden"
            document.getElementById("botonCompararTarifas").className = document.getElementById("botonCompararTarifas").className.replaceAll(" hidden","") + " hidden"
          }
        }
        catch(error){}

      }
      else{
        document.getElementById("botonCompararTarifas").className = document.getElementById("botonCompararTarifas").className.replaceAll(" hidden", "") + " hidden"
      }
      
      document.getElementById("literalBotonUltimaComprobacionTarifas").innerHTML = literalComprobacionTarifas
      document.getElementById("literalAhorroTarifaDashboard"+idInstalacion).innerHTML = literalComprobacionTarifasDashboard

      
      //* ************************************************************************************************************************************************************************************** */
      // [ DASHBOARD ]: VALORES, LITERALES Y COLORES
      //* ************************************************************************************************************************************************************************************** */

      var scoringAutoconsumo = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Value      
      document.getElementById("scoringInstalacionEficiencia"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(scoringAutoconsumo).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Unit
      document.getElementById("literalAutoconsumo"+idInstalacion).innerHTML = "Autoconsumo"
      document.getElementById("figureAutoconsumo"+idInstalacion).className = document.getElementById("figureAutoconsumo"+idInstalacion).className.replaceAll(" red", "").replaceAll(" orange", "").replaceAll(" lime", "").replaceAll(" cyan", "").replaceAll(" green", "").replaceAll(" gold", "")
      document.getElementById("figureAhorroGasto"+idInstalacion).className = document.getElementById("figureAhorroGasto"+idInstalacion).className.replaceAll(" red", "").replaceAll(" orange", "").replaceAll(" lime", "").replaceAll(" cyan", "").replaceAll(" green", "").replaceAll(" gold", "")

      var totalFacturaConIVA = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthsavingsBalance.Value)
      var scoringAhorro = parseFloat(totalFacturaConIVA).toFixed(2)

      if (scoringAhorro.toString() === "0.00"){          
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(scoringAhorro).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthsavingsBalance.Unit
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML.replaceAll("-","")
      }
      else{          
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(scoringAhorro).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthsavingsBalance.Unit
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML.replaceAll("-","")
      }  

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){                    
        module.exports.setearColorKPI("autoconsumo","figureAutoconsumo"+idInstalacion, scoringAutoconsumo)
        module.exports.setearColorKPI("gasto","AhorroGasto"+idInstalacion, scoringAhorro)      
      }
      else{          
        document.getElementById("figureAhorroGasto"+idInstalacion).className += " cyan"
        document.getElementById("figureAutoconsumo"+idInstalacion).className += " cyan"
      }
      
      var estadoActualfigureAhorroGasto = document.getElementById("figureAhorroGasto"+idInstalacion).className

      //* ************************************************************************************************************************************************************************************** */
      // [ HOY ]: VALORES, LITERALES Y COLORES
      //* ************************************************************************************************************************************************************************************** */
      //Pestaña factura                        

      document.getElementById("valorHoyTomadaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayfromGrid.Value, 2) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayfromGrid.Unit
      document.getElementById("valorHoyDevueltaARed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodaytoGrid.Value, 2) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodaytoGrid.Unit                
      document.getElementById("valorHoyPorcentajeReactiva").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayPercentageReactive.Value).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayPercentageReactive.Unit                        
      document.getElementById("valorImportePenalizacionReactivaHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayReactivePenaltyAmount.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayReactivePenaltyAmount.Unit                        
      document.getElementById("valorContadorExcesosPotenciaHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayPowerExcessesCount).toFixed(0))
      document.getElementById("valorImportePenalizacionExcesosPotenciaHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayPowerExcessesPenalty.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayPowerExcessesPenalty.Unit                        
      
      if(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyWaste.Value).toFixed(2) !== "0.00"){ 
        jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyWaste.Value = (jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyWaste.Value * -1).toString()
      }
      document.getElementById("valorHoyEnergiaComprada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyWaste.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyWaste.Unit      
      
      // PRECIOS

      var mediaCompraHoy = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyWaste.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayfromGrid.Value)).toFixed(3)     
      var precioMedioDiarioCompra = parseFloat(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.DailyAverageBuyPrice).toFixed(3)     
      
      if(isNaN(mediaCompraHoy)){ mediaCompraHoy = 0 }

      if(mediaCompraHoy < 0){ mediaCompraHoy = mediaCompraHoy * -1}
      
      document.getElementById("valorEnergyBuyPrice").innerHTML =  "Media: " + new Intl.NumberFormat('en-DE').format(mediaCompraHoy) + " €/kWh"   
      document.getElementById("valorDailyAverageBuyPrice").innerHTML =  new Intl.NumberFormat('en-DE').format(precioMedioDiarioCompra) + " €/kWh"

      if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.EnergyBuyPrice !== ""){ //PRECIO FIJO / VARIABLE
        //document.getElementById("valorEnergyBuyPrice").innerHTML = "Ahora: "+ new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.EnergyBuyPrice).toFixed(3)) + " €/kWh"        
        document.getElementById("valorCompraAhoraDashboard"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.EnergyBuyPrice).toFixed(3)) + " €/kWh"
        
      }
      else{
        //document.getElementById("valorEnergyBuyPrice").innerHTML = "Ahora: "+ new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.DailyEnergyBuyPrice.Value).toFixed(3)) + " " + jsonObjRespuestaDashboard.InstallationData.GeneralInfo.DailyEnergyBuyPrice.Unit        
        document.getElementById("valorCompraAhoraDashboard"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.DailyEnergyBuyPrice.Value).toFixed(3)) + " " + jsonObjRespuestaDashboard.InstallationData.GeneralInfo.DailyEnergyBuyPrice.Unit          
      }

      var elementosConsumoTramosHoy = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayfromGridPerTimeframe.split("#")
      
      if(elementosConsumoTramosHoy.length === 3){
        document.getElementById("spanP1Hoy").innerHTML = "P1 : Punta"
        document.getElementById("spanP2Hoy").innerHTML = "P2 : Llano"
        document.getElementById("spanP3Hoy").innerHTML = "P3 : Valle"
      }

      document.getElementById("trTramoP1CompradaHoy").className = document.getElementById("trTramoP1CompradaHoy").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP2CompradaHoy").className = document.getElementById("trTramoP2CompradaHoy").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP3CompradaHoy").className = document.getElementById("trTramoP3CompradaHoy").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP4CompradaHoy").className = document.getElementById("trTramoP4CompradaHoy").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP5CompradaHoy").className = document.getElementById("trTramoP5CompradaHoy").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP6CompradaHoy").className = document.getElementById("trTramoP6CompradaHoy").className.replaceAll(" hidden", "") + " hidden"

      var consumoTotalParcialesHoy = 0
      for(var x=0; x<elementosConsumoTramosHoy.length; x++){            
        consumoTotalParcialesHoy = consumoTotalParcialesHoy + parseFloat(elementosConsumoTramosHoy[x])
      }

      var porcentajesPorTramoHoy = []
      for(x=0; x<elementosConsumoTramosHoy.length; x++){            
        porcentajesPorTramoHoy[x] = parseFloat( parseFloat(elementosConsumoTramosHoy[x]) / parseFloat(consumoTotalParcialesHoy) ).toFixed(6)
      }

      for(x=0; x<elementosConsumoTramosHoy.length; x++){            
          document.getElementById("trTramoP"+(x+1)+"CompradaHoy").className = document.getElementById("trTramoP"+(x+1)+"CompradaHoy").className.replaceAll(" hidden", "")
          document.getElementById("spanP"+(x+1)+"CompradaEnergiaHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(parseFloat(elementosConsumoTramosHoy[x])/1000).toFixed(2)) + " kWh"
          document.getElementById("spanP"+(x+1)+"CompradaValorHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat( porcentajesPorTramoHoy[x] * 100).toFixed(0)) + " %"
      }

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){ //CONECTADO Y CON PLACAS SOLARES

        if(jsonObjRespuestaDashboard.FVData.SolarWallet === undefined){
          jsonObjRespuestaDashboard.FVData.SolarWallet = "false"
        }

        if(jsonObjRespuestaDashboard.FVData.SolarWallet === "true"){
          document.getElementById("widgetDashboardMonedero"+idInstalacion).className = document.getElementById("widgetDashboardMonedero"+idInstalacion).className.replaceAll(" hidden", "")
          document.getElementById("widgetConsumoEnergia"+idInstalacion).className = document.getElementById("widgetConsumoEnergia"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
          //document.getElementById("lineaLinkAutoconsumo"+idInstalacion).className = document.getElementById("lineaLinkAutoconsumo"+idInstalacion).className.replaceAll(" hidden", "")
          document.getElementById("valorlineaLinkAutoconsumo"+idInstalacion).innerHTML = document.getElementById("scoringInstalacionEficiencia"+idInstalacion).innerHTML            
        }
        else{
          document.getElementById("widgetDashboardMonedero"+idInstalacion).className = document.getElementById("widgetDashboardMonedero"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("widgetConsumoEnergia"+idInstalacion).className = document.getElementById("widgetConsumoEnergia"+idInstalacion).className.replaceAll(" hidden", "")
          //document.getElementById("lineaLinkAutoconsumo"+idInstalacion).className = document.getElementById("lineaLinkAutoconsumo"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
        }

        document.getElementById("valorHoyEnergiaVendida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyRevenue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyRevenue.Unit     
        
        var mediaHoy = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyRevenue.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodaytoGrid.Value)).toFixed(3)     
        var mediaPreciosVentaHoy = parseFloat(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.DailyAverageSellPrice).toFixed(3)     

        if(isNaN(mediaHoy)){ mediaHoy = 0 }

        document.getElementById("valorFVSellPrice").innerHTML = "Media: " + new Intl.NumberFormat('en-DE').format(mediaHoy) + " €/kWh"                
        document.getElementById("valorFVSellPriceAvgHoy").className = document.getElementById("valorFVSellPriceAvgHoy").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("valorFVSellPriceAvgHoy").innerHTML =  "Media: " + mediaHoy + " €/kWh"                

        document.getElementById("valorFVDailyAverageSellPrice").className = document.getElementById("valorFVDailyAverageSellPrice").className.replaceAll(" hidden", "")
        document.getElementById("valorFVDailyAverageSellPrice").innerHTML = new Intl.NumberFormat('en-DE').format(mediaPreciosVentaHoy) + " €/kWh"                
        
        if(jsonObjRespuestaDashboard.FVData.EnergySellPrice.Value !== ""){          
          document.getElementById("valorVentaAhoraDashboard"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.FVData.EnergySellPrice.Value).toFixed(3)) + " " + jsonObjRespuestaDashboard.FVData.EnergySellPrice.Unit + "/kWh"          
        }
        else{          
          document.getElementById("valorVentaAhoraDashboard"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.FVData.DailyEnergySellPrice.Value).toFixed(3)) + " " + jsonObjRespuestaDashboard.FVData.DailyEnergySellPrice.Unit          
        }

      }
      else{          
        document.getElementById("valorFVSellPrice").className = document.getElementById("valorFVSellPrice").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("valorFVSellPriceAvgHoy").className = document.getElementById("valorFVSellPriceAvgHoy").className.replaceAll(" hidden", "") + " hidden" 
        document.getElementById("valorFVDailyAverageSellPrice").className = document.getElementById("valorFVDailyAverageSellPrice").className.replaceAll(" hidden", "") + " hidden"         
      }
      
      try{
        document.getElementById("importeIVAHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.IVA.Value).toFixed(2)) + " €"        
      }
      catch(error){
        console.log(error)
        document.getElementById("importeIVAHoy").innerHTML = "0 €"
      }

      var etiquetaFacturaHoy = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodaysavingsBalance.Value).toFixed(2))        
      document.getElementById("textoPestañaFacturaHoy").innerHTML = "Tu factura ha aumentado en " 
      
      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){
        if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayGivenAwayMoney.Value > 0){            
          if(jsonObjRespuestaDashboard.FVData.SolarWallet === "true"){               
            document.getElementById("textoPestañaFacturaHoy").innerHTML = "Ganados "               
            etiquetaFacturaHoy = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayGivenAwayMoney.Value).toFixed(2))
          }            
        }
      }

      document.getElementById("valorPestañaFacturaHoy").innerHTML = etiquetaFacturaHoy + " €"    
      document.getElementById("valorPestañaFacturaHoy").innerHTML = document.getElementById("valorPestañaFacturaHoy").innerHTML.replaceAll("-","")
      
      // Descuentos
      if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount !== ""){
        document.getElementById("etiquetaTotalCompraventaYDescuentosHoy").innerHTML = "Consumo, excedente y descuentos"      
        document.getElementById("divDescuentosHoy").className = document.getElementById("divDescuentosHoy").className.replaceAll(" hidden", "")
        document.getElementById("porcentajeHoyDescuento").innerHTML = jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount + " %"
        document.getElementById("valorHoyDescuento").innerHTML =  new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayDiscountValue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayDiscountValue.Unit
      }
      else{
        document.getElementById("etiquetaTotalCompraventaYDescuentosHoy").innerHTML = "Consumo y excedente"      
        document.getElementById("divDescuentosHoy").className = document.getElementById("divDescuentosHoy").className.replaceAll(" hidden", "") + " hidden"
      }

      // Muestro los gastos Fijos

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.ContractedPower !== undefined){
        document.getElementById("trGastosFijosPotenciaHoy").className = document.getElementById("trGastosFijosPotenciaHoy").className.replaceAll(" hidden", "")          
        document.getElementById("valorHoyPotenciaContratada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.ContractedPower.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.ContractedPower.Unit          
      }
      else{
        document.getElementById("trGastosFijosPotenciaHoy").className = document.getElementById("trGastosFijosPotenciaHoy").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.EquipmentHiring !== undefined){
        document.getElementById("trGastosFijosAlquilerEquiposHoy").className = document.getElementById("trGastosFijosAlquilerEquiposHoy").className.replaceAll(" hidden", "")          
        document.getElementById("valorHoyEquiposMedicion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.EquipmentHiring.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.EquipmentHiring.Unit          
      }
      else{
        document.getElementById("trGastosFijosAlquilerEquiposHoy").className = document.getElementById("trGastosFijosAlquilerEquiposHoy").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.SolarWallet !== undefined){
        document.getElementById("trGastosFijosMonederoSolarHoy").className = document.getElementById("trGastosFijosMonederoSolarHoy").className.replaceAll(" hidden", "")          
        document.getElementById("valorHoyMonederoSolar").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.SolarWallet.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.SolarWallet.Unit          
      }
      else{
        document.getElementById("trGastosFijosMonederoSolarHoy").className = document.getElementById("trGastosFijosMonederoSolarHoy").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.SocialBonus !== undefined){
        document.getElementById("trGastosFijosBonoSocialHoy").className = document.getElementById("trGastosFijosBonoSocialHoy").className.replaceAll(" hidden", "")          
        document.getElementById("valorHoyBonoSocial").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.SocialBonus.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.SocialBonus.Unit          
      }
      else{
        document.getElementById("trGastosFijosBonoSocialHoy").className = document.getElementById("trGastosFijosBonoSocialHoy").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.ElectricityTax !== undefined){
        document.getElementById("trGastosFijosImpuestoElectricidadHoy").className = document.getElementById("trGastosFijosImpuestoElectricidadHoy").className.replaceAll(" hidden", "")          
        document.getElementById("valorHoyImpuestoElectricidad").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.ElectricityTax.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments.ElectricityTax.Unit          
      }
      else{
        document.getElementById("trGastosFijosImpuestoElectricidadHoy").className = document.getElementById("trGastosFijosImpuestoElectricidadHoy").className.replaceAll(" hidden", "") + " hidden"
      }

      // Alerta reactiva
      if(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayPercentageReactive.Value).toFixed(2) >= 33.00){                        
        document.getElementById("valorHoyPorcentajeReactiva").className = document.getElementById("valorHoyPorcentajeReactiva").className.replaceAll(" error", "") + " error"
      }
      else{ document.getElementById("valorHoyPorcentajeReactiva").className = document.getElementById("valorHoyPorcentajeReactiva").className.replaceAll(" error", "") }

      //Calculo el total de COMPRAVENTA Y DESCUENTOS
      var totalCompraventaYDescuentosHoy = 0.00

      totalCompraventaYDescuentosHoy = totalCompraventaYDescuentosHoy + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyWaste.Value) //Comprada HOY
      totalCompraventaYDescuentosHoy = totalCompraventaYDescuentosHoy + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayenergyRevenue.Value) // Vendida HOY
      totalCompraventaYDescuentosHoy = totalCompraventaYDescuentosHoy + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayDiscountValue.Value) // Descuentos HOY

      document.getElementById("totalCompraventaYDescuentosHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalCompraventaYDescuentosHoy).toFixed(2)) + " €"                

      // Calculo el total de GASTOS Y PENALIZACIONES

      var totalGastosYPenalizacionesHoy = 0.00
      var tempValue = ""

      for(x=0; x < Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments).length; x++ ){

        tempValue = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments

        tempValue = parseFloat(tempValue[Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayFixedPayments)[x]].Value)
        totalGastosYPenalizacionesHoy = totalGastosYPenalizacionesHoy + tempValue
      }

      var valorPenalizacionExcesoPotenciaHoy = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayPowerExcessesPenalty.Value)
      var valorPenalizacionReactivaHoy = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayReactivePenaltyAmount.Value)
      totalGastosYPenalizacionesHoy = totalGastosYPenalizacionesHoy + valorPenalizacionExcesoPotenciaHoy + valorPenalizacionReactivaHoy

      document.getElementById("totalGastosYPenalizacionesHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalGastosYPenalizacionesHoy).toFixed(2)) + "€"        

      //Pestaña autoconsumo
      document.getElementById("textoLabelAutoconsumoHoy").innerHTML = "Ahorro que no verás en la factura"
      
      //* ************************************************************************************************************************************************************************************** */
      // [ MES ]: VALORES, LITERALES Y COLORES
      //* ************************************************************************************************************************************************************************************** */
      
      //Pestaña factura

      document.getElementById("valorMesTomadaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Value, 0) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Unit
      document.getElementById("valorMesDevueltaARed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthtoGrid.Value, 0) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthtoGrid.Unit                
      document.getElementById("valorMesPorcentajeReactiva").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPercentageReactive.Value).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPercentageReactive.Unit                
      document.getElementById("valorImportePenalizacionReactivaMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthReactivePenaltyAmount.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthReactivePenaltyAmount.Unit                        
      document.getElementById("valorContadorExcesosPotenciaMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPowerExcessesCount).toFixed(0))
      document.getElementById("valorImportePenalizacionExcesosPotenciaMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPowerExcessesPenalty.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPowerExcessesPenalty.Unit                        

      if(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Value).toFixed(2) !== "0.00"){
        jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Value = (jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Value * -1).toString()
      }
      document.getElementById("valorMesEnergiaComprada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Unit      

      //PRECIOS
      var mediaCompraMes = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Value)).toFixed(3)     
      
      if(isNaN(mediaCompraMes)){ mediaCompraMes = 0 }

      if(mediaCompraMes < 0){ mediaCompraMes = mediaCompraMes * -1}
      document.getElementById("valorFVBuyPriceAvgMes").innerHTML =  "Media: " + new Intl.NumberFormat('en-DE').format(mediaCompraMes) + " €/kWh"   

      var elementosConsumoTramosMes = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGridPerTimeframe.split("#")
      
      if(elementosConsumoTramosMes.length === 3){
        document.getElementById("spanP1Mes").innerHTML = "P1 : Punta"
        document.getElementById("spanP2Mes").innerHTML = "P2 : Llano"
        document.getElementById("spanP3Mes").innerHTML = "P3 : Valle"
      }

      document.getElementById("trTramoP1CompradaMes").className = document.getElementById("trTramoP1CompradaMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP2CompradaMes").className = document.getElementById("trTramoP2CompradaMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP3CompradaMes").className = document.getElementById("trTramoP3CompradaMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP4CompradaMes").className = document.getElementById("trTramoP4CompradaMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP5CompradaMes").className = document.getElementById("trTramoP5CompradaMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP6CompradaMes").className = document.getElementById("trTramoP6CompradaMes").className.replaceAll(" hidden", "") + " hidden"

      //Calculos los consumos por P por porcentaje

      var consumoTotalParcialesMes = 0
      for(x=0; x<elementosConsumoTramosMes.length; x++){            
        consumoTotalParcialesMes = consumoTotalParcialesMes + parseFloat(elementosConsumoTramosMes[x])
      }

      var porcentajesPorTramoMes = []
      for(x=0; x<elementosConsumoTramosMes.length; x++){            
        porcentajesPorTramoMes[x] = parseFloat( parseFloat(elementosConsumoTramosMes[x]) / parseFloat(consumoTotalParcialesMes) ).toFixed(6)
      }

      var consumoEnergiaPTempMes = 0
      for(x=0; x<elementosConsumoTramosMes.length; x++){            
          document.getElementById("trTramoP"+(x+1)+"CompradaMes").className = document.getElementById("trTramoP"+(x+1)+"CompradaMes").className.replaceAll(" hidden", "")
          consumoEnergiaPTempMes = (parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Value) / 1000)  * parseFloat(porcentajesPorTramoMes[x])
          document.getElementById("spanP"+(x+1)+"CompradaEnergiaMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(consumoEnergiaPTempMes).toFixed(0)) + " kWh"
          document.getElementById("spanP"+(x+1)+"CompradaValorMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat( porcentajesPorTramoMes[x] * 100).toFixed(0)) + " %"
      }

      
      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){
        document.getElementById("valorMesEnergiaVendida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyRevenue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyRevenue.Unit                                
        document.getElementById("valorFVSellPriceAvgMes").className = document.getElementById("valorFVSellPriceAvgMes").className.replaceAll(" hidden", "")         
        var mediaMes = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyRevenue.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthtoGrid.Value)).toFixed(3)     
        if(isNaN(mediaMes)){ mediaMes = 0 }
        document.getElementById("valorFVSellPriceAvgMes").innerHTML =  "Media: " + new Intl.NumberFormat('en-DE').format(mediaMes) + " €/kWh"   
      }
      else{          
        document.getElementById("valorFVSellPriceAvgMes").className = document.getElementById("valorFVSellPriceAvgMes").className.replaceAll(" hidden", "") + " hidden" 
      }

      document.getElementById("importeIVAMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.IVA.Value).toFixed(2)) + " €"        
            
      var etiquetaFacturaMes = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthsavingsBalance.Value).toFixed(2)

      var fechaInicioFacturacion = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.BillingStartDate

      var diaInicioFacturacion = fechaInicioFacturacion.split("/")[0]
      var numeroMesFacturacion = fechaInicioFacturacion.split("/")[1]
      var mesInicioFacturacion = module.exports.obtenerNombreMes(numeroMesFacturacion)

      //Corijo los literales de textoPestañaFacturaMes en base a la lógica de Helias
      if(parseInt(numeroMesFacturacion) === 2){
        //Estoy en febrero
        if(parseInt(diaInicioFacturacion) > 28){
          if(generalCommonJS.esAñoBisiesto(new Date().getFullYear())){ diaInicioFacturacion = "29" }
          else{ diaInicioFacturacion = "28" }
        }
      }
      else if( (parseInt(numeroMesFacturacion) === 4) || (parseInt(numeroMesFacturacion) === 6) || (parseInt(numeroMesFacturacion) === 9) || (parseInt(numeroMesFacturacion) === 11) ){
        if(parseInt(diaInicioFacturacion) > 30){ diaInicioFacturacion = "30" }
      }
      
      document.getElementById("textoPestañaFacturaMes").innerHTML = "Desde el <strong>" + diaInicioFacturacion + " de " + mesInicioFacturacion + "</strong> tu factura te sale a pagar " 

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){
        if( (jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Value > 0) && (jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthsavingsBalance.Value >= 0) ){            
          if(jsonObjRespuestaDashboard.FVData.SolarWallet === "true"){               
            document.getElementById("textoPestañaFacturaMes").innerHTML = "Desde el <strong>" + diaInicioFacturacion + " de " + mesInicioFacturacion + "</strong> llevas ganados "                             
            etiquetaFacturaMes = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Value).toFixed(2)
          }          
        }
      }

      document.getElementById("valorPestañaFacturaMes").innerHTML = new Intl.NumberFormat('en-DE').format(etiquetaFacturaMes) + " €"   
      document.getElementById("valorPestañaFacturaMes").innerHTML = document.getElementById("valorPestañaFacturaMes").innerHTML.replaceAll("-","")

      //Gestiono el mensaje de "regalando dinero"

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){
        if(jsonObjRespuestaDashboard.FVData.SolarWallet === "false"){     

          document.getElementById("trMonederoSolarMes").className = document.getElementById("trMonederoSolarMes").className.replaceAll(" hidden", "") + " hidden"

          if(parseInt(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Value) > 0){

            var mensajeBase = "Si vendes más € que consumes tu compañía no te lo va a pagar, sólo te descuenta de lo que hayas consumido, no más... Así que "
            var mensajeAdaptado = ""

            document.getElementById("trAvisoRegalandoDineroMes").className = document.getElementById("trAvisoRegalandoDineroMes").className.replaceAll(" hidden", "")
            mensajeAdaptado = "este mes le llevas regalado a tu compañía eléctrica <strong>"
            document.getElementById("mensajeExcesoVolcadoMes").innerHTML = mensajeBase+mensajeAdaptado+new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Value).toFixed(2))+jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Unit+"</strong>."      

            //Y si le estoy regalando hoy dinero le muestro la alerta visual en el dashboard            
            if(!document.getElementById("figureAhorroGasto"+idInstalacion).className.includes("blink")){ // Si ya está parpadeando no hago nada              
              document.getElementById("figureAhorroGasto"+idInstalacion).className = "avatar size-l orange blink"
              setTimeout(() => {try{document.getElementById("figureAhorroGasto"+idInstalacion).className = estadoActualfigureAhorroGasto} catch (error) {console.log(error)} },3000);	
            }            

          }
          else{
            document.getElementById("trAvisoRegalandoDineroMes").className = document.getElementById("trAvisoRegalandoDineroMes").className.replaceAll(" hidden", "") + " hidden"
          }
        }
        else{
          
          var totalMonederoAhora = 0
          try{
            totalMonederoAhora = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentSolarWalletBalance.Value)
          }
          catch(error){
            console.log(error)
            totalMonederoAhora = parseFloat("0")
          }
          var scoringMesActivacion = 0
          
          if(jsonObjRespuestaDashboard.FVData.SolarWalletActivationDate !== undefined){                          
            scoringMesActivacion =  parseFloat(scoringAhorro)
          }

          document.getElementById("totalBalanceMonederoSolarMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalMonederoAhora).toFixed(2)) + " €"          
          document.getElementById("trAvisoRegalandoDineroMes").className = document.getElementById("trAvisoRegalandoDineroMes").className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("scoringMonederoBaterias"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalMonederoAhora).toFixed(2)) + " €"      
          
          if (scoringAhorro.toString() === "0.00"){
            document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(scoringMesActivacion).toFixed(0).replaceAll("-","")) + " €"
          }
          else{
            document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(scoringMesActivacion).toFixed(2).replaceAll("-","")) + " €"
          }
          
        }
      }
      else{
        document.getElementById("trAvisoRegalandoDineroMes").className = document.getElementById("trAvisoRegalandoDineroMes").className.replaceAll(" hidden", "") + " hidden"
      }

      // Descuentos
      if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount !== ""){
        document.getElementById("etiquetaTotalCompraventaYDescuentosMes").innerHTML = "Consumo, excedente y descuentos"
        document.getElementById("divDescuentosMes").className = document.getElementById("divDescuentosMes").className.replaceAll(" hidden", "")
        document.getElementById("porcentajeMesDescuento").innerHTML = jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount + " %"
        document.getElementById("valorMesDescuento").innerHTML =  new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthDiscountValue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthDiscountValue.Unit
      }
      else{
        document.getElementById("etiquetaTotalCompraventaYDescuentosMes").innerHTML = "Consumo y excedente"
        document.getElementById("divDescuentosMes").className = document.getElementById("divDescuentosMes").className.replaceAll(" hidden", "") + " hidden"
      }

      // Muestro los gastos Fijos

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.ContractedPower !== undefined){
        document.getElementById("trGastosFijosPotenciaMes").className = document.getElementById("trGastosFijosPotenciaMes").className.replaceAll(" hidden", "")          
        document.getElementById("valorMesPotenciaContratada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.ContractedPower.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.ContractedPower.Unit          
      }
      else{
        document.getElementById("trGastosFijosPotenciaMes").className = document.getElementById("trGastosFijosPotenciaMes").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.EquipmentHiring !== undefined){
        document.getElementById("trGastosFijosAlquilerEquiposMes").className = document.getElementById("trGastosFijosAlquilerEquiposMes").className.replaceAll(" hidden", "")          
        document.getElementById("valorMesEquiposMedicion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.EquipmentHiring.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.EquipmentHiring.Unit          
      }
      else{
        document.getElementById("trGastosFijosAlquilerEquiposMes").className = document.getElementById("trGastosFijosAlquilerEquiposMes").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.SolarWallet !== undefined){
        document.getElementById("trGastosFijosMonederoSolarMes").className = document.getElementById("trGastosFijosMonederoSolarMes").className.replaceAll(" hidden", "")          
        document.getElementById("valorMesMonederoSolar").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.SolarWallet.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.SolarWallet.Unit          
      }
      else{
        document.getElementById("trGastosFijosMonederoSolarMes").className = document.getElementById("trGastosFijosMonederoSolarMes").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.SocialBonus !== undefined){
        document.getElementById("trGastosFijosBonoSocialMes").className = document.getElementById("trGastosFijosBonoSocialMes").className.replaceAll(" hidden", "")          
        document.getElementById("valorMesBonoSocial").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.SocialBonus.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.SocialBonus.Unit          
      }
      else{
        document.getElementById("trGastosFijosBonoSocialMes").className = document.getElementById("trGastosFijosBonoSocialMes").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.ElectricityTax !== undefined){
        document.getElementById("trGastosFijosImpuestoElectricidadMes").className = document.getElementById("trGastosFijosImpuestoElectricidadMes").className.replaceAll(" hidden", "")          
        document.getElementById("valorMesImpuestoElectricidad").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.ElectricityTax.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments.ElectricityTax.Unit          
      }
      else{
        document.getElementById("trGastosFijosImpuestoElectricidadMes").className = document.getElementById("trGastosFijosImpuestoElectricidadMes").className.replaceAll(" hidden", "") + " hidden"
      }

      // Alerta reactiva
      if(parseInt(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPercentageReactive.Value).toFixed(2) >= 33.00){   
        
        document.getElementById("valorMesPorcentajeReactiva").className = document.getElementById("valorMesPorcentajeReactiva").className.replaceAll(" error", "") + " error"
        
        if(!document.getElementById("figureAhorroGasto"+idInstalacion).className.includes("blink")){ // Si ya está parpadeando no hago nada
          document.getElementById("figureAhorroGasto"+idInstalacion).className = "avatar size-l orange blink"          
          setTimeout(() => {try{document.getElementById("figureAhorroGasto"+idInstalacion).className = estadoActualfigureAhorroGasto} catch (error) {console.error(error);} },3000);	                              
        }
      }
      else{ 
        document.getElementById("valorMesPorcentajeReactiva").className = document.getElementById("valorMesPorcentajeReactiva").className.replaceAll(" error", "")           
      }

      // Alerta penalización por exceso de potencia
      if(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthReactivePenaltyAmount.Value).toFixed(2) !== "0.00"){          
        if(!document.getElementById("figureAhorroGasto"+idInstalacion).className.includes("blink")){ // Si ya está parpadeando no hago nada
          document.getElementById("figureAhorroGasto"+idInstalacion).className = "avatar size-l orange blink"          
          setTimeout(() => {try{document.getElementById("figureAhorroGasto"+idInstalacion).className = estadoActualfigureAhorroGasto} catch (error) {console.error(error);} },3000);	                              
        }
      }

      //Calculo el total de COMPRAVENTA Y DESCUENTOS
      var totalCompraventaYDescuentosMes = 0.00

      totalCompraventaYDescuentosMes = totalCompraventaYDescuentosMes + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Value) //Comprada HOY
      totalCompraventaYDescuentosMes = totalCompraventaYDescuentosMes + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthenergyRevenue.Value) // Vendida HOY
      totalCompraventaYDescuentosMes = totalCompraventaYDescuentosMes + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthDiscountValue.Value) // Descuentos HOY

      document.getElementById("totalCompraventaYDescuentosMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalCompraventaYDescuentosMes).toFixed(2)) + " €"        

      // Calculo el total de GASTOS Y PENALIZACIONES

      var totalGastosYPenalizacionesMes = 0.00
      tempValue = ""

      for(x=0; x < Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments).length; x++ ){

        tempValue = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments

        tempValue = parseFloat(tempValue[Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthFixedPayments)[x]].Value)
        totalGastosYPenalizacionesMes = totalGastosYPenalizacionesMes + tempValue
      }

      var valorPenalizacionExcesoPotenciaMes = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPowerExcessesPenalty.Value)
      var valorPenalizacionReactivaMes = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthReactivePenaltyAmount.Value)
      totalGastosYPenalizacionesMes = totalGastosYPenalizacionesMes + valorPenalizacionExcesoPotenciaMes + valorPenalizacionReactivaMes

      document.getElementById("totalGastosYPenalizacionesMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalGastosYPenalizacionesMes).toFixed(2)) + "€"        

      //Pestaña autoconsumo
      document.getElementById("textoLabelAutoconsumoMes").innerHTML = "Ahorro que no verás en la factura"
      
      //* ************************************************************************************************************************************************************************************** */
      // [ AÑO ]: VALORES, LITERALES Y COLORES
      //* ************************************************************************************************************************************************************************************** */
      
      //Pestaña factura                
      document.getElementById("valorAñoTomadaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearfromGrid.Value, 0) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearfromGrid.Unit
      document.getElementById("valorAñoDevueltaARed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YeartoGrid.Value, 0) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YeartoGrid.Unit                
      document.getElementById("valorAñoPorcentajeReactiva").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearPercentageReactive.Value).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearPercentageReactive.Unit                
      document.getElementById("valorImportePenalizacionReactivaAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearReactivePenaltyAmount.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearReactivePenaltyAmount.Unit                        
      document.getElementById("valorContadorExcesosPotenciaAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearPowerExcessesCount).toFixed(0))
      document.getElementById("valorImportePenalizacionExcesosPotenciaAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearPowerExcessesPenalty.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearPowerExcessesPenalty.Unit                        

      if(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyWaste.Value).toFixed(2) !== "0.00"){
        jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyWaste.Value = (jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyWaste.Value * -1).toString()
      }
      document.getElementById("valorAñoEnergiaComprada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyWaste.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyWaste.Unit      

      //PRECIOS
      var mediaCompraAño = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyWaste.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearfromGrid.Value)).toFixed(3)     
      if(mediaCompraAño < 0){ mediaCompraAño = mediaCompraAño * -1}
      if(isNaN(mediaCompraAño)){ mediaCompraAño = 0 }
      document.getElementById("valorFVBuyPriceAvgAño").innerHTML =  "Media: " + new Intl.NumberFormat('en-DE').format(mediaCompraAño) + " €/kWh"   
      
      var elementosConsumoTramosAño = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearfromGridPerTimeframe.split("#")
      
      if(elementosConsumoTramosAño.length === 3){
        document.getElementById("spanP1Año").innerHTML = "P1 : Punta"
        document.getElementById("spanP2Año").innerHTML = "P2 : Llano"
        document.getElementById("spanP3Año").innerHTML = "P3 : Valle"
      }

      document.getElementById("trTramoP1CompradaAño").className = document.getElementById("trTramoP1CompradaAño").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP2CompradaAño").className = document.getElementById("trTramoP2CompradaAño").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP3CompradaAño").className = document.getElementById("trTramoP3CompradaAño").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP4CompradaAño").className = document.getElementById("trTramoP4CompradaAño").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP5CompradaAño").className = document.getElementById("trTramoP5CompradaAño").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP6CompradaAño").className = document.getElementById("trTramoP6CompradaAño").className.replaceAll(" hidden", "") + " hidden"

      //Calculos los consumos por P por porcentaje

      var consumoTotalParcialesAño = 0
      for(x=0; x<elementosConsumoTramosAño.length; x++){            
        consumoTotalParcialesAño = consumoTotalParcialesAño + parseFloat(elementosConsumoTramosAño[x])
      }

      var porcentajesPorTramoAño = []
      for(x=0; x<elementosConsumoTramosAño.length; x++){            
        porcentajesPorTramoAño[x] = parseFloat( parseFloat(elementosConsumoTramosAño[x]) / parseFloat(consumoTotalParcialesAño) ).toFixed(6)
      }

      var consumoEnergiaPTempAño = 0
      for(x=0; x<elementosConsumoTramosAño.length; x++){            
          document.getElementById("trTramoP"+(x+1)+"CompradaAño").className = document.getElementById("trTramoP"+(x+1)+"CompradaAño").className.replaceAll(" hidden", "")
          consumoEnergiaPTempAño = (parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearfromGrid.Value) / 1000)  * parseFloat(porcentajesPorTramoAño[x])
          document.getElementById("spanP"+(x+1)+"CompradaEnergiaAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(consumoEnergiaPTempAño).toFixed(0)) + " kWh"
          document.getElementById("spanP"+(x+1)+"CompradaValorAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat( porcentajesPorTramoAño[x] * 100 ).toFixed(0)) + " %"
      }

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){
        document.getElementById("valorAñoEnergiaVendida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyRevenue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyRevenue.Unit     
        document.getElementById("valorFVSellPriceAvgAño").className = document.getElementById("valorFVSellPriceAvgAño").className.replaceAll(" hidden", "")         
        var mediaAño = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyRevenue.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YeartoGrid.Value)).toFixed(3)     
        if(isNaN(mediaAño)){ mediaAño = 0 }
        document.getElementById("valorFVSellPriceAvgAño").innerHTML =  "Media: " + new Intl.NumberFormat('en-DE').format(mediaAño) + " €/kWh"   
      }
      else{          
        document.getElementById("valorFVSellPriceAvgAño").className = document.getElementById("valorFVSellPriceAvgAño").className.replaceAll(" hidden", "") + " hidden" 
      }

      document.getElementById("importeIVAAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.IVA.Value).toFixed(2)) + " €"        

      var etiquetaFacturaAño = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearsavingsBalance.Value).toFixed(2))
      document.getElementById("textoPestañaFacturaAño").innerHTML = "Tus facturas te han salido a pagar " 
      document.getElementById("valorPestañaFacturaAño").innerHTML = etiquetaFacturaAño + " €"   
      document.getElementById("valorPestañaFacturaAño").innerHTML = document.getElementById("valorPestañaFacturaAño").innerHTML.replaceAll("-","")
      
      // Descuentos
      if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount !== ""){
        document.getElementById("etiquetaTotalCompraventaYDescuentosAño").innerHTML = "Consumo, excedente y descuentos"
        document.getElementById("divDescuentosAño").className = document.getElementById("divDescuentosAño").className.replaceAll(" hidden", "")
        document.getElementById("porcentajeAñoDescuento").innerHTML = jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount + " %"
        document.getElementById("valorAñoDescuento").innerHTML =  new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearDiscountValue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearDiscountValue.Unit
      }
      else{
        document.getElementById("etiquetaTotalCompraventaYDescuentosAño").innerHTML = "Consumo y excedente"
        document.getElementById("divDescuentosAño").className = document.getElementById("divDescuentosAño").className.replaceAll(" hidden", "") + " hidden"
      }        

      // Muestro los gastos Fijos

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.ContractedPower !== undefined){
        document.getElementById("trGastosFijosPotenciaAño").className = document.getElementById("trGastosFijosPotenciaAño").className.replaceAll(" hidden", "")          
        document.getElementById("valorAñoPotenciaContratada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.ContractedPower.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.ContractedPower.Unit          
      }
      else{
        document.getElementById("trGastosFijosPotenciaAño").className = document.getElementById("trGastosFijosPotenciaAño").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.EquipmentHiring !== undefined){
        document.getElementById("trGastosFijosAlquilerEquiposAño").className = document.getElementById("trGastosFijosAlquilerEquiposAño").className.replaceAll(" hidden", "")          
        document.getElementById("valorAñoEquiposMedicion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.EquipmentHiring.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.EquipmentHiring.Unit          
      }
      else{
        document.getElementById("trGastosFijosAlquilerEquiposAño").className = document.getElementById("trGastosFijosAlquilerEquiposAño").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.SolarWallet !== undefined){
        document.getElementById("trGastosFijosMonederoSolarAño").className = document.getElementById("trGastosFijosMonederoSolarAño").className.replaceAll(" hidden", "")          
        document.getElementById("valorAñoMonederoSolar").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.SolarWallet.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.SolarWallet.Unit          
      }
      else{
        document.getElementById("trGastosFijosMonederoSolarAño").className = document.getElementById("trGastosFijosMonederoSolarAño").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.SocialBonus !== undefined){
        document.getElementById("trGastosFijosBonoSocialAño").className = document.getElementById("trGastosFijosBonoSocialAño").className.replaceAll(" hidden", "")          
        document.getElementById("valorAñoBonoSocial").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.SocialBonus.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.SocialBonus.Unit          
      }
      else{
        document.getElementById("trGastosFijosBonoSocialAño").className = document.getElementById("trGastosFijosBonoSocialAño").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.ElectricityTax !== undefined){
        document.getElementById("trGastosFijosImpuestoElectricidadAño").className = document.getElementById("trGastosFijosImpuestoElectricidadAño").className.replaceAll(" hidden", "")          
        document.getElementById("valorAñoImpuestoElectricidad").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.ElectricityTax.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments.ElectricityTax.Unit          
      }
      else{
        document.getElementById("trGastosFijosImpuestoElectricidadAño").className = document.getElementById("trGastosFijosImpuestoElectricidadAño").className.replaceAll(" hidden", "") + " hidden"
      }

      // Alerta reactiva
      if(parseInt(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearPercentageReactive.Value).toFixed(2) >= 33.00){
        document.getElementById("valorAñoPorcentajeReactiva").className = document.getElementById("valorAñoPorcentajeReactiva").className.replaceAll(" error", "") + " error"
      }
      else{ document.getElementById("valorAñoPorcentajeReactiva").className = document.getElementById("valorAñoPorcentajeReactiva").className.replaceAll(" error", "") }

      //Calculo el total de COMPRAVENTA Y DESCUENTOS
      var totalCompraventaYDescuentosAño = 0.00

      totalCompraventaYDescuentosAño = totalCompraventaYDescuentosAño + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyWaste.Value) //Comprada HOY
      totalCompraventaYDescuentosAño = totalCompraventaYDescuentosAño + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearenergyRevenue.Value) // Vendida HOY
      totalCompraventaYDescuentosAño = totalCompraventaYDescuentosAño + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearDiscountValue.Value) // Descuentos HOY

      document.getElementById("totalCompraventaYDescuentosAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalCompraventaYDescuentosAño).toFixed(2)) + " €"        

      // Calculo el total de GASTOS Y PENALIZACIONES

      var totalGastosYPenalizacionesAño = 0.00
      tempValue = ""

      for(x=0; x < Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments).length; x++ ){

        tempValue = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments

        tempValue = parseFloat(tempValue[Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearFixedPayments)[x]].Value)
        totalGastosYPenalizacionesAño = totalGastosYPenalizacionesAño + tempValue
      }

      var valorPenalizacionExcesoPotenciaAño = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearPowerExcessesPenalty.Value)
      var valorPenalizacionReactivaAño = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearReactivePenaltyAmount.Value)
      totalGastosYPenalizacionesAño = totalGastosYPenalizacionesAño + valorPenalizacionExcesoPotenciaAño + valorPenalizacionReactivaAño

      document.getElementById("totalGastosYPenalizacionesAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalGastosYPenalizacionesAño).toFixed(2)) + "€"        

      //Pestaña autoconsumo
      document.getElementById("textoLabelAutoconsumoAño").innerHTML = "Ahorro que no verás en la factura"
      
      //* ************************************************************************************************************************************************************************************** */
      // [ DESDE REGISTRO ]: VALORES, LITERALES Y COLORES
      //* ************************************************************************************************************************************************************************************** */
      
      //Pestaña factura        
      document.getElementById("valorDesdeRegistroTomadaDeRed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationfromGrid.Value, 0) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationfromGrid.Unit
      document.getElementById("valorDesdeRegistroDevueltaARed").innerHTML = module.exports.obtenerCantidadEnergiaDimensionadaFront(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationtoGrid.Value, 0) + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationtoGrid.Unit                
      document.getElementById("valorDesdeRegistroPorcentajeReactiva").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPercentageReactive.Value).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPercentageReactive.Unit                
      document.getElementById("valorImportePenalizacionReactivaDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationReactivePenaltyAmount.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationReactivePenaltyAmount.Unit                        
      document.getElementById("valorContadorExcesosPotenciaDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPowerExcessesCount).toFixed(0))
      document.getElementById("valorImportePenalizacionExcesosPotenciaDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPowerExcessesPenalty.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPowerExcessesPenalty.Unit                        

      if(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyWaste.Value).toFixed(2) !== "0.00"){
        jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyWaste.Value = (jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyWaste.Value * -1).toString()
      }
      document.getElementById("valorDesdeRegistroEnergiaComprada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyWaste.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyWaste.Unit           

      //PRECIOS
      var mediaCompraDesdeRegistro = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyWaste.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationfromGrid.Value)).toFixed(3)     
      if(mediaCompraDesdeRegistro < 0){ mediaCompraDesdeRegistro = mediaCompraDesdeRegistro * -1}
      if(isNaN(mediaCompraDesdeRegistro)){ mediaCompraDesdeRegistro = 0 }
      document.getElementById("valorFVBuyPriceAvgDesdeRegistro").innerHTML =  "Media: " + new Intl.NumberFormat('en-DE').format(mediaCompraDesdeRegistro) + " €/kWh"
      
      var elementosConsumoTramosDesdeRegistro = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationfromGridPerTimeframe.split("#")
      
      if(elementosConsumoTramosDesdeRegistro.length === 3){
        document.getElementById("spanP1DesdeRegistro").innerHTML = "P1 : Punta"
        document.getElementById("spanP2DesdeRegistro").innerHTML = "P2 : Llano"
        document.getElementById("spanP3DesdeRegistro").innerHTML = "P3 : Valle"
      }

      document.getElementById("trTramoP1CompradaDesdeRegistro").className = document.getElementById("trTramoP1CompradaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP2CompradaDesdeRegistro").className = document.getElementById("trTramoP2CompradaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP3CompradaDesdeRegistro").className = document.getElementById("trTramoP3CompradaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP4CompradaDesdeRegistro").className = document.getElementById("trTramoP4CompradaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP5CompradaDesdeRegistro").className = document.getElementById("trTramoP5CompradaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTramoP6CompradaDesdeRegistro").className = document.getElementById("trTramoP6CompradaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"

      //Calculos los consumos por P por porcentaje

      var consumoTotalParcialesDesdeRegistro = 0
      for(x=0; x<elementosConsumoTramosDesdeRegistro.length; x++){            
        consumoTotalParcialesDesdeRegistro = consumoTotalParcialesDesdeRegistro + parseFloat(elementosConsumoTramosDesdeRegistro[x])
      }

      var porcentajesPorTramoDesdeRegistro = []
      for(x=0; x<elementosConsumoTramosDesdeRegistro.length; x++){            
        porcentajesPorTramoDesdeRegistro[x] = parseFloat( parseFloat(elementosConsumoTramosDesdeRegistro[x]) / parseFloat(consumoTotalParcialesDesdeRegistro) ).toFixed(6)
      }

      var consumoEnergiaPTempDesdeRegistro = 0
      for(x=0; x<elementosConsumoTramosDesdeRegistro.length; x++){            
          document.getElementById("trTramoP"+(x+1)+"CompradaDesdeRegistro").className = document.getElementById("trTramoP"+(x+1)+"CompradaDesdeRegistro").className.replaceAll(" hidden", "")
          consumoEnergiaPTempDesdeRegistro = (parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationfromGrid.Value) / 1000)  * parseFloat(porcentajesPorTramoDesdeRegistro[x])
          document.getElementById("spanP"+(x+1)+"CompradaEnergiaDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(consumoEnergiaPTempDesdeRegistro).toFixed(0)) + " kWh"
          document.getElementById("spanP"+(x+1)+"CompradaValorDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat( porcentajesPorTramoDesdeRegistro[x] * 100 ).toFixed(0)) + " %"
      }

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){
        document.getElementById("valorDesdeRegistroEnergiaVendida").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyRevenue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyRevenue.Unit       
        document.getElementById("valorFVSellPriceAvgDesdeRegistro").className = document.getElementById("valorFVSellPriceAvgDesdeRegistro").className.replaceAll(" hidden", "")         
        var mediaDesdeRegistro = parseFloat((1000 * parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyRevenue.Value)) / parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationtoGrid.Value)).toFixed(3)     
        if(isNaN(mediaDesdeRegistro)){ mediaDesdeRegistro = 0 }
        document.getElementById("valorFVSellPriceAvgDesdeRegistro").innerHTML =  "Media: " + new Intl.NumberFormat('en-DE').format(mediaDesdeRegistro) + " €/kWh"   
      }
      else{          
        document.getElementById("valorFVSellPriceAvgDesdeRegistro").className = document.getElementById("valorFVSellPriceAvgDesdeRegistro").className.replaceAll(" hidden", "") + " hidden" 
      }

      document.getElementById("importeIVADesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.IVA.Value).toFixed(2)) + " €"        
      
      var etiquetaFacturaDesdeRegistro = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationsavingsBalance.Value).toFixed(2)
      document.getElementById("textoPestañaFacturaDesdeRegistro").innerHTML = "Tus facturas te han salido a pagar " 

      document.getElementById("valorPestañaFacturaDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(etiquetaFacturaDesdeRegistro) + " €"   
      document.getElementById("valorPestañaFacturaDesdeRegistro").innerHTML = document.getElementById("valorPestañaFacturaDesdeRegistro").innerHTML.replaceAll("-","")
      
      // Descuentos
      if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount !== ""){
        document.getElementById("etiquetaTotalCompraventaYDescuentosDesdeRegistro").innerHTML = "Consumo, excedente y descuentos"
        document.getElementById("divDescuentosDesdeRegistro").className = document.getElementById("divDescuentosDesdeRegistro").className.replaceAll(" hidden", "")
        document.getElementById("porcentajeDesdeRegistroDescuento").innerHTML = jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount + " %"
        document.getElementById("valorDesdeRegistroDescuento").innerHTML =  new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationDiscountValue.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationDiscountValue.Unit
      }
      else{
        document.getElementById("etiquetaTotalCompraventaYDescuentosDesdeRegistro").innerHTML = "Consumo y excedente"
        document.getElementById("divDescuentosDesdeRegistro").className = document.getElementById("divDescuentosDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      }

      // Muestro los gastos Fijos

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.ContractedPower !== undefined){
        document.getElementById("trGastosFijosPotenciaDesdeRegistro").className = document.getElementById("trGastosFijosPotenciaDesdeRegistro").className.replaceAll(" hidden", "")          
        document.getElementById("valorDesdeRegistroPotenciaContratada").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.ContractedPower.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.ContractedPower.Unit          
      }
      else{
        document.getElementById("trGastosFijosPotenciaDesdeRegistro").className = document.getElementById("trGastosFijosPotenciaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.EquipmentHiring !== undefined){
        document.getElementById("trGastosFijosAlquilerEquiposDesdeRegistro").className = document.getElementById("trGastosFijosAlquilerEquiposDesdeRegistro").className.replaceAll(" hidden", "")          
        document.getElementById("valorDesdeRegistroEquiposMedicion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.EquipmentHiring.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.EquipmentHiring.Unit          
      }
      else{
        document.getElementById("trGastosFijosAlquilerEquiposDesdeRegistro").className = document.getElementById("trGastosFijosAlquilerEquiposDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.SolarWallet !== undefined){
        document.getElementById("trGastosFijosMonederoSolarDesdeRegistro").className = document.getElementById("trGastosFijosMonederoSolarDesdeRegistro").className.replaceAll(" hidden", "")          
        document.getElementById("valorDesdeRegistroMonederoSolar").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.SolarWallet.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.SolarWallet.Unit          
      }
      else{
        document.getElementById("trGastosFijosMonederoSolarDesdeRegistro").className = document.getElementById("trGastosFijosMonederoSolarDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.SocialBonus !== undefined){
        document.getElementById("trGastosFijosBonoSocialDesdeRegistro").className = document.getElementById("trGastosFijosBonoSocialDesdeRegistro").className.replaceAll(" hidden", "")          
        document.getElementById("valorDesdeRegistroBonoSocial").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.SocialBonus.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.SocialBonus.Unit          
      }
      else{
        document.getElementById("trGastosFijosBonoSocialDesdeRegistro").className = document.getElementById("trGastosFijosBonoSocialDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      }

      if(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.ElectricityTax !== undefined){
        document.getElementById("trGastosFijosImpuestoElectricidadDesdeRegistro").className = document.getElementById("trGastosFijosImpuestoElectricidadDesdeRegistro").className.replaceAll(" hidden", "")          
        document.getElementById("valorDesdeRegistroImpuestoElectricidad").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.ElectricityTax.Value).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments.ElectricityTax.Unit          
      }
      else{
        document.getElementById("trGastosFijosImpuestoElectricidadDesdeRegistro").className = document.getElementById("trGastosFijosImpuestoElectricidadDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      }
      
      // Alerta reactiva
      if(parseInt(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPercentageReactive.Value).toFixed(2) >= 33.00){
        document.getElementById("valorDesdeRegistroPorcentajeReactiva").className = document.getElementById("valorDesdeRegistroPorcentajeReactiva").className.replaceAll(" error", "") + " error"
      }
      else{ document.getElementById("valorDesdeRegistroPorcentajeReactiva").className = document.getElementById("valorDesdeRegistroPorcentajeReactiva").className.replaceAll(" error", "") }

      //Calculo el total de COMPRAVENTA Y DESCUENTOS
      var totalCompraventaYDescuentosDesdeRegistro = 0.00

      totalCompraventaYDescuentosDesdeRegistro = totalCompraventaYDescuentosDesdeRegistro + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyWaste.Value) //Comprada HOY
      totalCompraventaYDescuentosDesdeRegistro = totalCompraventaYDescuentosDesdeRegistro + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationenergyRevenue.Value) // Vendida HOY
      totalCompraventaYDescuentosDesdeRegistro = totalCompraventaYDescuentosDesdeRegistro + parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationDiscountValue.Value) // Descuentos HOY

      document.getElementById("totalCompraventaYDescuentosDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalCompraventaYDescuentosDesdeRegistro).toFixed(2)) + " €"        

      // Calculo el total de GASTOS Y PENALIZACIONES

      var totalGastosYPenalizacionesDesdeRegistro = 0.00
      tempValue = ""

      for(x=0; x < Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments).length; x++ ){

        tempValue = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments

        tempValue = parseFloat(tempValue[Object.keys(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationFixedPayments)[x]].Value)
        totalGastosYPenalizacionesDesdeRegistro = totalGastosYPenalizacionesDesdeRegistro + tempValue
      }

      var valorPenalizacionExcesoPotenciaDesdeRegistro = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPowerExcessesPenalty.Value)
      var valorPenalizacionReactivaDesdeRegistro = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationReactivePenaltyAmount.Value)
      totalGastosYPenalizacionesDesdeRegistro = totalGastosYPenalizacionesDesdeRegistro + valorPenalizacionExcesoPotenciaDesdeRegistro + valorPenalizacionReactivaDesdeRegistro

      document.getElementById("totalGastosYPenalizacionesDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalGastosYPenalizacionesDesdeRegistro).toFixed(2)) + "€"        
      
      //Pestaña autoconsumo
      document.getElementById("textoLabelAutoconsumoDesdeRegistro").innerHTML = "Ahorro que no verás en la factura"

      //* ************************************************************************************************************************************************************************************** */
      // [ CASUISTICAS ESPECIALES CONECTADAS A LA RED] 
      //* ************************************************************************************************************************************************************************************** */

      // CONECTADA A RED - SIN AUTOCONSUMO (FV)
      if(Object.keys(jsonObjRespuestaDashboard.FVData).length === 0){
      
        if(jsonObjRespuestaDashboard.InstallationData.GeneralInfo.BillDiscount !== ""){
          document.getElementById("etiquetaTotalCompraventaYDescuentosHoy").innerHTML = "Consumo y descuentos"
          document.getElementById("etiquetaTotalCompraventaYDescuentosMes").innerHTML = "Consumo y descuentos"
          document.getElementById("etiquetaTotalCompraventaYDescuentosAño").innerHTML = "Consumo y descuentos"
          document.getElementById("etiquetaTotalCompraventaYDescuentosDesdeRegistro").innerHTML = "Consumo y descuentos"
        }
        else{
          document.getElementById("etiquetaTotalCompraventaYDescuentosHoy").innerHTML = "Consumo"
          document.getElementById("etiquetaTotalCompraventaYDescuentosMes").innerHTML = "Consumo"
          document.getElementById("etiquetaTotalCompraventaYDescuentosAño").innerHTML = "Consumo"
          document.getElementById("etiquetaTotalCompraventaYDescuentosDesdeRegistro").innerHTML = "Consumo"
        }

        document.getElementById("figureAutoconsumo"+idInstalacion).className = "avatar size-l cyan"
        document.getElementById("figureAhorroGasto"+idInstalacion).className = "avatar size-l cyan"
        document.getElementById("literalAutoconsumo"+idInstalacion).innerHTML = "Consumo mes"

        //Ahora controlo la reutilización del componente de monedero para el MONEDERO DE BONIFICACIONES SIN FV
        var totalMonederoBonificaciones = 0
        try{
          totalMonederoBonificaciones = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentSolarWalletBalance.Value)
        }
        catch(error){
          console.log(error)
          totalMonederoBonificaciones = parseFloat("0")
        }

        document.getElementById("literalMonederoBaterias").innerHTML = "Bonificaciones"        
        document.getElementById("literalWidgetEconomiaMonedero").innerHTML = "Bonificaciones"    
        document.getElementById("literalFechaFinFacturaMonedero").innerHTML = "Fecha"         
        document.getElementById("literalSaldoWidgetMonederoSolar").innerHTML = "Importe"         
        
        document.getElementById("tooltipFechaMonederoSolar").className = document.getElementById("tooltipFechaMonederoSolar").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("tooltipSaldoMonederoSolar").className = document.getElementById("tooltipSaldoMonederoSolar").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("mensajeAclaracionBonificacionMonedero").innerHTML = "Indica el día que te confimaron (Ej: por e-mail) que te empezaban a aplicar la bonificación y el importe de la misma. Si ya tenías saldo previo súmalo."
          
        document.getElementById("trMonederoSolarMes").className = document.getElementById("trMonederoSolarMes").className.replaceAll(" hidden", "")
        document.getElementById("totalBalanceMonederoSolarMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalMonederoBonificaciones).toFixed(2)) + " €"          

        if(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentSolarWalletBalance.Value) !== 0 ){
          document.getElementById("widgetDashboardMonedero"+idInstalacion).className = document.getElementById("widgetDashboardMonedero"+idInstalacion).className.replaceAll(" hidden", "")
          document.getElementById("scoringMonederoBaterias"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalMonederoBonificaciones).toFixed(2)) + " €"      
          document.getElementById("widgetConsumoEnergia"+idInstalacion).className = document.getElementById("widgetConsumoEnergia"+idInstalacion).className.replaceAll(" hidden", "")  + " hidden"        
        }
        else{
          document.getElementById("widgetDashboardMonedero"+idInstalacion).className = document.getElementById("widgetDashboardMonedero"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("widgetConsumoEnergia"+idInstalacion).className = document.getElementById("widgetConsumoEnergia"+idInstalacion).className.replaceAll(" hidden", "")          
        }
        
        //document.getElementById("lineaLinkAutoconsumo"+idInstalacion).className = document.getElementById("lineaLinkAutoconsumo"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"                   

        document.getElementById("literalTarifaVenta"+idInstalacion).innerHTML = "Excesos de potencia" 
        document.getElementById("valorVentaAhoraDashboard"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthPowerExcessesCount).toFixed(0))
        
        //Si no tengo placas tomo todo de la red      
        scoringAutoconsumo = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Value)
        
        document.getElementById("scoringInstalacionEficiencia"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(((scoringAutoconsumo)/1000).toFixed(0)) + " k" + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Unit          
        document.getElementById("scoringInstalacionEficiencia"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(((scoringAutoconsumo)/1000).toFixed(0)) + " k" + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Unit
        
        document.getElementById("iconoAutoconsumo"+idInstalacion).innerHTML = "electric_meter"
        
        if(document.getElementById("labepestañaAutoconsumoHoy") !== null){ //Compruebo si existe el componente
          
          // Oculto autoconsumos al no aplicar
          document.getElementById("labepestañaAutoconsumoHoy").className = document.getElementById("labepestañaAutoconsumoHoy").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("labepestañaAutoconsumoMes").className = document.getElementById("labepestañaAutoconsumoMes").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("labepestañaAutoconsumoAño").className = document.getElementById("labepestañaAutoconsumoAño").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("labepestañaAutoconsumoDesdeRegistro").className = document.getElementById("labepestañaAutoconsumoDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"      
          
          //Oculto valores HOY
          document.getElementById("trConsumoHoy").className = document.getElementById("trConsumoHoy").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("trVentaHoy").className = document.getElementById("trVentaHoy").className.replaceAll(" hidden", "") + " hidden"                
                                
          //Oculto valores MES
          document.getElementById("trConsumoMes").className = document.getElementById("trConsumoMes").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("trVentaMes").className = document.getElementById("trVentaMes").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("pestañaAutoconsumoMes").className = document.getElementById("pestañaAutoconsumoMes").className.replaceAll(" hidden", "") + " hidden"                          
          
          //Oculto valores AÑO
          document.getElementById("trConsumoAño").className = document.getElementById("trConsumoAño").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("trVentaAño").className = document.getElementById("trVentaAño").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("pestañaAutoconsumoAño").className = document.getElementById("pestañaAutoconsumoAño").className.replaceAll(" hidden", "") + " hidden"                
                      
          //Oculto valores DESDE_REGISTRO
          document.getElementById("trConsumoDesdeRegistro").className = document.getElementById("trConsumoDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"                  
          document.getElementById("trVentaDesdeRegistro").className = document.getElementById("trVentaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"      
          document.getElementById("pestañaAutoconsumoDesdeRegistro").className = document.getElementById("pestañaAutoconsumoDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"                
                      
        }      

      }

      //Por último aplico código de colores a los valores de las facturas

      var instalacionAutoconsumo = false

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){
        instalacionAutoconsumo = true
      }

      //Hoy
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalCompraventaYDescuentosHoy")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalGastosYPenalizacionesHoy")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyEnergiaComprada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyEnergiaVendida")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyPotenciaContratada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyEquiposMedicion")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyMonederoSolar")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyDescuento")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyBonoSocial")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyImpuestoElectricidad")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"importeIVAHoy")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyValorEnergiaConsumida")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionExcesosPotenciaHoy")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionReactivaHoy")      

      document.getElementById("totalCompraventaYDescuentosHoy").innerHTML = document.getElementById("totalCompraventaYDescuentosHoy").innerHTML.replaceAll("-","")
      document.getElementById("totalGastosYPenalizacionesHoy").innerHTML = document.getElementById("totalGastosYPenalizacionesHoy").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyEnergiaComprada").innerHTML = document.getElementById("valorHoyEnergiaComprada").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyEnergiaVendida").innerHTML = document.getElementById("valorHoyEnergiaVendida").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyPotenciaContratada").innerHTML = document.getElementById("valorHoyPotenciaContratada").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyEquiposMedicion").innerHTML = document.getElementById("valorHoyEquiposMedicion").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyMonederoSolar").innerHTML = document.getElementById("valorHoyMonederoSolar").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyDescuento").innerHTML = document.getElementById("valorHoyDescuento").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyBonoSocial").innerHTML = document.getElementById("valorHoyBonoSocial").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyImpuestoElectricidad").innerHTML = document.getElementById("valorHoyImpuestoElectricidad").innerHTML.replaceAll("-","")
      document.getElementById("importeIVAHoy").innerHTML = document.getElementById("importeIVAHoy").innerHTML.replaceAll("-","")
      document.getElementById("valorHoyValorEnergiaConsumida").innerHTML = document.getElementById("valorHoyValorEnergiaConsumida").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionExcesosPotenciaHoy").innerHTML = document.getElementById("valorImportePenalizacionExcesosPotenciaHoy").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionReactivaHoy").innerHTML = document.getElementById("valorImportePenalizacionReactivaHoy").innerHTML.replaceAll("-","")

      //Mes
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalCompraventaYDescuentosMes")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalGastosYPenalizacionesMes")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesEnergiaComprada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesEnergiaVendida")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesPotenciaContratada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesEquiposMedicion")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesMonederoSolar")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesDescuento")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesBonoSocial")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesImpuestoElectricidad")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"importeIVAMes")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesValorEnergiaConsumida")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionExcesosPotenciaMes")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionReactivaMes")  
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorEurosGastadosGrupoMes")            

      document.getElementById("totalCompraventaYDescuentosMes").innerHTML = document.getElementById("totalCompraventaYDescuentosMes").innerHTML.replaceAll("-","")
      document.getElementById("totalGastosYPenalizacionesMes").innerHTML = document.getElementById("totalGastosYPenalizacionesMes").innerHTML.replaceAll("-","")
      document.getElementById("valorMesEnergiaComprada").innerHTML = document.getElementById("valorMesEnergiaComprada").innerHTML.replaceAll("-","")
      document.getElementById("valorMesEnergiaVendida").innerHTML = document.getElementById("valorMesEnergiaVendida").innerHTML.replaceAll("-","")
      document.getElementById("valorMesPotenciaContratada").innerHTML = document.getElementById("valorMesPotenciaContratada").innerHTML.replaceAll("-","")
      document.getElementById("valorMesEquiposMedicion").innerHTML = document.getElementById("valorMesEquiposMedicion").innerHTML.replaceAll("-","")
      document.getElementById("valorMesMonederoSolar").innerHTML = document.getElementById("valorMesMonederoSolar").innerHTML.replaceAll("-","")
      document.getElementById("valorMesDescuento").innerHTML = document.getElementById("valorMesDescuento").innerHTML.replaceAll("-","")
      document.getElementById("valorMesBonoSocial").innerHTML = document.getElementById("valorMesBonoSocial").innerHTML.replaceAll("-","")
      document.getElementById("valorMesImpuestoElectricidad").innerHTML = document.getElementById("valorMesImpuestoElectricidad").innerHTML.replaceAll("-","")
      document.getElementById("importeIVAMes").innerHTML = document.getElementById("importeIVAMes").innerHTML.replaceAll("-","")
      document.getElementById("valorMesValorEnergiaConsumida").innerHTML = document.getElementById("valorMesValorEnergiaConsumida").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionExcesosPotenciaMes").innerHTML = document.getElementById("valorImportePenalizacionExcesosPotenciaMes").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionReactivaMes").innerHTML = document.getElementById("valorImportePenalizacionReactivaMes").innerHTML.replaceAll("-","")
      
      //Año
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalCompraventaYDescuentosAño")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalGastosYPenalizacionesAño")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoEnergiaComprada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoEnergiaVendida")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoPotenciaContratada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoEquiposMedicion")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoMonederoSolar")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoDescuento")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoBonoSocial")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoImpuestoElectricidad")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"importeIVAAño")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoValorEnergiaConsumida")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionExcesosPotenciaAño")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionReactivaAño")        

      document.getElementById("totalCompraventaYDescuentosAño").innerHTML = document.getElementById("totalCompraventaYDescuentosAño").innerHTML.replaceAll("-","")
      document.getElementById("totalGastosYPenalizacionesAño").innerHTML = document.getElementById("totalGastosYPenalizacionesAño").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoEnergiaComprada").innerHTML = document.getElementById("valorAñoEnergiaComprada").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoEnergiaVendida").innerHTML = document.getElementById("valorAñoEnergiaVendida").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoPotenciaContratada").innerHTML = document.getElementById("valorAñoPotenciaContratada").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoEquiposMedicion").innerHTML = document.getElementById("valorAñoEquiposMedicion").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoMonederoSolar").innerHTML = document.getElementById("valorAñoMonederoSolar").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoDescuento").innerHTML = document.getElementById("valorAñoDescuento").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoBonoSocial").innerHTML = document.getElementById("valorAñoBonoSocial").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoImpuestoElectricidad").innerHTML = document.getElementById("valorAñoImpuestoElectricidad").innerHTML.replaceAll("-","")
      document.getElementById("importeIVAAño").innerHTML = document.getElementById("importeIVAAño").innerHTML.replaceAll("-","")
      document.getElementById("valorAñoValorEnergiaConsumida").innerHTML = document.getElementById("valorAñoValorEnergiaConsumida").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionExcesosPotenciaAño").innerHTML = document.getElementById("valorImportePenalizacionExcesosPotenciaAño").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionReactivaAño").innerHTML = document.getElementById("valorImportePenalizacionReactivaAño").innerHTML.replaceAll("-","")

      //Desde Registro
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalCompraventaYDescuentosDesdeRegistro")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"totalGastosYPenalizacionesDesdeRegistro")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroEnergiaComprada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroEnergiaVendida")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroPotenciaContratada")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroEquiposMedicion")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroMonederoSolar")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroDescuento")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroBonoSocial")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroImpuestoElectricidad")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"importeIVADesdeRegistro")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroValorEnergiaConsumida")        
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionExcesosPotenciaDesdeRegistro")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorImportePenalizacionReactivaDesdeRegistro")        

      document.getElementById("totalCompraventaYDescuentosDesdeRegistro").innerHTML = document.getElementById("totalCompraventaYDescuentosDesdeRegistro").innerHTML.replaceAll("-","")
      document.getElementById("totalGastosYPenalizacionesDesdeRegistro").innerHTML = document.getElementById("totalGastosYPenalizacionesDesdeRegistro").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroEnergiaComprada").innerHTML = document.getElementById("valorDesdeRegistroEnergiaComprada").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroEnergiaVendida").innerHTML = document.getElementById("valorDesdeRegistroEnergiaVendida").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroPotenciaContratada").innerHTML = document.getElementById("valorDesdeRegistroPotenciaContratada").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroEquiposMedicion").innerHTML = document.getElementById("valorDesdeRegistroEquiposMedicion").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroMonederoSolar").innerHTML = document.getElementById("valorDesdeRegistroMonederoSolar").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroDescuento").innerHTML = document.getElementById("valorDesdeRegistroDescuento").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroBonoSocial").innerHTML = document.getElementById("valorDesdeRegistroBonoSocial").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroImpuestoElectricidad").innerHTML = document.getElementById("valorDesdeRegistroImpuestoElectricidad").innerHTML.replaceAll("-","")
      document.getElementById("importeIVADesdeRegistro").innerHTML = document.getElementById("importeIVADesdeRegistro").innerHTML.replaceAll("-","")
      document.getElementById("valorDesdeRegistroValorEnergiaConsumida").innerHTML = document.getElementById("valorDesdeRegistroValorEnergiaConsumida").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionExcesosPotenciaDesdeRegistro").innerHTML = document.getElementById("valorImportePenalizacionExcesosPotenciaDesdeRegistro").innerHTML.replaceAll("-","")
      document.getElementById("valorImportePenalizacionReactivaDesdeRegistro").innerHTML = document.getElementById("valorImportePenalizacionReactivaDesdeRegistro").innerHTML.replaceAll("-","")

    }
    else{ //INSTALACIÓN DESCONECTADA DE LA RED GENERAL

      try{
        document.getElementById("botonTarifasDiarias").className = document.getElementById("botonTarifasDiarias").className.replaceAll(" hidden", "") + " hidden"
      }
      catch(error){}

      document.getElementById("labelpestañaFacturaHoy").className = document.getElementById("labelpestañaFacturaHoy").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("labelpestañaFacturaMes").className = document.getElementById("labelpestañaFacturaMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("labelpestañaFacturaAño").className = document.getElementById("labelpestañaFacturaAño").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("labelpestañaFacturaDesdeRegistro").className = document.getElementById("labelpestañaFacturaDesdeRegistro").className.replaceAll(" hidden", "") + " hidden"
      
      document.getElementById("widgetConsumoEnergia"+idInstalacion).className = document.getElementById("widgetConsumoEnergia"+idInstalacion).className.replaceAll(" hidden", "")
      document.getElementById("trAvisoRegalandoDineroMes").className = document.getElementById("trAvisoRegalandoDineroMes").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trMonederoSolarMes").className = document.getElementById("trMonederoSolarMes").className.replaceAll(" hidden", "") + " hidden"
      
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","DesdeRegistro")
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Año")        
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Hoy")
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Mes")            
      
      instalacionAutoconsumo = true

      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorHoyValorEnergiaConsumida")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorMesValorEnergiaConsumida")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorAñoValorEnergiaConsumida")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorDesdeRegistroValorEnergiaConsumida")

      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorEurosGastadosGrupoHoy")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorEurosGastadosGrupoMes")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorEurosGastadosGrupoAño")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorEurosGastadosGrupoDesdeRegistro")

      //* ************************************************************************************************************************************************************************************** */
      // LITERALES
      //* ************************************************************************************************************************************************************************************** */

      if(document.getElementById("valorPestañaAutoconsumoHoy").innerHTML.includes("-")){ document.getElementById("textoLabelAutoconsumoHoy").innerHTML = "Gasto de" }
      else{ document.getElementById("textoLabelAutoconsumoHoy").innerHTML = "Ahorro de" }

      if(document.getElementById("valorPestañaAutoconsumoMes").innerHTML.includes("-")){ document.getElementById("textoLabelAutoconsumoMes").innerHTML = "Gasto de" }
      else{ document.getElementById("textoLabelAutoconsumoMes").innerHTML = "Ahorro de" }

      if(document.getElementById("valorPestañaAutoconsumoAño").innerHTML.includes("-")){ document.getElementById("textoLabelAutoconsumoAño").innerHTML = "Gasto de" }
      else{ document.getElementById("textoLabelAutoconsumoAño").innerHTML = "Ahorro de" }

      if(document.getElementById("valorPestañaAutoconsumoDesdeRegistro").innerHTML.includes("-")){ document.getElementById("textoLabelAutoconsumoDesdeRegistro").innerHTML = "Gasto de" }
      else{ document.getElementById("textoLabelAutoconsumoDesdeRegistro").innerHTML = "Ahorro de" }
              
      //* ************************************************************************************************************************************************************************************** */
      // [ DASHBOARD ]: VALORES, LITERALES Y COLORES
      //* ************************************************************************************************************************************************************************************** */

      // Ahora muestro el ahorro por otros gastos, previamente los paso a positivos para mostrarlos en verde

      var otrosGastosHoy = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodaysavingsBalance.Value).toFixed(2) * -1
      var otrosGastosMes = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthsavingsBalance.Value).toFixed(2) * -1
      var otrosGastosAño = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearsavingsBalance.Value).toFixed(2) * -1
      var otrosGastosDesdeRegistro = parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationsavingsBalance.Value).toFixed(2) * -1

      document.getElementById("trOtrosGastosAutoconsumoHoy").className = document.getElementById("trOtrosGastosAutoconsumoHoy").className.replaceAll(" hidden","")
      document.getElementById("trOtrosGastosAutoconsumoMes").className = document.getElementById("trOtrosGastosAutoconsumoMes").className.replaceAll(" hidden","")
      document.getElementById("trOtrosGastosAutoconsumoAño").className = document.getElementById("trOtrosGastosAutoconsumoAño").className.replaceAll(" hidden","")
      document.getElementById("trOtrosGastosAutoconsumoDesdeRegistro").className = document.getElementById("trOtrosGastosAutoconsumoDesdeRegistro").className.replaceAll(" hidden","")

      document.getElementById("valorOtrosGastosAutoconsumoHoy").innerHTML = new Intl.NumberFormat('en-DE').format(otrosGastosHoy) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodaysavingsBalance.Unit
      document.getElementById("valorOtrosGastosAutoconsumoMes").innerHTML = new Intl.NumberFormat('en-DE').format(otrosGastosMes) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthsavingsBalance.Unit
      document.getElementById("valorOtrosGastosAutoconsumoAño").innerHTML = new Intl.NumberFormat('en-DE').format(otrosGastosAño) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearsavingsBalance.Unit
      document.getElementById("valorOtrosGastosAutoconsumoDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(otrosGastosDesdeRegistro) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationsavingsBalance.Unit

      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorOtrosGastosAutoconsumoHoy")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorOtrosGastosAutoconsumoMes")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorOtrosGastosAutoconsumoAño")
      module.exports.setearColorValorFactura(instalacionAutoconsumo,"valorOtrosGastosAutoconsumoDesdeRegistro")

      if(Object.keys(jsonObjRespuestaDashboard.FVData).length > 0){                    
        module.exports.setearColorKPI("autoconsumo","figureAutoconsumo"+idInstalacion, scoringAutoconsumo)
        module.exports.setearColorKPI("gasto","AhorroGasto"+idInstalacion, scoringAhorro)      
      }
      else{          
        document.getElementById("figureAhorroGasto"+idInstalacion).className = document.getElementById("figureAhorroGasto"+idInstalacion).className.replaceAll(" cyan","") + " cyan"
        document.getElementById("figureAutoconsumo"+idInstalacion).className = document.getElementById("figureAutoconsumo"+idInstalacion).className.replaceAll(" cyan","") + " cyan"
      }

      scoringAutoconsumo = jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Value    
      document.getElementById("scoringInstalacionEficiencia"+idInstalacion).innerHTML = parseFloat(scoringAutoconsumo).toFixed(0) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Unit
      document.getElementById("literalAutoconsumo"+idInstalacion).innerHTML = "Autoconsumo"
      document.getElementById("figureAutoconsumo"+idInstalacion).className = document.getElementById("figureAutoconsumo"+idInstalacion).className.replaceAll(" red", "").replaceAll(" orange", "").replaceAll(" lime", "").replaceAll(" cyan", "").replaceAll(" green", "").replaceAll(" gold", "")                
      document.getElementById("figureAhorroGasto"+idInstalacion).className = document.getElementById("figureAhorroGasto"+idInstalacion).className.replaceAll(" red", "").replaceAll(" orange", "").replaceAll(" lime", "").replaceAll(" cyan", "").replaceAll(" green", "").replaceAll(" gold", "")
  
      scoringAhorro = parseFloat(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthusedEnergyCost.Value) + parseFloat(otrosGastosMes) - parseFloat(jsonObjRespuestaDashboard.GeneratorData.CurrentMonthGeneratorConsumptionCost.Value)).toFixed(2) 

      if (scoringAhorro.toString() === "0.00"){
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(scoringAhorro).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Unit
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML.replaceAll("-","")
      }        
      else{
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(scoringAhorro).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Unit
        document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML = document.getElementById("scoringInstalacionAhorro"+idInstalacion).innerHTML.replaceAll("-","")
      }  

      module.exports.setearColorKPI("autoconsumo","figureAutoconsumo"+idInstalacion, jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumption.Value)
      
      localStorage.setItem("lastDashboardData", JSON.stringify(jsonObjRespuestaDashboard))
      
      module.exports.setearColorKPI("gasto","AhorroGasto"+idInstalacion, scoringAhorro)      
      
      document.getElementById("scoringMonederoBaterias"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Value).toFixed(2)) + " €"        

      document.getElementById("literalTarifaCompra"+idInstalacion).innerHTML = "kW Autoconsumo"
      document.getElementById("valorCompraAhoraDashboard"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format((parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthconsumption.Value)/1000).toFixed(2)) + " k" + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthconsumption.Unit
      document.getElementById("literalTarifaVenta"+idInstalacion).innerHTML = "Aprovechamiento"
      document.getElementById("valorVentaAhoraDashboard"+idInstalacion).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthEnergeticUse.Value).toFixed(0)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthEnergeticUse.Unit

      // Ahora rectifico las pestañas de autoconsumo para considerar todos los gastos

      var totalPestañaAutoconsumoHoy = parseFloat(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.TodayusedEnergyCost.Value) + parseFloat(otrosGastosHoy) - parseFloat(jsonObjRespuestaDashboard.GeneratorData.TodayGeneratorConsumptionCost.Value)).toFixed(2) 
      var totalPestañaAutoconsumoMes = scoringAhorro
      var totalPestañaAutoconsumoAño = parseFloat(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.YearusedEnergyCost.Value) + parseFloat(otrosGastosAño) - parseFloat(jsonObjRespuestaDashboard.GeneratorData.YearGeneratorConsumptionCost.Value)).toFixed(2) 
      var totalPestañaAutoconsumoDesdeRegistro = parseFloat(parseFloat(jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.SinceRegistrationusedEnergyCost.Value) + parseFloat(otrosGastosDesdeRegistro) - parseFloat(jsonObjRespuestaDashboard.GeneratorData.SinceRegistrationGeneratorConsumptionCost.Value)).toFixed(2) 

      document.getElementById("valorPestañaAutoconsumoHoy").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalPestañaAutoconsumoHoy).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Unit
      document.getElementById("valorPestañaAutoconsumoMes").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalPestañaAutoconsumoMes).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Unit
      document.getElementById("valorPestañaAutoconsumoAño").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalPestañaAutoconsumoAño).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Unit
      document.getElementById("valorPestañaAutoconsumoDesdeRegistro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(totalPestañaAutoconsumoDesdeRegistro).toFixed(2)) + " " + jsonObjRespuestaDashboard.SelfConsumptionAndSavingsData.CurrentMonthselfConsumptionBalance.Unit

    }

    //Finalmente seteo default la fecha del monedero    
    
    if(document.getElementById("fechaDesdeFacturaMonedero").value === ""){      
      var fechaActual = new Date().toJSON().split("T")[0];      
      document.getElementById("fechaDesdeFacturaMonedero").value = fechaActual
    }

  }    

}

exports.cargarWidgetTOTALES = function(jsonObjTOTAL){

  //Muestro los iconos correspondientes en función de la configuración de la instalación

  if(jsonObjTOTAL.InstallationData.GeneralInfo.EnergyGridConnected === "true"){ 
    document.getElementById("etiquetaConsumoMaximoHistorico").innerHTML = "Consumo máximo histórico:"

    if(Object.keys(jsonObjTOTAL.FVData).length > 0){    
      document.getElementById("etiquetaConsumoMaximoHistorico").innerHTML = "Consumo máximo histórico red:"
    }
  }
  else{    
    document.getElementById("etiquetaConsumoMaximoHistorico").innerHTML = "Consumo máximo histórico:"
  }

  //Máximo hitórico consumo
  document.getElementById("consumoMaximoHistoricoTotal").innerHTML = jsonObjTOTAL.SelfConsumptionAndSavingsData.HistoricalMaxPowerConsumption.Value + " " + jsonObjTOTAL.SelfConsumptionAndSavingsData.HistoricalMaxPowerConsumption.Unit
 
  //Cargo los iconos para la FV
  if(Object.keys(jsonObjTOTAL.FVData).length > 0){
    if(parseInt(jsonObjTOTAL.FVData.GeneralWhFVGeneration.Value) > 0 ){
      document.getElementById("figureFVGenerando").className = "avatar size-l pink"
    }
    else{
      document.getElementById("figureFVGenerando").className = "avatar size-l disabled"
    }
  }
  else{
    document.getElementById("figureFVGenerando").className = " hidden"
  }
  
  //Cargo los iconos para las baterías
  if(Object.keys(jsonObjTOTAL.BatteriesData).length > 0){
    document.getElementById("figureBateriasGenerando").className = "avatar size-l percentage-indicator disabled"
    document.getElementById("figureBateriasConsumiendo").className = "avatar size-l percentage-indicator disabled"

    if(parseInt(jsonObjTOTAL.BatteriesData.BatteryWhConsumption.Value) !== 0){
      if(jsonObjTOTAL.BatteriesData.BatteryStatus === "Cargando"){
        document.getElementById("figureBateriasGenerando").className = "avatar size-l percentage-indicator disabled hidden"
        document.getElementById("figureBateriasConsumiendo").className = "avatar size-l percentage-indicator pink"              
  
      }    
      else if( (jsonObjTOTAL.BatteriesData.BatteryStatus === "Descargando") || (jsonObjTOTAL.BatteriesData.BatteryStatus === "Cargada") ){
        document.getElementById("figureBateriasGenerando").className = "avatar size-l percentage-indicator pink"
        document.getElementById("figureBateriasConsumiendo").className = "avatar size-l percentage-indicator disabled hidden"        
      }
    }
    else{
      if( (jsonObjTOTAL.BatteriesData.BatteryStatus === "Reposo") || (jsonObjTOTAL.BatteriesData.BatteryStatus === "N/A") || (jsonObjTOTAL.BatteriesData.BatteryStatus === "En reposo")){
        document.getElementById("figureBateriasGenerando").className = "avatar size-l percentage-indicator disabled"
        document.getElementById("figureBateriasConsumiendo").className = "avatar size-l percentage-indicator disabled hidden"        
      }      
      else if(jsonObjTOTAL.BatteriesData.BatteryStatus === "Cargada"){
        document.getElementById("figureBateriasGenerando").className = "avatar size-l percentage-indicator disabled"
        document.getElementById("figureBateriasConsumiendo").className = "avatar size-l percentage-indicator disabled hidden"        
      }      
    }

    document.getElementById("etiquetaPorcentajeBateriasGenerando").innerHTML = parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) + " " + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit
    document.getElementById("etiquetaPorcentajeBateriasGenerando").style = "--indicator-progress:"+jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit    
    document.getElementById("etiquetaPorcentajeBateriasConsumiendo").innerHTML = parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) + " " + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit
    document.getElementById("etiquetaPorcentajeBateriasConsumiendo").style = "--indicator-progress:"+jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit

    if(parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) <= 35){
      document.getElementById("etiquetaPorcentajeBateriasGenerando").className = "indicator low"
      document.getElementById("etiquetaPorcentajeBateriasConsumiendo").className = "indicator low"
    }
    else if( (parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) > 35) && (parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) <= 60)){
      document.getElementById("etiquetaPorcentajeBateriasGenerando").className = "indicator medium"
      document.getElementById("etiquetaPorcentajeBateriasConsumiendo").className = "indicator medium"
    }
    else if(parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) > 60){
      document.getElementById("etiquetaPorcentajeBateriasGenerando").className = "indicator high"
      document.getElementById("etiquetaPorcentajeBateriasConsumiendo").className = "indicator high"
    }
    
  }
  else{
    document.getElementById("figureBateriasGenerando").className = " hidden"
    document.getElementById("figureBateriasConsumiendo").className = " hidden"
  }

  //Cargo los iconos para el Grupo Electrógeno
  if(Object.keys(jsonObjTOTAL.GeneratorData).length > 0){
    document.getElementById("figureGrupoGenerando").className = "avatar size-l percentage-indicator disabled"
  
    if(parseInt(jsonObjTOTAL.GeneratorData.GeneralWhGeneratorTOTALGeneration.Value) > 0 ){
      document.getElementById("figureGrupoGenerando").className = "avatar size-l percentage-indicator pink"
    }

    document.getElementById("etiquetaPorcentajeGrupoGenerando").innerHTML = parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) + " " + jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Unit
    document.getElementById("etiquetaPorcentajeGrupoGenerando").style = "--indicator-progress:"+jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value + jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Unit    

    if(parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) <= 35){
      document.getElementById("etiquetaPorcentajeGrupoGenerando").className = "indicator low"
      document.getElementById("etiquetaPorcentajeGrupoGenerando").className = "indicator low"
    }
    else if( (parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) > 35) && (parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) <= 60)){
      document.getElementById("etiquetaPorcentajeGrupoGenerando").className = "indicator medium"
      document.getElementById("etiquetaPorcentajeGrupoGenerando").className = "indicator medium"
    }
    else if(parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) > 60){
      document.getElementById("etiquetaPorcentajeGrupoGenerando").className = "indicator high"
      document.getElementById("etiquetaPorcentajeGrupoGenerando").className = "indicator high"
    }

    if(parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) < 25){      
      var estadoActualfigureGrupoGenerando = document.getElementById("figureGrupoGenerando").className
      document.getElementById("figureGrupoGenerando").className = "avatar size-l percentage-indicator orange blink"
      setTimeout(() => {try{document.getElementById("figureGrupoGenerando").className = estadoActualfigureGrupoGenerando} catch (error) {console.error(error);} },3000);	      
    }    
    
  }
  else{
    document.getElementById("figureGrupoGenerando").className = " hidden"
  }

  //Cargo los iconos para la instalación
  if(Object.keys(jsonObjTOTAL.InstallationData.GeneralInfo).length > 0){
    document.getElementById("figureInstalacionConsumiendo").className = "avatar size-l disabled"
  
    if(parseInt(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Value) > 0 ){
      document.getElementById("figureInstalacionConsumiendo").className = "avatar size-l green"
    }
  }
  else{
    document.getElementById("figureInstalacionConsumiendo").className = " hidden"
  }

  //Cargo los iconos para el coche
  try{
    if(Object.keys(jsonObjTOTAL.CarsData).length > 0){

      document.getElementById("figureCocheConsumiendo").className = "avatar size-l percentage-indicator disabled"
    
      if(parseInt(jsonObjTOTAL.CarsData[0].ChargePower.Value) > 0 ){
        document.getElementById("figureCocheConsumiendo").className = "avatar size-l percentage-indicator pink"
      }

      document.getElementById("etiquetaPorcentajeCocheConsumiendo").innerHTML = parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) + " " + jsonObjTOTAL.CarsData[0].ChargeLevel.Unit
      document.getElementById("etiquetaPorcentajeCocheConsumiendo").style = "--indicator-progress:"+jsonObjTOTAL.CarsData[0].ChargeLevel.Value + jsonObjTOTAL.CarsData[0].ChargeLevel.Unit    

      if(parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) <= 35){
        document.getElementById("etiquetaPorcentajeCocheConsumiendo").className = "indicator low"
        document.getElementById("etiquetaPorcentajeCocheConsumiendo").className = "indicator low"
      }
      else if( (parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) > 35) && (parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) <= 60)){
        document.getElementById("etiquetaPorcentajeCocheConsumiendo").className = "indicator medium"
        document.getElementById("etiquetaPorcentajeCocheConsumiendo").className = "indicator medium"
      }
      else if(parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) > 60){
        document.getElementById("etiquetaPorcentajeCocheConsumiendo").className = "indicator high"
        document.getElementById("etiquetaPorcentajeCocheConsumiendo").className = "indicator high"
      }

    }
    else{
      document.getElementById("figureCocheConsumiendo").className = " hidden"
    }
  }
  catch(error){console.log(error)}

  document.getElementById("potenciaTOTALDisponible").innerHTML = jsonObjTOTAL.GeneralData.TotalMaximunGeneration.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalMaximunGeneration.Unit
  document.getElementById("generacionTOTALActual").innerHTML = jsonObjTOTAL.GeneralData.TotalBulkGeneration.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalBulkGeneration.Unit
  
  // Si tengo capacitiva pongo 0 para no confundir al usuario.
  if(jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value < 0){
    jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value = "0"
  }

  document.getElementById("consumoTOTALActual").innerHTML = jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value + " " + jsonObjTOTAL.GeneralData.TotalBulkConsumption.Unit   
  document.getElementById("potenciaActual").innerHTML = jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value + " " + jsonObjTOTAL.GeneralData.TotalBulkConsumption.Unit   
  
  //Gestiono la visualización de los datos de carga/volcado de la red y energía residual

  // Por defecto muestro tanto tomando como devolviendo oculto
  document.getElementById("divTomandoDeLaRed").className = document.getElementById("divTomandoDeLaRed").className.replaceAll(" hidden", "") + " hidden"        
  document.getElementById("divDevolviendoARed").className = document.getElementById("divDevolviendoARed").className.replaceAll(" hidden", "") + " hidden"        
  
  document.getElementById("etiquetaTomandoDeLaRed").innerHTML = ""        
  document.getElementById("etiquetaDevolviendoARed").innerHTML = ""        
  
  document.getElementById("figureTomandoDeLaRed").className = "avatar size-l disabled"                
  document.getElementById("figureDevolviendoARed").className = "avatar size-l disabled"                
  
  document.getElementById("spanFigureTomandoDeLaRed").innerHTML = ""                        
  document.getElementById("spanFigureDevolviendoARed").innerHTML = ""                        
  
  document.getElementById("tomandoDeLaRed").innerHTML = "0 Wh"
  document.getElementById("devolviendoARed").innerHTML = "0 Wh"

  if(jsonObjTOTAL.InstallationData.GeneralInfo.EnergyGridConnected === "true"){      
    
    // Ahora si tomo de la red lo muestro
    if(parseInt(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Value) > 0){        
      document.getElementById("etiquetaTomandoDeLaRed").innerHTML = "Tomando de la red"
      document.getElementById("figureTomandoDeLaRed").className = "avatar size-l cyan"                
      document.getElementById("spanFigureTomandoDeLaRed").innerHTML = "power_input" 
      document.getElementById("divTomandoDeLaRed").className = document.getElementById("divTomandoDeLaRed").className.replaceAll(" hidden", "")
      document.getElementById("tomandoDeLaRed").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Value.replace("-","") + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Unit
    }
    
    // Y si devuelvo también
    if(parseInt(jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value) > 0){    
      document.getElementById("etiquetaDevolviendoARed").innerHTML = "Devolviendo a la red"
      document.getElementById("figureDevolviendoARed").className = "avatar size-l cyan"     
      document.getElementById("spanFigureDevolviendoARed").innerHTML = "output" 
      document.getElementById("divDevolviendoARed").className = document.getElementById("divDevolviendoARed").className.replaceAll(" hidden", "")    
      document.getElementById("devolviendoARed").innerHTML = jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalWastedEnergy.Unit
    }

  }
  else{

    if(parseInt(jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value) > 0){            
      document.getElementById("divDevolviendoARed").className = document.getElementById("divDevolviendoARed").className.replaceAll(" hidden", "")
      document.getElementById("etiquetaDevolviendoARed").innerHTML = "Perdiendo / Residual"         
      document.getElementById("figureDevolviendoARed").className = "avatar size-l cyan"        
      document.getElementById("spanFigureDevolviendoARed").innerHTML = "output"                            
      document.getElementById("devolviendoARed").innerHTML = jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalWastedEnergy.Unit
    }

  }

  var consumoActualTotal = parseInt(jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value.replace("-","").replaceAll(".", ""))  
  var generacionMaximaInstalacion = parseInt(jsonObjTOTAL.GeneralData.TotalMaximunGeneration.Value.replace("-","").replaceAll(".", ""))

  document.getElementById("resumenGeneralConsumoMeter").min = "0"
  document.getElementById("resumenGeneralConsumoMeter").max = generacionMaximaInstalacion
  document.getElementById("resumenGeneralConsumoMeter").value = consumoActualTotal

  var porcentajeConsumoInstalacion = (consumoActualTotal * 100) / generacionMaximaInstalacion

  if ( (0 <= porcentajeConsumoInstalacion) && (porcentajeConsumoInstalacion <= 50) ){
    document.getElementById("resumenGeneralConsumoMeter").className = "fill green"
  }
  else if ( (50 < porcentajeConsumoInstalacion) && (porcentajeConsumoInstalacion <= 80) ){
    document.getElementById("resumenGeneralConsumoMeter").className = "fill orange"
  }
  else if ( (80 < porcentajeConsumoInstalacion) && (porcentajeConsumoInstalacion <= 100) ){
    document.getElementById("resumenGeneralConsumoMeter").className = "fill red"    
  }
  else if (porcentajeConsumoInstalacion > 100){
    document.getElementById("resumenGeneralConsumoMeter").className = "fill red blink"    
  }

  //Tras pintar todo, simplifico datos en caso de red básica conectada a la red general
  if( (Object.keys(jsonObjTOTAL.FVData).length === 0) && (Object.keys(jsonObjTOTAL.BatteriesData).length === 0) && (Object.keys(jsonObjTOTAL.GeneratorData).length === 0) ){
    document.getElementById("contenedorBotoneraInferiorDashboard").className = document.getElementById("contenedorBotoneraInferiorDashboard").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("divTomandoDeLaRed").className = document.getElementById("divTomandoDeLaRed").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("divConsumiendo").className = document.getElementById("divConsumiendo").className.replaceAll(" hidden", "") + " hidden"

    if( (Object.keys(jsonObjTOTAL.CarsData).length > 0) || (jsonObjTOTAL.InstallationData.GeneralInfo.ElectricSystemType === "TRIFASICO") ){
      if(jsonObjTOTAL.InstallationData.GeneralInfo.EnergyGridConnected === "true"){       
        document.getElementById("contenedorBotoneraInferiorDashboard").className = document.getElementById("contenedorBotoneraInferiorDashboard").className.replaceAll(" hidden", "") 
        document.getElementById("divTomandoDeLaRed").className = document.getElementById("divTomandoDeLaRed").className.replaceAll(" hidden", "")
      }
      document.getElementById("divConsumiendo").className = document.getElementById("divConsumiendo").className.replaceAll(" hidden", "")
    }    
  }

  var generacionActualTotal = parseInt(jsonObjTOTAL.GeneralData.TotalBulkGeneration.Value.replaceAll(".",""))  

  if( (Object.keys(jsonObjTOTAL.FVData).length > 0) || (Object.keys(jsonObjTOTAL.BatteriesData).length > 0) || (Object.keys(jsonObjTOTAL.GeneratorData).length > 0) ){
    //Si tengo algún elemento de generación aun no habiendo generación lo muestro para mantener el icono de acceso al detalle
    document.getElementById("divGenerando").className = document.getElementById("divGenerando").className.replaceAll(" hidden", "")
  }
  else{ // Sino oculto la generación si procede
    if(generacionActualTotal === 0){
      document.getElementById("divGenerando").className = document.getElementById("divGenerando").className.replaceAll(" hidden", "") + " hidden"
    }    
    else{
      document.getElementById("divGenerando").className = document.getElementById("divGenerando").className.replaceAll(" hidden", "")
    }
  }
  
}

exports.cargarWidgetMeteo = function(jsonObjMeteo,setObjHorarioSol,objDayForecasting){
  
    try{
      var tipoDispositivoMovil = generalCommonJS.obtenerTipoPlataforma() 
      var elementoACargar = ""

      if(tipoDispositivoMovil.includes("Web")){ 
        elementoACargar = ""
        document.getElementById("divMeteo").className = document.getElementById("divMeteo").className.replaceAll(" hidden", "")
        document.getElementById("widgetMeteoMobile").className = document.getElementById("widgetMeteoMobile").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("widgetMeteoDetailMobile").className = document.getElementById("widgetMeteoDetailMobile").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("filaTemperaturaExterior").className = document.getElementById("filaTemperaturaExterior").className.replaceAll(" hidden", "")      
        document.getElementById("filaAmanecer").className = document.getElementById("filaAmanecer").className.replaceAll(" hidden", "")      
        document.getElementById("filaAnochecer").className = document.getElementById("filaAnochecer").className.replaceAll(" hidden", "")           
        document.getElementById("ulCiudadProvincia").className = document.getElementById("ulCiudadProvincia").className.replaceAll(" hidden", "")   
        document.getElementById("filaNombreCiudad").className = document.getElementById("filaNombreCiudad").className.replaceAll(" hidden", "")   
        document.getElementById("filaNombreProvincia").className = document.getElementById("filaNombreProvincia").className.replaceAll(" hidden", "")   
        document.getElementById("infoTemperaturaMobile").innerHTML = ""
        if(jsonObjMeteo.PrecipRate.includes(".")){
          document.getElementById("infoLluviaMobile").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjMeteo.PrecipRate).toFixed(1)) + " L/m²"  
          document.getElementById("infoLluviaWebWidget").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjMeteo.PrecipRate).toFixed(1)) + " L/m²"            
        }
        else{
          document.getElementById("infoLluviaMobile").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.PrecipRate) + " L/m²"  
          document.getElementById("infoLluviaWebWidget").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjMeteo.PrecipRate).toFixed(1)) + " L/m²"            
        }

        document.getElementById("infoVientoMobile").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.WindSpeed) + " Km/h"
        document.getElementById("infoVientoWebWidget").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.WindSpeed) + " Km/h"
        
      }
      else{ //Mobile
        elementoACargar = "DetailMobile"
        document.getElementById("divMeteo").className = document.getElementById("divMeteo").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("widgetMeteoMobile").className = document.getElementById("widgetMeteoMobile").className.replaceAll(" hidden", "")
        document.getElementById("widgetMeteoDetailMobile").className = document.getElementById("widgetMeteoDetailMobile").className.replaceAll(" hidden", "")
        document.getElementById("filaTemperaturaExterior").className = document.getElementById("filaTemperaturaExterior").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("filaAmanecer").className = document.getElementById("filaAmanecer").className.replaceAll(" hidden", "") + " hidden"        
        document.getElementById("filaAnochecer").className = document.getElementById("filaAnochecer").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("ulCiudadProvincia").className = document.getElementById("ulCiudadProvincia").className.replaceAll(" hidden", "") + " hidden"                  
        document.getElementById("filaNombreCiudad").className = document.getElementById("filaNombreCiudad").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("filaNombreProvincia").className = document.getElementById("filaNombreProvincia").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("infoTemperaturaMobile").innerHTML = jsonObjMeteo.Temperature + " °C"
        
        if(jsonObjMeteo.PrecipRate.includes(".")){
          document.getElementById("infoLluviaMobile").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjMeteo.PrecipRate).toFixed(1)) + " L/m²"  
        }
        else{
          document.getElementById("infoLluviaMobile").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.PrecipRate) + " L/m²"  
        }
        
        document.getElementById("infoVientoMobile").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.WindSpeed) + " Km/h"
        
        
        
        document.getElementById("figureDetalleMeteo").innerHTML = '<span class="material-icon">cloud</span>'
              
      }

      if(document.getElementById("iconoTiempoDashboard") !== null){

        //CARGO DATOS BÁSICOS      
        document.getElementById("iconoTiempoDashboard").src = "https://www.aemet.es/imagenes_gcd/_iconos_municipios/"+jsonObjMeteo.NowForcasting.SkyStatusValue+".png"
        document.getElementById("iconoTiempoDashboardMobile").src = "https://www.aemet.es/imagenes_gcd/_iconos_municipios/"+jsonObjMeteo.NowForcasting.SkyStatusValue+".png"
        document.getElementById("iconoTiempoDashboardDetailMobile").src = "https://www.aemet.es/imagenes_gcd/_iconos_municipios/"+jsonObjMeteo.NowForcasting.SkyStatusValue+".png"

        if(jsonObjMeteo.NowForcasting.SkyStatus !== undefined){
          document.getElementById("literalTiempo"+elementoACargar).innerHTML = jsonObjMeteo.NowForcasting.SkyStatus
        }
        else{
          document.getElementById("literalTiempo"+elementoACargar).innerHTML = ""
        }
        
        document.getElementById("literalTemperatura"+elementoACargar).innerHTML = jsonObjMeteo.Temperature+" °C"
        document.getElementById("nombreMunicipio"+elementoACargar).innerHTML = jsonObjMeteo.CityName.replace("`","'")                
        document.getElementById("valorProvinceName"+elementoACargar).innerHTML = jsonObjMeteo.ProvinceName.replace("`","'") 
        document.getElementById("horaSalidaSol"+elementoACargar).innerHTML = jsonObjMeteo.Sunrise
        document.getElementById("horaPuestaSol"+elementoACargar).innerHTML = jsonObjMeteo.Sunset
            
        var horaSalidaSol = jsonObjMeteo.Sunrise
        var horaPuestaSol = jsonObjMeteo.Sunset
        if (horaSalidaSol.length < 5){ horaSalidaSol = "0"+jsonObjMeteo.Sunrise }
        if (horaPuestaSol.length < 5){ horaPuestaSol = "0"+jsonObjMeteo.Sunset }

        //Seteo los valores para actualizar la grafica FV
        setObjHorarioSol({
            "Sunrise": horaSalidaSol,
            "Sunset": horaPuestaSol
        })

        var fechaActual = new Date();
        var añoActual = fechaActual.getFullYear();
        var mesActual = (fechaActual.getMonth()+1);
        var diaActual = fechaActual.getDate();
          
        if (mesActual < 10){ mesActual = "0"+mesActual;	}
        if (diaActual < 10){ diaActual = "0"+diaActual;	}
        
        var timestampInicioDia = Date.parse(añoActual+"/"+mesActual+"/"+diaActual + " 00:00:00")		    
        var puntoActualDia = (Date.now() - timestampInicioDia)/1000
        
        var timestampSalidaSol = Date.parse(añoActual+"/"+mesActual+"/"+diaActual + " " + horaSalidaSol + ":00")
        var timestampPuestaSol = Date.parse(añoActual+"/"+mesActual+"/"+diaActual + " " + horaPuestaSol + ":00")
        
        var puntoSalidaSol = (timestampSalidaSol - timestampInicioDia)/1000
        var puntoPuestaSol = (timestampPuestaSol - timestampInicioDia)/1000

        document.getElementById("sunLightMeter"+elementoACargar).min = "0"
        document.getElementById("sunLightMeter"+elementoACargar).max = "86400"
        document.getElementById("sunLightMeter"+elementoACargar).value = puntoActualDia
        document.getElementById("sunLightMeter"+elementoACargar).style = "--sun:"+puntoSalidaSol+";--moon:"+puntoPuestaSol

        if( (puntoActualDia < puntoSalidaSol) || (puntoActualDia > puntoPuestaSol) ){
          document.getElementById("widgetMeteo").className = document.getElementById("widgetMeteo").className.replaceAll(" night", "") + " night"
        }
        else{
          document.getElementById("widgetMeteo").className = document.getElementById("widgetMeteo").className.replaceAll(" day", "") + " day"
        }

        //CARGO DATOS MÁS DETALLE

        document.getElementById("etiquetaNombreCiudad").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CityName") 
        
        if(jsonObjMeteo.CityName !== ""){
          document.getElementById("valorNombreCiudad").innerHTML = jsonObjMeteo.CityName.replace("`","'")                  
        }
        else{          
          document.getElementById("ulCiudadProvincia").className = document.getElementById("ulCiudadProvincia").className.replaceAll(" hidden", "") + " hidden"
        }

        document.getElementById("etiquetaNombreProvincia").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("ProvinceName") 
        document.getElementById("valorNombreProvincia").innerHTML = jsonObjMeteo.ProvinceName.replace("`","'") 

        document.getElementById("etiquetaInstallationLongitude").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("InstallationLongitude") 
        document.getElementById("valorInstallationLongitude").innerHTML = parseFloat(jsonObjMeteo.InstallationLongitude).toFixed(6)

        document.getElementById("etiquetaInstallationLatitude").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("InstallationLatitude") 
        document.getElementById("valorInstallationLatitude").innerHTML = parseFloat(jsonObjMeteo.InstallationLatitude).toFixed(6)

        document.getElementById("etiquetaTemperaturaExterior").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("Temperature") 
        document.getElementById("valorTemperaturaExterior").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.Temperature) + " °C"

        document.getElementById("etiquetaUV").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("UV") 
        document.getElementById("valorUV").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.UV)
        
        document.getElementById("etiquetaSolarRadiation").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("SolarRadiation") 
        document.getElementById("valorSolarRadiation").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.SolarRadiation) + " W/m²"
        
        document.getElementById("etiquetaWindSpeed").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("WindSpeed") 
        document.getElementById("valorWindSpeed").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.WindSpeed) + " Km/h"

        document.getElementById("etiquetaPrecipRate").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("PrecipRate") 
        document.getElementById("valorPrecipRate").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.PrecipRate) + " L/m²"

        document.getElementById("etiquetaHumidity").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("Humidity") 
        document.getElementById("valorHumidity").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjMeteo.Humidity) + " %"

        document.getElementById("etiquetaSunrise").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("Sunrise") 
        document.getElementById("valorSunrise").innerHTML = jsonObjMeteo.Sunrise

        document.getElementById("etiquetaSunset").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("Sunset") 
        document.getElementById("valorSunset").innerHTML = jsonObjMeteo.Sunset
        
        objDayForecasting = jsonObjMeteo.Forecasting[0].Data

      }
    }
    catch(error){console.log(error)}
  
}

exports.cargarWidgetInstalacion = function(jsonObjTOTAL, idInstalacion){

  if(document.getElementById("divTOTALES"+idInstalacion)!== null){

    document.getElementById("detalleTotalesInstalacion").className = document.getElementById("detalleTotalesInstalacion").className.replaceAll(" hidden", "")    
    
    if(!localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
      document.getElementById("graficaWidgetInstalacion").className = document.getElementById("graficaWidgetInstalacion").className.replaceAll(" hidden", "")
    }    

    document.getElementById("divTOTALES"+idInstalacion).className = document.getElementById("divTOTALES"+idInstalacion).className.replaceAll(" hidden", "")
    
    
    module.exports.cargarWidgetTOTALES(jsonObjTOTAL)    
    

    if(document.getElementById("NoDatadashboardGraficaGENERAL") !== null){
      if(jsonObjTOTAL.InstallationData.GeneralInfo.MainElectricConnectionSensorsInInstallation === "false"){        
        document.getElementById("fieldsetRevisemosTuTarifa").className = document.getElementById("fieldsetRevisemosTuTarifa").className.replaceAll(" hidden", "")
        document.getElementById("fieldsetConfiguraTuTarifaElectrica").className = document.getElementById("fieldsetConfiguraTuTarifaElectrica").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("tituloGrafica").innerHTML = "Gráfica diaria"
        document.getElementById("descripcionGrafica").innerHTML = "Para ver tu consumo en tiempo real instala un medidor."              
        document.getElementById("botonMaximoHistorico").className = document.getElementById("botonMaximoHistorico").className.replaceAll(" hidden", "") + " hidden"        
      }
      else{
        
        document.getElementById("fieldsetRevisemosTuTarifa").className = document.getElementById("fieldsetRevisemosTuTarifa").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("fieldsetConfiguraTuTarifaElectrica").className = document.getElementById("fieldsetConfiguraTuTarifaElectrica").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("tituloGrafica").innerHTML = "Gráfica diaria"
        document.getElementById("descripcionGrafica").innerHTML = "Todavía no hay suficiente información para mostrar tu gráfica diaria, en breve aparecerá."            
        document.getElementById("botonMaximoHistorico").className = document.getElementById("botonMaximoHistorico").className.replaceAll(" hidden", "")

        if(jsonObjTOTAL.InstallationData.GeneralInfo.PowerContracted === ""){
          document.getElementById("fieldsetRevisemosTuTarifa").className = document.getElementById("fieldsetRevisemosTuTarifa").className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("fieldsetConfiguraTuTarifaElectrica").className = document.getElementById("fieldsetConfiguraTuTarifaElectrica").className.replaceAll(" hidden", "")
        }

      }
    }

    //CARGO DATOS MÁS DETALLE
    if(document.getElementById("etiquetaEnergyGridConnected") !== null){
      document.getElementById("etiquetaEnergyGridConnected").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("EnergyGridConnected") 
    }

    if(jsonObjTOTAL.InstallationData.GeneralInfo.EnergyGridConnected === "true"){ 
      document.getElementById("valorEnergyGridConnected").innerHTML = "Sí" 
      document.getElementById("bloqueEnergiaTomadaDeRed").className = document.getElementById("bloqueEnergiaTomadaDeRed").className.replaceAll(" hidden","") 
    }
    else{
      document.getElementById("bloqueEnergiaTomadaDeRed").className = document.getElementById("bloqueEnergiaTomadaDeRed").className.replaceAll(" hidden","") + " hidden"
      document.getElementById("valorEnergyGridConnected").innerHTML = "No"
    }

    document.getElementById("etiquetaPowerContracted").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("PowerContracted") 
    if(jsonObjTOTAL.InstallationData.GeneralInfo.PowerContracted !== "N/A"){      
      document.getElementById("valorPowerContracted").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.PowerContracted + " W"
    }
    else{
      document.getElementById("valorPowerContracted").innerHTML = "Sin contrato eléctrico"
    }

    document.getElementById("etiquetaTotalBulkGeneration").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("GeneralWhInstallationTOTALGeneration") 
    document.getElementById("valorTotalBulkGeneration").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Unit

    document.getElementById("etiquetaTotalBulkConsumption").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("TotalBulkConsumption") 

    //Si es capacitiva pongo 0 para no confundir al usuario
    if(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Value < 0){
      jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Value = "0"
    }

    document.getElementById("valorTotalBulkConsumption").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Unit
    
    if(document.getElementById("consumoTotalWidget") !== null){
      document.getElementById("consumoTotalWidget").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Unit    
    }

    document.getElementById("etiquetaTotalReactiveEnergy").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("TotalReactiveEnergy") 
    document.getElementById("valorTotalReactiveEnergy").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALReactiveEnergy.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALReactiveEnergy.Unit
    
    document.getElementById("etiquetaTotalCapacitiveEnergy").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("TotalCapacitiveEnergy") 
    document.getElementById("valorTotalCapacitiveEnergy").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALCapacitiveEnergy.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALCapacitiveEnergy.Unit
    
    document.getElementById("etiquetaTotalWastedEnergy").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("TotalWastedEnergy") 
    document.getElementById("valorTotalWastedEnergy").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALWastedEnergy.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALWastedEnergy.Unit

    document.getElementById("valorGeneralWhInstallationTOTALGeneration").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Unit
    document.getElementById("valorGeneralWhInstallationGenerationP1").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationGenerationP1.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationGenerationP1.Unit
    document.getElementById("valorGeneralWhInstallationGenerationP2").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationGenerationP2.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationGenerationP2.Unit
    document.getElementById("valorGeneralWhInstallationGenerationP3").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationGenerationP3.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationGenerationP3.Unit
      
    document.getElementById("valorGeneralWhInstallationTOTALConsumption").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Unit

    //Si es capacitiva pongo 0 para no confundir al usuario
    if(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP1.Value < 0){
      jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP1.Value = "0" 
    }

    document.getElementById("valorGeneralWhInstallationConsumptionP1").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP1.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP1.Unit
    
    //Si es capacitiva pongo 0 para no confundir al usuario
    if(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP2.Value < 0){
      jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP2.Value = "0"
    }

    document.getElementById("valorGeneralWhInstallationConsumptionP2").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP2.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP2.Unit
    
    //Si es capacitiva pongo 0 para no confundir al usuario
    if(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP3.Value < 0){
      jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP3.Value = "0"
    }

    document.getElementById("valorGeneralWhInstallationConsumptionP3").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP3.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationConsumptionP3.Unit

    document.getElementById("valorGeneralWhInstallationTOTALReactiveEnergy").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALReactiveEnergy.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALReactiveEnergy.Unit
    document.getElementById("valorGeneralWhInstallationReactiveEnergyP1").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationReactiveEnergyP1.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationReactiveEnergyP1.Unit
    document.getElementById("valorGeneralWhInstallationReactiveEnergyP2").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationReactiveEnergyP2.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationReactiveEnergyP2.Unit
    document.getElementById("valorGeneralWhInstallationReactiveEnergyP3").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationReactiveEnergyP3.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationReactiveEnergyP3.Unit

    document.getElementById("valorGeneralWhInstallationTOTALCapacitiveEnergy").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALCapacitiveEnergy.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALCapacitiveEnergy.Unit
    document.getElementById("valorGeneralWhInstallationCapacitiveEnergyP1").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationCapacitiveEnergyP1.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationCapacitiveEnergyP1.Unit
    document.getElementById("valorGeneralWhInstallationCapacitiveEnergyP2").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationCapacitiveEnergyP2.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationCapacitiveEnergyP2.Unit
    document.getElementById("valorGeneralWhInstallationCapacitiveEnergyP3").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationCapacitiveEnergyP3.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationCapacitiveEnergyP3.Unit

    document.getElementById("valorGeneralWhInstallationTOTALWastedEnergy").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALWastedEnergy.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALWastedEnergy.Unit
    document.getElementById("valorGeneralWhInstallationWastedEnergyP1").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationWastedEnergyP1.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationWastedEnergyP1.Unit
    document.getElementById("valorGeneralWhInstallationWastedEnergyP2").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationWastedEnergyP2.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationWastedEnergyP2.Unit      
    document.getElementById("valorGeneralWhInstallationWastedEnergyP3").innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationWastedEnergyP3.Value + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationWastedEnergyP3.Unit

    if(jsonObjTOTAL.InstallationData.GeneralInfo.ElectricSystemType === "MONOFASICO"){
      document.getElementById("ulDesgloseMultifase").className = document.getElementById("ulDesgloseMultifase").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("ulReactiva").className = document.getElementById("ulReactiva").className.replaceAll(" hidden", "") + " hidden"    
      document.getElementById("ulCapacitiva").className = document.getElementById("ulCapacitiva").className.replaceAll(" hidden", "") + " hidden"    
    }
    
  }

}

exports.cargarWidgetFV = function(jsonObjInstallationData, jsonObjFV){
  
  try{
    //CARGO DATOS BÁSICOS
    document.getElementById("generacionFVActual").innerHTML = jsonObjFV.GeneralWhFVGeneration.Value + " " + jsonObjFV.GeneralWhFVGeneration.Unit

    document.getElementById("rendimientoFVActual").innerHTML = jsonObjFV.FVPerformance.Value + " " + jsonObjFV.FVPerformance.Unit        
    document.getElementById("generacionSolarMaximaEstimada").innerHTML = jsonObjFV.FVMaxGenerationEstimation.Value + " " + jsonObjFV.FVMaxGenerationEstimation.Unit    

    if(jsonObjInstallationData.GeneralInfo.EnergyGridConnected === "true"){      
      
      document.getElementById("etiquetaSolarMaximaEstimada").className += " hidden"
      document.getElementById("generacionSolarMaximaEstimada").className += " hidden"
      document.getElementById("etiquetaFVWastedEnergy").className += " hidden"
      document.getElementById("valorFVWastedEnergy").className += " hidden"

    }
    else{
      document.getElementById("etiquetaSolarMaximaEstimada").className = document.getElementById("etiquetaSolarMaximaEstimada").className.replaceAll(" hidden", "")
      document.getElementById("generacionSolarMaximaEstimada").className = document.getElementById("generacionSolarMaximaEstimada").className.replaceAll(" hidden", "")
      document.getElementById("etiquetaFVWastedEnergy").className = document.getElementById("etiquetaFVWastedEnergy").className.replaceAll(" hidden", "")
      document.getElementById("valorFVWastedEnergy").className = document.getElementById("valorFVWastedEnergy").className.replaceAll(" hidden", "")      
    }

    document.getElementById("etiquetaFVWastedEnergy").innerHTML = "Perdiendo"
    document.getElementById("valorFVWastedEnergy").innerHTML = jsonObjFV.FVWastedEnergy.Value + " " + jsonObjFV.FVWastedEnergy.Unit    

    var potenciaMaximaFV  = parseInt(jsonObjFV.FVMaxGeneration.Value.replace(".",""))
    var consumoActualFV = parseInt(jsonObjFV.GeneralWhFVGeneration.Value.replace(".",""))
    var estimacionMaximaFV  = parseInt(jsonObjFV.FVMaxGenerationEstimation.Value.replace(".",""))

    document.getElementById("solarProductionMeter").min = "0"
    document.getElementById("solarProductionMeter").max = potenciaMaximaFV
    document.getElementById("solarProductionMeter").value = consumoActualFV

    var porcentajeEficienciaFV = (consumoActualFV * 100) / estimacionMaximaFV
    
    if (isNaN(porcentajeEficienciaFV)){ //Es de noche, lo muestro neutro
      document.getElementById("solarProductionMeter").className = "fill cyan"
    }
    else{//Si hay generación aplico criterio
      if (porcentajeEficienciaFV < 50){
        document.getElementById("solarProductionMeter").className = "fill red"
      }
      else if ( (porcentajeEficienciaFV >= 50) && (porcentajeEficienciaFV < 85) ){
        document.getElementById("solarProductionMeter").className = "fill orange"
      }
      else if ( porcentajeEficienciaFV >= 85){
        document.getElementById("solarProductionMeter").className = "fill green"
      }
    }

    if(jsonObjFV.FVStatus === "Offline"){
      document.getElementById("literalRendimientoFVActual").innerHTML = "Estado"
      document.getElementById("rendimientoFVActual").className = " error"
      document.getElementById("rendimientoFVActual").innerHTML = "<strong>Offline</strong>"
    }
    else{      
      document.getElementById("rendimientoFVActual").className = document.getElementById("rendimientoFVActual").className.replaceAll(" error", "")      
    }

    //CARGO DATOS MÁS DETALLE
    document.getElementById("etiquetaFVMaxGeneration").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("FVMaxGeneration") 
    document.getElementById("valorFVMaxGeneration").innerHTML = jsonObjFV.FVMaxGeneration.Value + " " + jsonObjFV.FVMaxGeneration.Unit

    document.getElementById("etiquetaFVStatus").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("FVStatus") 
    document.getElementById("valorFVStatus").innerHTML = jsonObjFV.FVStatus

    document.getElementById("etiquetaFVMaxGenerationEstimationMode").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("FVMaxGenerationEstimationMode") 
    document.getElementById("valorFVMaxGenerationEstimationMode").innerHTML = jsonObjFV.FVMaxGenerationEstimationMode
  }
  catch(error){console.log(error)}  
  
}

exports.cargarWidgetBaterias = function(jsonObjBaterias){
  
  //CARGO DATOS BÁSICOS    
  var cargaMaximaBaterias  = parseInt(jsonObjBaterias.BatteriesMaxCapacity.Value.replace(".",""))
  var cargaActualBaterias = parseInt(jsonObjBaterias.BatteriesCurrentCapacity.Value.replace(".",""))

  document.getElementById("porcentajeBaterias").innerHTML = jsonObjBaterias.GeneralBatteryPercentage.Value + " " + jsonObjBaterias.GeneralBatteryPercentage.Unit

  var valorConsumoBaterias = 0

  if(jsonObjBaterias.BatteryStatus === "Descargando"){
    valorConsumoBaterias = parseInt(jsonObjBaterias.BatteryWhConsumption.Value.replaceAll(".","")) * -1
  }
  else{
    valorConsumoBaterias = parseInt(jsonObjBaterias.BatteryWhConsumption.Value.replaceAll(".",""))
  }

  //Muestro la información de carga / descarga de las baterías
  if(parseInt(valorConsumoBaterias) > 0){ 
    document.getElementById("estadoBaterias").innerHTML = jsonObjBaterias.BatteryStatus
    document.getElementById("literalTiempoCarga").innerHTML = "Carga total en " 
    document.getElementById("literalGeneracionConsumoBaterias").innerHTML = "Consumo actual"   
    document.getElementById("tiempoCargaDescargaRestante").innerHTML = jsonObjBaterias.RemainingBatteryChargeTime.Value + " " + jsonObjBaterias.RemainingBatteryChargeTime.Unit
    document.getElementById("literalTiempoCarga").style = "display"
    document.getElementById("tiempoCargaDescargaRestante").style = "display"
    document.getElementById("literalGeneracionConsumoBaterias").style = "display"
    document.getElementById("consumoActualBaterias").style = "display"
  }
  else if (parseInt(valorConsumoBaterias) < 0){
    document.getElementById("estadoBaterias").innerHTML = jsonObjBaterias.BatteryStatus
    document.getElementById("literalTiempoCarga").innerHTML = "Descarga al 20% en "  
    document.getElementById("literalGeneracionConsumoBaterias").innerHTML = "Generación actual"  
    document.getElementById("tiempoCargaDescargaRestante").innerHTML = jsonObjBaterias.RemainingBatteryDischargeTime.Value + " " + jsonObjBaterias.RemainingBatteryDischargeTime.Unit      
    document.getElementById("literalTiempoCarga").style = "display"
    document.getElementById("tiempoCargaDescargaRestante").style = "display"
    document.getElementById("literalGeneracionConsumoBaterias").style = "display"
    document.getElementById("consumoActualBaterias").style = "display"
  }
  else {
    document.getElementById("estadoBaterias").innerHTML = jsonObjBaterias.BatteryStatus
    document.getElementById("literalTiempoCarga").innerHTML = ""  
    document.getElementById("literalGeneracionConsumoBaterias").innerHTML = ""  
    document.getElementById("tiempoCargaDescargaRestante").innerHTML = jsonObjBaterias.RemainingBatteryDischargeTime.Value + " " + jsonObjBaterias.RemainingBatteryDischargeTime.Unit      
    document.getElementById("literalTiempoCarga").style = "display: none"
    document.getElementById("tiempoCargaDescargaRestante").style = "display: none"
    document.getElementById("literalGeneracionConsumoBaterias").style = "display: none"      
    document.getElementById("consumoActualBaterias").style = "display: none"

    if(parseInt(jsonObjBaterias.GeneralBatteryPercentage.Value) !== 100){
      document.getElementById("estadoBaterias").innerHTML = "En reposo"     
      document.getElementById("figureBateriasConsumiendo").className = " hidden"
    }      

    if(jsonObjBaterias.BatteryStatus === "Desconectada"){
      document.getElementById("estadoBaterias").innerHTML = "Desconectada"     
      document.getElementById("porcentajeBaterias").innerHTML = "No disponible"
    }  

  }

  document.getElementById("consumoActualBaterias").innerHTML = jsonObjBaterias.BatteryWhConsumption.Value.replace("-","") + " " + jsonObjBaterias.BatteryWhConsumption.Unit
  
  document.getElementById("batteryMeter").min = "0"
  document.getElementById("batteryMeter").max = cargaMaximaBaterias
  document.getElementById("batteryMeter").value = cargaActualBaterias

  var porcentajeNivelBaterias = (cargaActualBaterias * 100) / cargaMaximaBaterias
  
  if ( (0 <= porcentajeNivelBaterias) && (porcentajeNivelBaterias <= 50) ){
    document.getElementById("batteryMeter").className = "fill red"
  }
  else if ( (50 < porcentajeNivelBaterias) && (porcentajeNivelBaterias <= 85) ){
    document.getElementById("batteryMeter").className = "fill orange"
  }
  else if ( (85 < porcentajeNivelBaterias) && (porcentajeNivelBaterias <= 100) ){
    document.getElementById("batteryMeter").className = "fill green"
  }
  
  if(jsonObjBaterias.BatteryStatus === "Cargando"){
    document.getElementById("batteryMeter").className += " charging"
  }
  else if(jsonObjBaterias.BatteryStatus === "Descargando"){
    document.getElementById("batteryMeter").className += " draining"
  }
  else{ // Si está en iddle no pongo nada
    document.getElementById("batteryMeter").className += ""
  }

  //CARGO DATOS MÁS DETALLE

  document.getElementById("etiquetaBatteriesMaxCapacity").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("BatteriesMaxCapacity") 
  document.getElementById("valorBatteriesMaxCapacity").innerHTML = jsonObjBaterias.BatteriesMaxCapacity.Value + " " + jsonObjBaterias.BatteriesMaxCapacity.Unit

  document.getElementById("etiquetaBatteriesInverterMaxPower").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("BatteriesInverterMaxPower") 
  document.getElementById("valorBatteriesInverterMaxPower").innerHTML = jsonObjBaterias.BatteriesInverterMaxPower.Value + " " + jsonObjBaterias.BatteriesInverterMaxPower.Unit

  document.getElementById("etiquetaBatteryVoltage").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("BatteryVoltage") 
  document.getElementById("valorBatteryVoltage").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjBaterias.BatteryVoltage.Value) + " " + jsonObjBaterias.BatteryVoltage.Unit

  if(parseFloat(jsonObjBaterias.BatteryVoltage.Value) === 0){    
    document.getElementById("liValorBatteryVoltage").className = document.getElementById("liValorBatteryVoltage").className.replaceAll(" hidden", "") + " hidden"
  }
  else{
    document.getElementById("liValorBatteryVoltage").className = document.getElementById("liValorBatteryVoltage").className.replaceAll(" hidden", "")
  }

  document.getElementById("etiquetaBatteryAmperage").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("BatteryAmperage") 
  document.getElementById("valorBatteryAmperage").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjBaterias.BatteryAmperage.Value) + " " + jsonObjBaterias.BatteryAmperage.Unit

  if(parseFloat(jsonObjBaterias.BatteryAmperage.Value) === 0){    
    document.getElementById("liValorBatteryAmperage").className = document.getElementById("liValorBatteryAmperage").className.replaceAll(" hidden", "") + " hidden"
  }
  else{
    document.getElementById("liValorBatteryAmperage").className = document.getElementById("liValorBatteryAmperage").className.replaceAll(" hidden", "")
  }

  document.getElementById("etiquetaEstadoModoTOU").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CurrentBatteryWorkingMode") 
  
  try{
    var modoTOU = jsonObjBaterias.CurrentBatteryWorkingMode
    
    if((modoTOU !== undefined) && (modoTOU !== "N/A")){
      document.getElementById("liModoTOU").className = document.getElementById("liModoTOU").className.replaceAll(" hidden", "")
      if(modoTOU === "TOU"){
        document.getElementById("valorEstadoModoTOU").innerHTML = "Activado"
      }
      else{
        document.getElementById("valorEstadoModoTOU").innerHTML = "Desactivado"
      }
    }
    else{
      document.getElementById("liModoTOU").className = document.getElementById("liModoTOU").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("valorEstadoModoTOU").innerHTML = "N/A"
    }
  }
  catch(error){
    document.getElementById("liModoTOU").className = document.getElementById("liModoTOU").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("valorEstadoModoTOU").innerHTML = "N/A"
  }

  document.getElementById("etiquetaBatteryTemperature").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("BatteryTemperature") 
  document.getElementById("valorBatteryTemperature").innerHTML = jsonObjBaterias.BatteryTemperature.Value + " " + jsonObjBaterias.BatteryTemperature.Unit

  // Carga de baterías desde la red

  if ( (localStorage.getItem("lastDashboardData")!== null) && (Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData).length > 0) && (JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData.Application === "TESLA") ){

    document.getElementById("textoCargaBateriasDesdeLaRed").innerHTML = "Si la activas las baterías se empezarán a cargar desde la red hasta el % que tengas configurado como respaldo."    

    if( (JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyGridConnected === "false") && (Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData).length === 0) ){ //Si está desconectado y sin baterías lo oculto
        document.getElementById("idFieldsetCargaBateriasDesdeLaRed").className = document.getElementById("idFieldsetCargaBateriasDesdeLaRed").className.replaceAll(" hidden", "") + " hidden"        
    }

  }
  else{
      document.getElementById("idFieldsetCargaNocturnaBaterias").className = document.getElementById("idFieldsetCargaNocturnaBaterias").className.replaceAll(" hidden", "") + " hidden"        
  } 

  //Carga dinamica nocturna baterías 

  if ( (localStorage.getItem("lastDashboardData")!== null) && (Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData).length > 0) && (JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData.Application === "FUSIONSOLAR") ){
    document.getElementById("idFieldsetCargaNocturnaBaterias").className = document.getElementById("idFieldsetCargaNocturnaBaterias").className.replaceAll(" hidden", "")   
    
    try{
      if(JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData.TOUPermitsAccepted === "false"){
        document.getElementById("cargaNocturnaBaterias").setAttribute('disabled','disabled');            
        document.getElementById("textoMensajeCargaNocturnaBaterias").innerHTML = "Para poder activar la carga nocturna inteligente <strong>tienes que pedirle a tu instalador que te habilite la configuración de baterías y aceptar antes los terminos y condiciones dentro de la aplicación Fusionsolar</strong> accediendo a la aplicación → pulsando sobre dispositivos → Baterías. La aceptación de estos términos y condiciones NO afecta a la garantía."
      }
      else{
        document.getElementById("cargaNocturnaBaterias").removeAttribute('disabled');            
        document.getElementById("textoMensajeCargaNocturnaBaterias").innerHTML = "Analizo tus consumos y cargo tus baterías lo necesario durante la noche para que lo que consumas durante el día sea al precio mínimo."
      }
    }
    catch(error){}

    if( (JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyGridConnected === "false") && (Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData).length === 0) ){ //Si está desconectado y sin baterías lo oculto
        document.getElementById("idFieldsetCargaNocturnaBaterias").className = document.getElementById("idFieldsetCargaNocturnaBaterias").className.replaceAll(" hidden", "") + " hidden"        
    }
  }
  else{
      document.getElementById("idFieldsetCargaNocturnaBaterias").className = document.getElementById("idFieldsetCargaNocturnaBaterias").className.replaceAll(" hidden", "") + " hidden"        
  }    

  if(document.getElementById("cargaNocturnaBaterias") !== null){

    if(jsonObjBaterias.DynamicBatteriesNightCharge === "true"){
      console.log("activo carga nocturna baterías dinamica")
      document.getElementById("cargaNocturnaBaterias").checked = true        
    }
    else{
      console.log("Desactivo carga nocturna baterías dinamica")
      document.getElementById("cargaNocturnaBaterias").checked = false        
    }
  }

}

exports.cargarWidgetGrupoElectrogeno = function(jsonObjGrupoElectrogeno){
  
  if(parseInt(jsonObjGrupoElectrogeno.CurrentGeneratorTankLevel.Value) === 0){    
    document.getElementById("avisoMensajeLlenadoDepositoGrupo").className = document.getElementById("avisoMensajeLlenadoDepositoGrupo").className.replaceAll(" hidden", "")
    document.getElementById("mensajeLlenadoDepositoGrupo").innerHTML = "Actualmente el depósito de su grupo electrógeno aparece como vacío, por favor llénelo al 100% y confírmelo con el siguiente botón."        
  }
  else{
    document.getElementById("avisoMensajeLlenadoDepositoGrupo").className = document.getElementById("avisoMensajeLlenadoDepositoGrupo").className.replaceAll(" hidden", "") + " hidden"
  }

  //CARGO DATOS BÁSICOS
  document.getElementById("valorEnergiaTotalGeneradaGrupo").innerHTML = jsonObjGrupoElectrogeno.GeneralWhGeneratorTOTALGeneration.Value + " " + jsonObjGrupoElectrogeno.GeneralWhGeneratorTOTALGeneration.Unit        

  //El botón del grupo se actualiza en la función de actualización de dispositivos.

  var potenciaMaximaGrupo  = parseInt(jsonObjGrupoElectrogeno.GeneratorMaxGeneration.Value.replace(".",""))
  var consumoActualGrupo = parseInt(jsonObjGrupoElectrogeno.GeneralWhGeneratorTOTALGeneration.Value.replace(".",""))

  document.getElementById("GRUPOELECTROGENOMeter").min = "0"
  document.getElementById("GRUPOELECTROGENOMeter").max = potenciaMaximaGrupo
  document.getElementById("GRUPOELECTROGENOMeter").value = consumoActualGrupo

  var porcentajeGeneracionGrupo = (consumoActualGrupo * 100) / potenciaMaximaGrupo
  
  if (0 === porcentajeGeneracionGrupo){
    document.getElementById("GRUPOELECTROGENOMeter").className = "fill cyan"
  }
  else if ( (0 <= porcentajeGeneracionGrupo) && (porcentajeGeneracionGrupo <= 50) ){
    document.getElementById("GRUPOELECTROGENOMeter").className = "fill green"
  }
  else if ( (50 < porcentajeGeneracionGrupo) && (porcentajeGeneracionGrupo <= 70) ){
    document.getElementById("GRUPOELECTROGENOMeter").className = "fill orange"
  }
  else if ( (70 < porcentajeGeneracionGrupo) && (porcentajeGeneracionGrupo <= 100) ){
    document.getElementById("GRUPOELECTROGENOMeter").className = "fill red"
  }

  //CARGO DATOS MÁS DETALLE

  document.getElementById("valorRendimientoGrupo").innerHTML = jsonObjGrupoElectrogeno.GeneratorPerformance.Value + " " + jsonObjGrupoElectrogeno.GeneratorPerformance.Unit

  document.getElementById("etiquetaporcentajeDepositoGrupo").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CurrentGeneratorTankPercentage") 
  document.getElementById("porcentajeDepositoGrupo").innerHTML = jsonObjGrupoElectrogeno.CurrentGeneratorTankPercentage.Value.split(".")[0] + " " + jsonObjGrupoElectrogeno.CurrentGeneratorTankPercentage.Unit    

  document.getElementById("etiquetaGeneratorMaxGeneration").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("GeneratorMaxGeneration") 
  document.getElementById("valorGeneratorMaxGeneration").innerHTML = jsonObjGrupoElectrogeno.GeneratorMaxGeneration.Value + " " + jsonObjGrupoElectrogeno.GeneratorMaxGeneration.Unit
  
  document.getElementById("etiquetaCombustiblePrice").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CombustiblePrice") 
  
  if(jsonObjGrupoElectrogeno.CombustiblePrice.Value !== ""){
    document.getElementById("valorCombustiblePrice").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjGrupoElectrogeno.CombustiblePrice.Value) + " " + jsonObjGrupoElectrogeno.CombustiblePrice.Unit
  }
  else{
    document.getElementById("valorCombustiblePrice").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjGrupoElectrogeno.DailyCombustiblePrice.Value).toFixed(2)) + " " + jsonObjGrupoElectrogeno.DailyCombustiblePrice.Unit + " (Media nacional)"
  }
  
  
  document.getElementById("etiquetaGeneratorTankCapacity").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("GeneratorTankCapacity") 
  document.getElementById("valorGeneratorTankCapacity").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjGrupoElectrogeno.GeneratorTankCapacity.Value) + " " + jsonObjGrupoElectrogeno.GeneratorTankCapacity.Unit

  document.getElementById("etiquetaCurrentGeneratorTankLevel").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CurrentGeneratorTankLevel") 
  document.getElementById("valorCurrentGeneratorTankLevel").innerHTML = new Intl.NumberFormat('en-DE').format(jsonObjGrupoElectrogeno.CurrentGeneratorTankLevel.Value) + " " + jsonObjGrupoElectrogeno.CurrentGeneratorTankLevel.Unit
  
  document.getElementById("valorWorkingTimeAccumulatedFromDate").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjGrupoElectrogeno.WorkingTimeAccumulatedFromDate.Value).toFixed(2)) + " " + jsonObjGrupoElectrogeno.WorkingTimeAccumulatedFromDate.Unit +" de trabajo"  
  
  document.getElementById("etiquetaCurrentGeneratorLitersConsumption").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CurrentGeneratorLitersConsumption") 
  document.getElementById("valorCurrentGeneratorLitersConsumption").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjGrupoElectrogeno.CurrentGeneratorLitersConsumption.Value).toFixed(2)) + " " + jsonObjGrupoElectrogeno.CurrentGeneratorLitersConsumption.Unit

  document.getElementById("etiquetaCurrentGeneratorConsumptionCost").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CurrentGeneratorConsumptionCost") 
  document.getElementById("valorCurrentGeneratorConsumptionCost").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonObjGrupoElectrogeno.CurrentGeneratorConsumptionCost.Value).toFixed(2)) + " " + jsonObjGrupoElectrogeno.CurrentGeneratorConsumptionCost.Unit

  document.getElementById("etiquetaGeneralWhGeneratorGenerationP1").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("GeneralWhGeneratorGenerationP1") 
  document.getElementById("valorGeneralWhGeneratorGenerationP1").innerHTML = jsonObjGrupoElectrogeno.GeneralWhGeneratorGenerationP1.Value + " " + jsonObjGrupoElectrogeno.GeneralWhGeneratorGenerationP1.Unit

  document.getElementById("etiquetaGeneralWhGeneratorGenerationP2").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("GeneralWhGeneratorGenerationP2") 
  document.getElementById("valorGeneralWhGeneratorGenerationP2").innerHTML = jsonObjGrupoElectrogeno.GeneralWhGeneratorGenerationP2.Value + " " + jsonObjGrupoElectrogeno.GeneralWhGeneratorGenerationP2.Unit

  document.getElementById("etiquetaGeneralWhGeneratorGenerationP3").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("GeneralWhGeneratorGenerationP3") 
  document.getElementById("valorGeneralWhGeneratorGenerationP3").innerHTML = jsonObjGrupoElectrogeno.GeneralWhGeneratorGenerationP3.Value + " " + jsonObjGrupoElectrogeno.GeneralWhGeneratorGenerationP3.Unit

  if(jsonObjGrupoElectrogeno.GeneratorType === "MONOFASICO"){
    document.getElementById("liGeneracionFase2Grupo").className = document.getElementById("liGeneracionFase2Grupo").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("liGeneracionFase3Grupo").className = document.getElementById("liGeneracionFase3Grupo").className.replaceAll(" hidden", "") + " hidden"
  }
  


}

exports.cargarWidgetCoche = function(jsonObjCoche){

    //CARGO DATOS BÁSICOS
    document.getElementById("valorChargeLevel").innerHTML = jsonObjCoche[0].ChargeLevel.Value + " " + jsonObjCoche[0].ChargeLevel.Unit    
    document.getElementById("valorChargeStatus").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo(jsonObjCoche[0].ChargeStatus)

    document.getElementById("valorRemainingChargeTime").innerHTML = jsonObjCoche[0].RemainingChargeTime.Value + " " + jsonObjCoche[0].RemainingChargeTime.Unit

    module.exports.gestionarBotonesEstadoCoche(jsonObjCoche[0].ChargeStatus)

    document.getElementById("valorUpdateTime").innerHTML = module.exports.formatearAFechaHoraCortaDashboard(jsonObjCoche[0].UpdateTime, "String")

    var nivelCargaActualCoche = parseInt(jsonObjCoche[0].ChargeLevel.Value.replace(".",""))

    document.getElementById("COCHEMeter").min = "0"
    document.getElementById("COCHEMeter").max = "100"
    document.getElementById("COCHEMeter").value = nivelCargaActualCoche

    if ( (0 <= nivelCargaActualCoche) && (nivelCargaActualCoche <= 20) ){
      document.getElementById("COCHEMeter").className = "red"
    }
    else if ( (20 < nivelCargaActualCoche) && (nivelCargaActualCoche <= 50) ){
      document.getElementById("COCHEMeter").className = "orange"
    }
    else if ( (50 < nivelCargaActualCoche) && (nivelCargaActualCoche <= 100) ){
      document.getElementById("COCHEMeter").className = "green"
    }

    if( (jsonObjCoche[0].ChargeStatus === "Starting") || (jsonObjCoche[0].ChargeStatus === "Charging") ){
      document.getElementById("COCHEMeter").className += " charging"
      module.exports.actualizarDatosCoche("silencioso")
      console.log("Actualizo datos coche")
    }
    else{ // Si está en iddle no pongo nada
      document.getElementById("COCHEMeter").className += ""
    }

    //CARGO DATOS MÁS DETALLE
    document.getElementById("etiquetaAutonomy").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("Autonomy") 
    document.getElementById("valorAutonomy").innerHTML = jsonObjCoche[0].Autonomy.Value + " " + jsonObjCoche[0].Autonomy.Unit

    document.getElementById("etiquetaMaximumChargeAmperage").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("MaximumChargeAmperage") 
    document.getElementById("valorMaximumChargeAmperage").innerHTML = jsonObjCoche[0].MaximumChargeAmperage.Value + " " + jsonObjCoche[0].MaximumChargeAmperage.Unit

    document.getElementById("etiquetaCurrentChargeLimit").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CurrentChargeLimit") 
    document.getElementById("valorCurrentChargeLimit").innerHTML = jsonObjCoche[0].CurrentChargeLimit.Value + " " + jsonObjCoche[0].CurrentChargeLimit.Unit

    document.getElementById("etiquetaChargePower").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("ChargePower") 
    document.getElementById("valorChargePower").innerHTML = jsonObjCoche[0].ChargePower.Value + " " + jsonObjCoche[0].ChargePower.Unit

    document.getElementById("etiquetaCarName").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CarName") 
    document.getElementById("valorCarName").innerHTML = jsonObjCoche[0].CarName

    if(jsonObjCoche[0].CarName === "N/A"){
      initialConfigCommonJS.mostrarMensajeInformativo("Estoy teniendo problemas para cargar la información del COCHE, por favor revisa que tenga conectividad y que funcione correctamente.","negative")
    }

    document.getElementById("etiquetaCarLatitude").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CarLatitude") 
    document.getElementById("etiquetaCarLongitude").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("CarLongitude") 
    
    var latitudCoche = jsonObjCoche[0].CarLatitude.Value
    var longitudCoche = jsonObjCoche[0].CarLongitude.Value

    if( (latitudCoche !== "0.0") && (longitudCoche !== "0.0") ){
      document.getElementById("valorCarLatitude").innerHTML = latitudCoche + " " + jsonObjCoche[0].CarLatitude.Unit  
      document.getElementById("valorCarLongitude").innerHTML = longitudCoche + " " + jsonObjCoche[0].CarLongitude.Unit
    }
    else{
      document.getElementById("valorCarLatitude").innerHTML = "No disponible"
      document.getElementById("valorCarLongitude").innerHTML = "No disponible"
    }  

    document.getElementById("etiquetaChargeVoltage").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("ChargeVoltage") 
    document.getElementById("valorChargeVoltage").innerHTML = jsonObjCoche[0].ChargeVoltage.Value + " " + jsonObjCoche[0].ChargeVoltage.Unit

    document.getElementById("etiquetaChargeAmperage").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("ChargeAmperage") 
    document.getElementById("valorChargeAmperage").innerHTML = jsonObjCoche[0].ChargeAmperage.Value + " " + jsonObjCoche[0].ChargeAmperage.Unit
    
    if(jsonObjCoche[0].ChargeAmperage.Value !== "0"){
      document.getElementById("amperajeCarga").value = jsonObjCoche[0].ChargeAmperage.Value
      document.getElementById("ddTiempoRestanteCarga").className = document.getElementById("ddTiempoRestanteCarga").className.replace(" hidden", "")
    }
    else{
      document.getElementById("amperajeCarga").value = 5
      document.getElementById("ddTiempoRestanteCarga").className += " hidden"      
    }

    document.getElementById("etiquetaChargeLatchStatus").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("ChargeLatchStatus") 
    
    if(initialConfigCommonJS.obtenerLiteralAtributo(jsonObjCoche[0].ChargeLatchStatus) !== ""){
      document.getElementById("valorChargeLatchStatus").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo(jsonObjCoche[0].ChargeLatchStatus)
    }
    else{
      document.getElementById("valorChargeLatchStatus").innerHTML = jsonObjCoche[0].ChargeLatchStatus
    }
    
    if(jsonObjCoche[0].ChargeType.Value === "None"){
      document.getElementById("liEtiquetaChargeType").className = document.getElementById("liEtiquetaChargeType").className.replaceAll(" hidden", "") + " hidden"
    }
    else{
      document.getElementById("liEtiquetaChargeType").className = document.getElementById("liEtiquetaChargeType").className.replaceAll(" hidden", "")
      document.getElementById("etiquetaChargeType").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo("ChargeType") 
      document.getElementById("valorChargeType").innerHTML = jsonObjCoche[0].ChargeType.Value + " " + jsonObjCoche[0].ChargeType.Unit
    }

    //Carga dinamica
    if ( (localStorage.getItem("lastDashboardData")!== null) && (Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).FVData).length > 0) && (JSON.parse(localStorage.getItem("lastDashboardData")).CarsData[0].ChargesInInstallation === "true") ){
      document.getElementById("idFieldsetautomaticCharge").className = document.getElementById("idFieldsetautomaticCharge").className.replaceAll(" hidden", "")   
      
      if( (JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyGridConnected === "false") && (Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).BatteriesData).length === 0) ){ //Si está desconectado y sin baterías lo oculto
          document.getElementById("idFieldsetautomaticCharge").className = document.getElementById("idFieldsetautomaticCharge").className.replaceAll(" hidden", "") + " hidden"        
      }
    }
    else{
        document.getElementById("idFieldsetautomaticCharge").className = document.getElementById("idFieldsetautomaticCharge").className.replaceAll(" hidden", "") + " hidden"        
    }    

    if(document.getElementById("automaticCharge") !== null){

      if(jsonObjCoche[0].DynamicChargeStatus === "true"){

        console.log("activo carga dinamica")
        document.getElementById("automaticCharge").checked = true        
        document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "") + " hidden"

        try{

          var jsonObjDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))

          if(jsonObjCoche[0].ChargesInInstallation === "true"){
            console.log("Coche carga en instalación")            

            var latitudInstalacion = jsonObjDashboard.MeteoData.InstallationLatitude.substring(0,4)
            var longitudInstalacion = jsonObjDashboard.MeteoData.InstallationLongitude.substring(0,4)
            latitudCoche = jsonObjCoche[0].CarLatitude.Value.substring(0,4)
            longitudCoche = jsonObjCoche[0].CarLongitude.Value.substring(0,4)

            if( (latitudInstalacion !== latitudCoche) || (longitudInstalacion !== longitudCoche) ){
              document.getElementById("mensajeInformativoCocheFueraInstalacion").className = document.getElementById("mensajeInformativoCocheFueraInstalacion").className.replaceAll(" hidden", "")
            }
            else{
              document.getElementById("mensajeInformativoCocheFueraInstalacion").className = document.getElementById("mensajeInformativoCocheFueraInstalacion").className.replaceAll(" hidden", "") + " hidden"
            }

          }
          else{
            console.log("Coche NO carga en instalación")            
          }
        }
        catch(error){console.log(error)}

      }
      else{
        console.log("Desactivo carga dinamica")
        document.getElementById("automaticCharge").checked = false        

        try{
          if(jsonObjCoche[0].ChargesInInstallation === "true"){
            document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "")
          }
          else{
            document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "") + " hidden"
          }
        }
        catch(error){}

      }
    }

}

exports.actualizarTarifasDiarias = function(){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  document.getElementById("loaderTarifasDiarias").className = document.getElementById("loaderTarifasDiarias").className.replaceAll(" hidden", "")

  //Petición de datos   
  var jsonPeticion = {
    "accountID": localStorage.getItem("accountID"),
    "installationID": localStorage.getItem("installationId")    
  }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postRetrieveDailyFees, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }          
        else{ 
          // Aquí cargo y muestro las tarifas
          
          var hora = new Date().getHours();

          if(hora > 9){
            hora=hora.toString()
          }
          else{
            hora="0"+hora.toString()
          }          

          document.getElementById("spanHora"+hora).style="color: aqua; font-weight: bold"

          var unidad = jsonRespuesta.body.Unidad          
          var tarifas = jsonRespuesta.body.Tarifas
          var mejoresTarifas = jsonRespuesta.body.HorasMejoresTarifas
          var peoresTarifas = jsonRespuesta.body.HorasPeoresTarifas
          
          for(var x=0; x<tarifas.length; x++){

            document.getElementById("spanTarifaCompra"+tarifas[x].Hora).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(tarifas[x].Compra).toFixed(3)) + " " + unidad
            document.getElementById("spanTarifaVenta"+tarifas[x].Hora).innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(tarifas[x].Venta).toFixed(3)) + " " + unidad

            if( parseFloat(mejoresTarifas.Compra).toFixed(3) !== parseFloat(peoresTarifas.Compra).toFixed(3) ){
              if(parseFloat(tarifas[x].Compra).toFixed(3) === parseFloat(mejoresTarifas.Compra).toFixed(3) ){
                document.getElementById("spanTarifaCompra"+tarifas[x].Hora).style="color: lime"
              }

              if(parseFloat(tarifas[x].Compra).toFixed(3) === parseFloat(peoresTarifas.Compra).toFixed(3) ){
                document.getElementById("spanTarifaCompra"+tarifas[x].Hora).style="color: red"
              }
            }

            if( parseFloat(mejoresTarifas.Venta).toFixed(3) !== parseFloat(peoresTarifas.Venta).toFixed(3) ){
              if( parseFloat(tarifas[x].Venta).toFixed(3) === parseFloat(mejoresTarifas.Venta).toFixed(3) ){
                document.getElementById("spanTarifaVenta"+tarifas[x].Hora).style="color: lime"
              }

              if( parseFloat(tarifas[x].Venta).toFixed(3) === parseFloat(peoresTarifas.Venta).toFixed(3) ){
                document.getElementById("spanTarifaVenta"+tarifas[x].Hora).style="color: red"
              }           
            }

            if(tarifas[x].Venta !== "N/A"){
              document.getElementById("tdTituloVentaTarifaMedia").className = document.getElementById("tdTituloVentaTarifaMedia").className.replaceAll(" hidden", "")
              document.getElementById("tdTarifaMediaVenta").className = document.getElementById("tdTarifaMediaVenta").className.replaceAll(" hidden", "")              
              document.getElementById("tdTarifaVenta"+tarifas[x].Hora).className = document.getElementById("tdTarifaVenta"+tarifas[x].Hora).className.replaceAll(" hidden", "")              
            }
            else{
              document.getElementById("tdTituloVentaTarifaMedia").className = document.getElementById("tdTituloVentaTarifaMedia").className.replaceAll(" hidden", "") + " hidden"
              document.getElementById("tdTarifaMediaVenta").className = document.getElementById("tdTarifaMediaVenta").className.replaceAll(" hidden", "") + " hidden"              
              document.getElementById("tdTarifaVenta"+tarifas[x].Hora).className = document.getElementById("tdTarifaVenta"+tarifas[x].Hora).className.replaceAll(" hidden", "") + " hidden"
            }

          }

        }

      }

      if (this.readyState === 4 && this.status !== 200) { 
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)                  
      }

      document.getElementById("loaderTarifasDiarias").className = document.getElementById("loaderTarifasDiarias").className.replaceAll(" hidden", "") + " hidden"

    }
    xhttp.send(data);  

}

exports.mostrarDetalleWidget = function(widget,setObjWeekForecastUpdateTimestamp,setObjGraphUpdateTimestamp, ReactGA){

  try{    

    if(widget !== "CHAT"){    
      document.getElementById("figureDetalleWidget").innerHTML = '<span id="iconoDetalleWidget" class="material-icon">devices_other</span>'
    }    

    var camposWidget = ""
    var accesoDirectoWidget = ""
    
    if(localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
      camposWidget = widget.split("|")
      widget = camposWidget[0]      
    }else{
      camposWidget = widget.split("|")
      widget = camposWidget[0]
      accesoDirectoWidget = camposWidget[1]
    }

    document.getElementById("figureDetalleMeteo").className = "hidden"
    document.getElementById("figureDetalleWidget").className = "hidden"

    document.getElementById("detalleMETEO").className = "hidden"
    document.getElementById("detallePrevision7Dias").className = "hidden"
    document.getElementById("detalleINSTALACION").className = "hidden"
    document.getElementById("detalleACTIVIDAD_INSTALACION").className = "hidden"
    document.getElementById("detalleFV").className = "hidden"
    document.getElementById("detalleBATERIAS").className = "hidden"
    document.getElementById("detalleGRUPOELECTROGENO").className = "hidden"
    document.getElementById("detalleCOCHE").className = "hidden"
    document.getElementById("detalleAUTOCONSUMO_AHORRO").className = "hidden"
    document.getElementById("detalleTARIFAS").className = "hidden"
    document.getElementById("detalleCHAT").className = "hidden"
    
    document.getElementById("detalle"+widget).className = ""

    if(widget === "METEO"){       
      
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'METEO - Ahora', "", "")
      
      if(document.getElementById("widgetMeteo").className.includes("day")){
        document.getElementById("detalleLateral").className = "modal lateral-detail day"
      }
      else{
        document.getElementById("detalleLateral").className = "modal lateral-detail night"
      }      
      document.getElementById("figureDetalleMeteo").className = "avatar size-xl"
      
      var tipoDispositivoMovil = generalCommonJS.obtenerTipoPlataforma()

      if(tipoDispositivoMovil.includes("Web")){
        document.getElementById("figureDetalleMeteo").innerHTML = document.getElementById("figureAvatarTiempo").innerHTML    
      }
      else{ //Mobile
        document.getElementById("figureDetalleMeteo").innerHTML = '<span class="material-icon">cloud</span>'
      }


      document.getElementById("tituloDetalleWidget").innerHTML = "Meteorología" 
    }
    else if(widget === "Prevision7Dias"){       

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'METEO - Previsión 7 días', "", "")
      
      if(document.getElementById("widgetMeteo").className.includes("day")){
        document.getElementById("detalleLateral").className = "modal lateral-detail day"
      }
      else{
        document.getElementById("detalleLateral").className = "modal lateral-detail night"
      }      
      document.getElementById("figureDetalleMeteo").className = "avatar size-xl"
      document.getElementById("figureDetalleMeteo").innerHTML = '<span class="material-icon">cloud_done</span>'
      document.getElementById("tituloDetalleWidget").innerHTML = "Previsión 7 días" 
      setObjWeekForecastUpdateTimestamp(new Date().getTime())
    }
    else if(widget === "INSTALACION"){ 

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'INSTALACIÓN - Detalle', "", "")

      document.getElementById("detalleLateral").className = "modal lateral-detail green"
      document.getElementById("figureDetalleWidget").className = "avatar size-xl"
      
      document.getElementById("iconoDetalleWidget").innerHTML = module.exports.obtenerIconoInstalacion(localStorage.getItem("installationName").split("*")[0])
            
      document.getElementById("tituloDetalleWidget").innerHTML = "Instalación"  
      module.exports.mostrarPestañaEnergiaInstalacion("pestañaGeneracion")
      setObjGraphUpdateTimestamp(new Date().getTime())
    }
    else if(widget === "ACTIVIDAD_INSTALACION"){ 

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'ACTIVIDAD - Actividad de HOY', "", "")
      
      document.getElementById("detalleLateral").className = "modal lateral-detail"
      document.getElementById("figureDetalleWidget").className = "avatar size-xl green"
      document.getElementById("iconoDetalleWidget").innerHTML = "fact_check"      
      document.getElementById("tituloDetalleWidget").innerHTML = "Actividad"    
      setObjGraphUpdateTimestamp(new Date().getTime())             
    }
    else if(widget === "FV"){ 

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'FV - Detalle', "", "")
      
      document.getElementById("detalleLateral").className = "modal lateral-detail pink" 
      document.getElementById("figureDetalleWidget").className = "avatar size-xl"
      document.getElementById("iconoDetalleWidget").innerHTML = "solar_power"   
      document.getElementById("tituloDetalleWidget").innerHTML = "Paneles solares"   
      
      setObjGraphUpdateTimestamp(new Date().getTime())
    }
    else if(widget === "BATERIAS"){ 
      
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'BATERIAS - Detalle', "", "")
      
      document.getElementById("detalleLateral").className = "modal lateral-detail pink"
      document.getElementById("figureDetalleWidget").className = "avatar size-xl"
      document.getElementById("iconoDetalleWidget").innerHTML = "battery_std"   
      document.getElementById("tituloDetalleWidget").innerHTML = "Baterías"           
      setObjGraphUpdateTimestamp(new Date().getTime())
    }
    else if(widget === "GRUPOELECTROGENO"){ 

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'GRUPO ELECTRÓGENO - Detalle', "", "")
      
      document.getElementById("detalleLateral").className = "modal lateral-detail pink"
      document.getElementById("figureDetalleWidget").className = "avatar size-xl"
      document.getElementById("iconoDetalleWidget").innerHTML = "dynamic_form"   
      document.getElementById("tituloDetalleWidget").innerHTML = "Grupo electrógeno"           
      setObjGraphUpdateTimestamp(new Date().getTime())
    }
    else if(widget === "COCHE"){ 

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'COCHE - Detalle', "", "")

      module.exports.actualizarDatosCoche("silencioso")
      
      document.getElementById("detalleLateral").className = "modal lateral-detail pink"
      document.getElementById("figureDetalleWidget").className = "avatar size-xl"
      document.getElementById("iconoDetalleWidget").innerHTML = "directions_car"   
      document.getElementById("tituloDetalleWidget").innerHTML = "Coche" 
      document.getElementById("detalleCOCHE").className = "vertical gap-08"          
      setObjGraphUpdateTimestamp(new Date().getTime())
    }   
    else if(widget === "AUTOCONSUMO_AHORRO"){

      if(document.getElementById("detalleLateral").className.includes(" hidden")){ //Sólo refresco esta información cuando no se muestra la pestaña

        generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'AUTOCONSUMO Y GASTOS - Detalle', "", "")
        
        document.getElementById("detalleLateral").className = "modal lateral-detail"
        document.getElementById("figureDetalleWidget").className = "avatar size-xl cyan"
        document.getElementById("iconoDetalleWidget").innerHTML = "euro"   
        document.getElementById("tituloDetalleWidget").innerHTML = "Economía" 
        document.getElementById("detalleAUTOCONSUMO_AHORRO").className = "vertical gap-08"   
      
        if(accesoDirectoWidget === "1"){    
          if(Object.keys(JSON.parse(localStorage.getItem("lastDashboardData")).FVData).length > 0){
            module.exports.mostrarPestañaAutoconsumoAhorro("pestañaHoy")
            module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Hoy")
          }
          else{
            module.exports.mostrarPestañaAutoconsumoAhorro("pestañaHoy")
            module.exports.mostrarPestañaAutoconsumoFactura("pestañaFactura","Hoy")
          }      
        }
        else{    
          if( document.getElementById("valorMesPorcentajeReactiva").className.includes("error") ){
            module.exports.mostrarPestañaAutoconsumoAhorro("pestañaMes")
            module.exports.mostrarPestañaAutoconsumoFactura("pestañaFactura","Mes")
          }
          else{
            if( JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyGridConnected === "true" ){
              module.exports.mostrarPestañaAutoconsumoAhorro("pestañaHoy")
              module.exports.mostrarPestañaAutoconsumoFactura("pestañaFactura","Hoy")
            }
            else{           
              module.exports.mostrarPestañaAutoconsumoAhorro("pestañaHoy")
              module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Hoy")
            }
          }
          
        }
      }

    } 
    else if(widget === "TARIFAS"){

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'TARIFAS HOY - Detalle', "", "")

      document.getElementById("detalleLateral").className = "modal lateral-detail cyan"
      document.getElementById("figureDetalleWidget").className = "avatar size-xl"
      document.getElementById("iconoDetalleWidget").innerHTML = "euro"   
      document.getElementById("tituloDetalleWidget").innerHTML = "Tarifas de hoy" 
      document.getElementById("detalleTARIFAS").className = "vertical"          
      
      
      //Aquí llamo al servicio que cargue las tarifas.

      module.exports.actualizarTarifasDiarias()


      setObjGraphUpdateTimestamp(new Date().getTime())

    } 
    else if(widget === "CHAT"){

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'CHAT IA', "", "")

      document.getElementById("detalleLateral").className = "modal lateral-detail cyan"
      document.getElementById("figureDetalleWidget").className = "avatar size-xl"      
      document.getElementById("tituloDetalleWidget").innerHTML = "¿Qué necesitas?" 
      document.getElementById("detalleCHAT").className = "vertical"            

      setObjGraphUpdateTimestamp(new Date().getTime())

    } 

    module.exports.operarDetalleLateral("abrir")
  }
  catch(error){
    console.log(error)
    window.location.reload()
  }


}

exports.mostrarAccionesWidget = function(widget){

  if(document.getElementById(widget).className.includes("flip")){         
    document.getElementById(widget).className = document.getElementById(widget).className.replace(" flip", "")
  }
  else{ 
    document.getElementById(widget).className += " flip"
  }

}

exports.gestionarVisibilidadMenuDetalleWidget = function(event){        
  if ( (document.getElementById("detalleLateral") !== null) && !document.getElementById("detalleLateral").className.includes("hidden") && (event.target.id === "detalleLateral") ){
      module.exports.operarDetalleLateral("cerrar")      
  }
};  

exports.establecerDepositoLleno = function(){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  document.getElementById("botonEstablecerDepositoLleno").className += " loading"
      
  //Petición de datos 
  var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId")}

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
      xhttp.open("PUT", updateTankLevelFull, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
          //Si recibo datos ya configurados lo cargo  

          if(typeof jsonRespuesta.body !== 'undefined'){
              
              document.getElementById("valorCurrentGeneratorTankLevel").innerHTML = document.getElementById("valorGeneratorTankCapacity").innerHTML
              document.getElementById("porcentajeDepositoGrupo").innerHTML = "100 %"
              document.getElementById("etiquetaPorcentajeGrupoGenerando").innerHTML = "100 %"              

              document.getElementById("avisoMensajeLlenadoDepositoGrupo").className = document.getElementById("avisoMensajeLlenadoDepositoGrupo").className.replaceAll(" hidden", "") + " hidden"

              initialConfigCommonJS.mostrarMensajeInformativo("Depósito de combustible establecido al 100% correctamente","positive")
              console.log("Depósito de combustible establecido al 100% correctamente.")              
          }
          }

          document.getElementById("botonEstablecerDepositoLleno").className = document.getElementById("botonEstablecerDepositoLleno").className.replace(" loading", "")

      }
  
      if (this.readyState === 4 && this.status !== 200) {   
          document.getElementById("botonEstablecerDepositoLleno").className = "button primary"   
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
      }
      xhttp.send(data); 

}

exports.mostrarAccionesWidget = function(widget){

  if(document.getElementById(widget).className.includes("flip")){         
      document.getElementById(widget).className = document.getElementById(widget).className.replace(" flip", "")
  }
  else{ 
      document.getElementById(widget).className += " flip"
  }
  
}

exports.actualizarDatosCoche = function(modoActualizacion){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  var comando = "actualizarEstado"
  var valor = "on"

  document.getElementById("botonActualizarDatosCoche").className = document.getElementById("botonActualizarDatosCoche").className.replaceAll(" loading","") + " loading"

  //Petición de datos   
  var jsonPeticion = {
    "accountID": localStorage.getItem("accountID"),
    "installationID": localStorage.getItem("installationId"), 
    "installationName": localStorage.getItem("installationName").split("*")[1], 
    "telegramAccount": "false",
    "marcaDispositivo": JSON.parse(localStorage.getItem("lastDashboardData")).CarsData[0].Application,
    "comando": comando,
    "idDispositivo": "",
    "nuevoEstado": valor
  }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postSmartDeviceCommandRequestURL, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }          
        else{          
          //Si recibo datos ya configurados lo cargo  

          if(typeof jsonRespuesta.body !== 'undefined'){

            //Aqui seteo todos los campos

            module.exports.gestionarBotonesEstadoCoche(jsonRespuesta.body[0].ChargeStatus)

            document.getElementById("valorChargeLevel").innerHTML = jsonRespuesta.body[0].ChargeLevel.Value + " " +jsonRespuesta.body[0].ChargeLevel.Unit
            document.getElementById("valorChargeStatus").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo(jsonRespuesta.body[0].ChargeStatus)
            document.getElementById("valorUpdateTime").innerHTML = module.exports.formatearAFechaHoraCortaDashboard(jsonRespuesta.body[0].UpdateTime, "String")
            document.getElementById("valorCarName").innerHTML = jsonRespuesta.body[0].CarName
            document.getElementById("valorAutonomy").innerHTML = jsonRespuesta.body[0].Autonomy.Value + " " +jsonRespuesta.body[0].Autonomy.Unit
            
            var latitudCoche = jsonRespuesta.body[0].CarLatitude.Value
            var longitudCoche = jsonRespuesta.body[0].CarLongitude.Value

            if( (latitudCoche !== "0.0") && (longitudCoche !== "0.0") ){
              document.getElementById("valorCarLatitude").innerHTML = latitudCoche + " " + jsonRespuesta.body[0].CarLatitude.Unit  
              document.getElementById("valorCarLongitude").innerHTML = longitudCoche + " " + jsonRespuesta.body[0].CarLongitude.Unit              
            }
            else{              
              document.getElementById("valorCarLatitude").innerHTML = "No disponible"
              document.getElementById("valorCarLongitude").innerHTML = "No disponible"
            }
            
            document.getElementById("valorChargeLatchStatus").innerHTML = jsonRespuesta.body[0].ChargeLatchStatus
            document.getElementById("valorCurrentChargeLimit").innerHTML = jsonRespuesta.body[0].CurrentChargeLimit.Value + " " +jsonRespuesta.body[0].CurrentChargeLimit.Unit
            document.getElementById("valorChargeType").innerHTML = jsonRespuesta.body[0].ChargeType.Value + " " +jsonRespuesta.body[0].ChargeType.Unit
            document.getElementById("valorMaximumChargeAmperage").innerHTML = jsonRespuesta.body[0].MaximumChargeAmperage.Value + " " +jsonRespuesta.body[0].MaximumChargeAmperage.Unit
            document.getElementById("valorChargePower").innerHTML = jsonRespuesta.body[0].ChargePower.Value + " " +jsonRespuesta.body[0].ChargePower.Unit
            document.getElementById("valorChargeVoltage").innerHTML = jsonRespuesta.body[0].ChargeVoltage.Value + " " +jsonRespuesta.body[0].ChargeVoltage.Unit
            document.getElementById("valorChargeAmperage").innerHTML = jsonRespuesta.body[0].ChargeAmperage.Value + " " +jsonRespuesta.body[0].ChargeAmperage.Unit
            document.getElementById("amperajeCarga").value = jsonRespuesta.body[0].ChargeAmperage.Value   
            document.getElementById("valorRemainingChargeTime").innerHTML = jsonRespuesta.body[0].RemainingChargeTime.Value + " " +jsonRespuesta.body[0].RemainingChargeTime.Unit

            if(jsonRespuesta.body[0].RemainingChargeTime.Value === "0"){ document.getElementById("ddTiempoRestanteCarga").className += " hidden" }
            else{ document.getElementById("ddTiempoRestanteCarga").className = document.getElementById("ddTiempoRestanteCarga").className.replace(" hidden", "")}

            if(modoActualizacion !== "silencioso"){
              initialConfigCommonJS.mostrarMensajeInformativo("Información del coche actualizada correctamente","positive")
            }

            try{
              
              var jsonObjDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))

              if(jsonObjDashboard.CarsData[0].DynamicChargeStatus === "true"){

                document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "") + " hidden"

                if(jsonObjDashboard.CarsData[0].ChargesInInstallation === "true"){
                  
                  console.log("Coche carga en instalación")                  
      
                  var latitudInstalacion = jsonObjDashboard.MeteoData.InstallationLatitude.substring(0,4)
                  var longitudInstalacion = jsonObjDashboard.MeteoData.InstallationLongitude.substring(0,4)
                  latitudCoche = jsonRespuesta.body[0].CarLatitude.Value.substring(0,4)
                  longitudCoche = jsonRespuesta.body[0].CarLongitude.Value.substring(0,4)
      
                  if( (latitudInstalacion !== latitudCoche) || (longitudInstalacion !== longitudCoche) ){
                    document.getElementById("mensajeInformativoCocheFueraInstalacion").className = document.getElementById("mensajeInformativoCocheFueraInstalacion").className.replaceAll(" hidden", "")
                  }
                  else{
                    document.getElementById("mensajeInformativoCocheFueraInstalacion").className = document.getElementById("mensajeInformativoCocheFueraInstalacion").className.replaceAll(" hidden", "") + " hidden"
                  }
      
                }
                else{
                  console.log("Coche NO carga en instalación")                  
                }
              }              
              else{
                console.log("Desactivo carga dinamica")
                document.getElementById("automaticCharge").checked = false        

                try{
                  if(jsonObjDashboard.CarsData[0].ChargesInInstallation === "true"){
                    document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "")
                  }
                  else{
                    document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "") + " hidden"
                  }
                }
                catch(error){}
              }
            }            
            catch(error){console.log(error)}
            
            console.log("Información del coche actualizada correctamente.")

          }
          else{
            if(modoActualizacion !== "silencioso"){
              initialConfigCommonJS.mostrarMensajeInformativo("No se pudo actualizar la información del coche, es probablemente que esté dormido. Prueba de nuevo en unos segundos.","negative")
            }            
            console.log("No se pudo actualizar la información del coche.")
          }
        }

        document.getElementById("botonActualizarDatosCoche").className = document.getElementById("botonActualizarDatosCoche").className.replace(" loading", "")

      }

      if (this.readyState === 4 && this.status !== 200) { 

        document.getElementById("botonActualizarDatosCoche").className = "link"
             
        if( (this.status === 504) || (this.status === 502) ){
          if(modoActualizacion !== "silencioso"){
            initialConfigCommonJS.mostrarMensajeInformativo("No se puedo actualizar la información porque los sistemas de TESLA están con mucha carga, inténtalo de nuevo.","negative")
          }
        }
        else{
          if(modoActualizacion !== "silencioso"){
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
      }
    }
    xhttp.send(data); 

}

exports.gestionarBotonesEstadoCoche = function(estadoCarga){

  try{
    if( (estadoCarga === "Cargando") || (estadoCarga === "Comenzando") ){
      document.getElementById("fieldsetAmperajeCarga").className = document.getElementById("fieldsetAmperajeCarga").className.replaceAll(" hidden", "")
      document.getElementById("iniciarCargaCoche").className += " hidden"
      document.getElementById("iniciarCargaCoche").disabled = true
      document.getElementById("pararCargaCoche").className = document.getElementById("pararCargaCoche").className.replace(" hidden", "")
      document.getElementById("pararCargaCoche").disabled = false
      document.getElementById("amperajeCarga").disabled = false
    }
    else if( (estadoCarga === "Completada") || (estadoCarga === "Desconectado") ){
      document.getElementById("fieldsetAmperajeCarga").className = document.getElementById("fieldsetAmperajeCarga").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("iniciarCargaCoche").className = document.getElementById("iniciarCargaCoche").className.replace(" hidden", "") 
      document.getElementById("iniciarCargaCoche").disabled = true
      document.getElementById("pararCargaCoche").className += " hidden"
      document.getElementById("pararCargaCoche").disabled = true
      document.getElementById("amperajeCarga").disabled = true   
    }
    else{
      document.getElementById("fieldsetAmperajeCarga").className = document.getElementById("fieldsetAmperajeCarga").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("iniciarCargaCoche").className = document.getElementById("iniciarCargaCoche").className.replace(" hidden", "") 
      document.getElementById("iniciarCargaCoche").disabled = false
      document.getElementById("pararCargaCoche").className += " hidden"
      document.getElementById("pararCargaCoche").disabled = true
      document.getElementById("amperajeCarga").disabled = true        
    }
  }catch(error){console.log(error)}
}

exports.ejecutarComandoCoche = function(comando, valor){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")    
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  if(comando === "iniciarCarga"){
    document.getElementById("iniciarCargaCoche").className = "button primary loading"      
  }
  else if(comando === "pararCarga"){
    document.getElementById("pararCargaCoche").className = "button primary loading"      
  }    

  if( (comando === "iniciarCarga") || (comando === "pararCarga") || ((comando === "modificarAmperajeCarga") && (valor !== "")) ){
  
    //Petición de datos 
    var jsonPeticion = {
        "accountID": localStorage.getItem("accountID"),
        "installationID": localStorage.getItem("installationId"), 
        "installationName": localStorage.getItem("installationName").split("*")[1], 
        "telegramAccount": "false",
        "marcaDispositivo": JSON.parse(localStorage.getItem("lastDashboardData")).CarsData[0].Application,
        "comando": comando,
        "idDispositivo": "",
        "nuevoEstado": valor
    }

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postSmartDeviceCommandRequestURL, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)

            if(typeof jsonRespuesta.responseMessage !== 'undefined'){              
              console.log(jsonRespuesta)
              if(jsonRespuesta.statusCode === "200"){
                initialConfigCommonJS.mostrarMensajeInformativo(jsonRespuesta.responseMessage,"positive")
                module.exports.actualizarDatosCoche("widget")

                //Para evitar el "delay visual" actualizo los botones hasta el siguiente refresco
                if(comando === "iniciarCarga"){
                  module.exports.gestionarBotonesEstadoCoche("Charging")
                  document.getElementById("ddTiempoRestanteCarga").className = document.getElementById("ddTiempoRestanteCarga").className.replaceAll(" hidden", "")
                }
                else if(comando === "pararCargaCoche"){
                  module.exports.gestionarBotonesEstadoCoche("Stopped")
                  document.getElementById("ddTiempoRestanteCarga").className += " hidden"
                }
              }
              else{                
                initialConfigCommonJS.mostrarMensajeInformativo("No se pudo ejecutar el comando del coche, es probablemente que esté dormido. Prueba de nuevo en unos segundos.","negative")
                console.log("No se pudo ejecutar el comando del coche.")
              }
              
              console.log("Comando del coche ejecutado correctamente.")

            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo("No se pudo ejecutar el comando del coche, es probablemente que esté dormido. Prueba de nuevo en unos segundos.","negative")
              console.log("No se pudo ejecutar el comando del coche.")
            }
          
            if(comando === "iniciarCarga"){
              document.getElementById("iniciarCargaCoche").className = "button primary"      
            }
            else if(comando === "pararCarga"){
              document.getElementById("pararCargaCoche").className = "button primary"      
            }

        }
  
        if (this.readyState === 4 && this.status !== 200) {   
          
          if(this.status === 502){
            initialConfigCommonJS.mostrarMensajeInformativo("No se pudo ejecutar el comando del coche, es probablemente que esté dormido. Prueba de nuevo en unos segundos.","negative")
            console.log("No se pudo ejecutar el comando del coche.")
          }
          else{
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }

          if(comando === "iniciarCarga"){
            document.getElementById("iniciarCargaCoche").className = "button primary"      
          }
          else if(comando === "pararCarga"){
            document.getElementById("pararCargaCoche").className = "button primary"      
          }                    
          
        }
      }
      xhttp.send(data); 
  }
}

exports.setearCargaDinamica = function(estado){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  document.getElementById("automaticCharge").setAttribute("loading", "")

  //Petición de datos para el paso actual
  var jsonPeticion = { "accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"), "status": estado }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postManageDynamicCarCharge, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{                              
          if(estado === "on"){
            document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "") + " hidden"
          }
          else{
            document.getElementById("divBotoneraAccionesCoche").className = document.getElementById("divBotoneraAccionesCoche").className.replaceAll(" hidden", "")
          }
          
          document.getElementById("automaticCharge").removeAttribute("loading")
          console.log("Carga dinámica actualizada correctamente.")
        }
      }

      if (this.readyState === 4 && this.status !== 200) {      
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data);       
}

exports.actualizarCargaDinamica = function(){
  try{
    if(document.getElementById("automaticCharge").checked === true){            
      module.exports.setearCargaDinamica("on")
    }
    else{            
      module.exports.setearCargaDinamica("off")
    }
  }
  catch(error){console.log(error)}

}

exports.setearCargaNocturnaBateriasDinamica = function(estado){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  document.getElementById("cargaNocturnaBaterias").setAttribute("loading", "")

  //Petición de datos para el paso actual
  var jsonPeticion = { "accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"), "status": estado }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postManageDynamicBatteriesNightCharge, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{     
          document.getElementById("cargaNocturnaBaterias").removeAttribute("loading")
          console.log("Carga dinámica actualizada correctamente.")
        }
      }

      if (this.readyState === 4 && this.status !== 200) {      
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data);       
}

exports.actualizarModoTOU = function(){
  try{
    if(document.getElementById("cargaNocturnaBaterias").checked === true){            
      module.exports.setearCargaNocturnaBateriasDinamica("on")
    }
    else{            
      module.exports.setearCargaNocturnaBateriasDinamica("off")
    }
  }
  catch(error){console.log(error)}

}

exports.actualizarCargaBateriasDesdeRed = function(){
  
  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  document.getElementById("cargaBateriasDesdeLaRed").setAttribute("loading", "")

  //Petición de datos para el paso actual
  
  var jsonDashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))

  var nombreInstalacion = localStorage.getItem("installationName").split("*")[1]
  var marcaDispositivo = jsonDashboardData.BatteriesData.Application
  var idDispositivo = jsonDashboardData.BatteriesData.BatteryId

  var nuevoEstado = ""

  //Es un checkbox
  if(document.getElementById("cargaBateriasDesdeLaRed").checked == true){
    nuevoEstado = "true"
  }
  else{
    nuevoEstado = "false"
  }

  var jsonPeticion = { "accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"),"installationName":nombreInstalacion ,"telegramAccount":"false","marcaDispositivo":marcaDispositivo,"comando":"modificarCargaBateriasDeRed","idDispositivo":idDispositivo,"nuevoEstado":nuevoEstado}
  
  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postSmartDeviceCommandRequestURL, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{     
          document.getElementById("cargaBateriasDesdeLaRed").removeAttribute("loading")
          console.log("Carga de baterías desde la red actualizada correctamente.")
        }
      }

      if (this.readyState === 4 && this.status !== 200) {      
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data);
  
         
}

exports.formatearAFechaHoraCorta = function(fecha, formato){
  
  //Formato fecha entrada "UTC": "2022-09-18T07:21:03"
  //Formato fecha entrada "String": "Wed, 14 Sep 2022 19:50:21"
  
  var tzoffset = (new Date(fecha)).getTimezoneOffset() * 60000; //offset in milliseconds  
  var localISOTime = ""
  
  if ( formato === "UTC"){
    localISOTime = fecha.slice(0, 16).replace('T', ' ').replaceAll('-', '/')
  }
  else{
    localISOTime = (new Date(Date.parse(fecha) - tzoffset)).toISOString().slice(0, 16).replace('T', ' ').replaceAll('-', '/');
  }
  

  var elementosISOTime = localISOTime.split(" ")
  var elementosFecha = elementosISOTime[0].split("/")
  var fechaFinal = elementosISOTime[1]+ " - "+ elementosFecha[2]+"/"+elementosFecha[1]+"/"+elementosFecha[0].slice(0, 4)

  return fechaFinal
}

exports.formatearAFechaHoraCortaDashboard = function(fecha, formato){
  
  //Formato fecha entrada "UTC": "2022-09-18T07:21:03"
  //Formato fecha entrada "String": "Wed, 14 Sep 2022 19:50:21"
  
  var tzoffset = (new Date(fecha)).getTimezoneOffset() * 60000; //offset in milliseconds  
  var localISOTime = ""
  
  if ( formato === "UTC"){
    localISOTime = fecha.slice(0, 16).replace('T', ' ').replaceAll('-', '/')
  }
  else{
    localISOTime = (new Date(Date.parse(fecha) - tzoffset)).toISOString().slice(0, 16).replace('T', ' ').replaceAll('-', '/');
  }
  
  var elementosISOTime = localISOTime.split(" ")
  var elementosFecha = elementosISOTime[0].split("/")
  var fechaFinal = elementosISOTime[1]+ " - "+ elementosFecha[2]

  if(parseInt(elementosFecha[1]) === 1){fechaFinal = fechaFinal + " Ene"}
  else if(parseInt(elementosFecha[1]) === 2){fechaFinal = fechaFinal + " Feb"}
  else if(parseInt(elementosFecha[1]) === 3){fechaFinal = fechaFinal + " Mar"}
  else if(parseInt(elementosFecha[1]) === 4){fechaFinal = fechaFinal + " Abr"}
  else if(parseInt(elementosFecha[1]) === 5){fechaFinal = fechaFinal + " May"}
  else if(parseInt(elementosFecha[1]) === 6){fechaFinal = fechaFinal + " Jun"}
  else if(parseInt(elementosFecha[1]) === 7){fechaFinal = fechaFinal + " Jul"}
  else if(parseInt(elementosFecha[1]) === 8){fechaFinal = fechaFinal + " Ago"}
  else if(parseInt(elementosFecha[1]) === 9){fechaFinal = fechaFinal + " Sep"}
  else if(parseInt(elementosFecha[1]) === 10){fechaFinal = fechaFinal + " Oct"}
  else if(parseInt(elementosFecha[1]) === 11){fechaFinal = fechaFinal + " Nov"}
  else if(parseInt(elementosFecha[1]) === 12){fechaFinal = fechaFinal + " Dic"}

  return fechaFinal
}

exports.formatearAFechaCorta = function(fecha){

  //Formato fecha entrada: "2022-09-18T07:21:03"

  var tzoffset = (new Date(fecha)).getTimezoneOffset() * 60000; //offset in milliseconds
  var localISOTime = (new Date(Date.parse(fecha) - tzoffset)).toISOString().slice(0, 16).replace('T', ' ').replaceAll('-', '/');

  var elementosISOTime = localISOTime.split(" ")
  var elementosFecha = elementosISOTime[0].split("/")
  var fechaFinal = elementosFecha[2]+"/"+elementosFecha[1]+"/"+elementosFecha[0].slice(0, 4)

  return fechaFinal
}

exports.obtenerNombreMes = function(numeroMes){

  var nombreMes = ""

  numeroMes = parseInt(numeroMes)

  if(numeroMes === 1){ nombreMes = "Enero" }
  else if(numeroMes === 2){ nombreMes = "Febrero" }
  else if(numeroMes === 3){ nombreMes = "Marzo" }
  else if(numeroMes === 4){ nombreMes = "Abril" }
  else if(numeroMes === 5){ nombreMes = "Mayo" }
  else if(numeroMes === 6){ nombreMes = "Junio" }
  else if(numeroMes === 7){ nombreMes = "Julio" }
  else if(numeroMes === 8){ nombreMes = "Agosto" }
  else if(numeroMes === 9){ nombreMes = "Septiembre" }
  else if(numeroMes === 10){ nombreMes = "Octubre" }
  else if(numeroMes === 11){ nombreMes = "Noviembre" }
  else if(numeroMes === 12){ nombreMes = "Diciembre" }

  return nombreMes
}

exports.comprobarHoy = function(fecha){

  var fechaEsHoy = false

  var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
  var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, 16).replace('T', ' ')

  var elementosISOTime = localISOTime.split(" ")
  
  var fechaHoy = elementosISOTime[0]
  var fechaParametro = fecha.substring(0,10)
  
  if(fechaParametro === fechaHoy){
    fechaEsHoy = true
  }

  return fechaEsHoy
}

exports.obtenerNombreDiaDeLaSemana = function(numeroDia){

  const dia = [    
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo'
  ];  

  return dia[parseInt(numeroDia)-1]
}

exports.obtenerDiaDeLaSemana = function(fecha){
  var tzoffset = (new Date(fecha)).getTimezoneOffset() * 60000; //offset in milliseconds
  var dateFecha = (new Date(Date.parse(fecha) - tzoffset))
  
  const dia = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ];  

  return dia[dateFecha.getDay()]
}

exports.operarDetalleLateral = function(accion){  

    if(accion === "abrir"){
      document.getElementById("detalleLateral").className = document.getElementById("detalleLateral").className.replaceAll("hidden", "")
    }else{      
      document.getElementById("detalleLateral").className = document.getElementById("detalleLateral").className.replaceAll("hidden", "") + " hidden"
    }
    
}

exports.operarMenuDispositivos = function(accion, setObjDevicesUpdateTimestamp, ReactGA){
    
    if(accion === "abrir"){
      
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CUADRO DE MANDO', 'DISPOSITIVOS - Listado', "", "")

      //Con esto precaliento la lambda para mitigar doble coldstart de postSmartDeviceCommand y postXXXCommand                    
      module.exports.precalentarLambda("postSmartDeviceCommand")           

      document.getElementById("menuDispositivos").className = document.getElementById("menuDispositivos").className.replace("hidden", "")
      setObjDevicesUpdateTimestamp(new Date().getTime())        
    }else{
        document.getElementById("menuDispositivos").className += " hidden"
    } 
        
}

exports.añadirRegla = function(numeroReglasManuales,accion,regla,tipo){   
    accion(regla,tipo)  
}

exports.añadirDispositivo = function(origen,accion){
    
    if(origen === "MenuDispositivosDashboard"){
      window.location="/InstallationConfiguration/Devices"
    }
    else{//Menú Configuración -> Dispositivos
      accion()
    }    

}

exports.actualizarEstadoFrontAC = function(idDispositivo, estadoDispositivo){

  if(estadoDispositivo === "FRIO"){
    document.getElementById("frio"+idDispositivo).checked = true
    document.getElementById("calor"+idDispositivo).checked = false
    document.getElementById("literalBotonApagarAC"+idDispositivo).innerHTML = "Apagar"
  }
  else if(estadoDispositivo === "CALOR"){
    document.getElementById("frio"+idDispositivo).checked = false
    document.getElementById("calor"+idDispositivo).checked = true
    document.getElementById("literalBotonApagarAC"+idDispositivo).innerHTML = "Apagar"
  }
  else if(estadoDispositivo === "off"){
    document.getElementById("frio"+idDispositivo).checked = false
    document.getElementById("calor"+idDispositivo).checked = false
    document.getElementById("literalBotonApagarAC"+idDispositivo).innerHTML = "Apagado"
  }

}

exports.actualizarEstadoDispositivo = function(appDispositivo,idDispositivo,tipoDispositivo){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
    
    var estadoActual = 0
    var nuevoEstado = ""

    if(document.getElementById("checkbox"+idDispositivo) !== null){

      document.getElementById("checkbox"+idDispositivo).setAttribute("loading", "")

      if(document.getElementById("checkbox"+idDispositivo).checked === true){
        estadoActual = "off"
      }      
      else{
        estadoActual = "on"
      }

    }
    else if(document.getElementById("pulsador"+idDispositivo) !== null){

      document.getElementById("pulsador"+idDispositivo).className = document.getElementById("pulsador"+idDispositivo).className.replaceAll("loading", "") + " loading"
      estadoActual = "on"     

    }
    else{ // Se trata otro dipo de dispositivo con un control distinto al switch basico con checkbox

      //Compruebo si es una persiana
      if(document.getElementById("botonSubir"+idDispositivo) !== null ){ // Es una persiana

        document.getElementById("botonSubir"+idDispositivo).className = document.getElementById("botonSubir"+idDispositivo).className.replaceAll(" loading", "") + " loading"
        document.getElementById("botonBajar"+idDispositivo).className = document.getElementById("botonBajar"+idDispositivo).className.replaceAll(" loading", "") + " loading"

        if(document.getElementById("botonSubir"+idDispositivo).className.includes(" hidden")){
          estadoActual = "on"
        }
        else{
          estadoActual = "off"
        }        
      }
      else if( document.getElementById("ModosOperacionAC"+idDispositivo) !== null ){ // Es un AC Broadlink
        estadoActual = ""
        nuevoEstado = document.getElementById("ModosOperacionAC"+idDispositivo).value
      }
      
    }
    
    if(estadoActual === "on"){
      
      if(tipoDispositivo.includes("LAVADORA")){
        nuevoEstado = "on"                
      }
      else{
        nuevoEstado = "off"                
      }      

    }
    else if(estadoActual === "off"){
      nuevoEstado = "on"
    }

    if(tipoDispositivo === "ESCENA"){ //En este caso siempre pido on
      nuevoEstado = "on"
    }

    var tieneCuentaTelegram = "false"

    if(JSON.parse(localStorage.getItem("lastDashboardData")).GeneralData.TelegramAccount !== ""){
      tieneCuentaTelegram = "true"
    }
    else{
      tieneCuentaTelegram = "false"
    }

    tieneCuentaTelegram = "false"
  
    //Petición de datos para el paso actual    
    var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"), "installationName": localStorage.getItem("installationName").split("*")[1], "telegramAccount": tieneCuentaTelegram ,"marcaDispositivo": appDispositivo,"comando": "cambiarEstado","idDispositivo": idDispositivo,"nuevoEstado": nuevoEstado}

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postSmartDeviceCommandRequestURL, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          

            //Si se trata de un SWITCH BÁSICO
            if(document.getElementById("checkbox"+idDispositivo) !== null){

              document.getElementById("checkbox"+idDispositivo).removeAttribute("loading")              

              if(nuevoEstado === "on"){
                document.getElementById("checkbox"+idDispositivo).checked = true
                document.getElementById("li"+idDispositivo).className = document.getElementById("li"+idDispositivo).className.replaceAll(" blue-300", " green") 
              }
              else{
                document.getElementById("checkbox"+idDispositivo).checked = false
                document.getElementById("li"+idDispositivo).className = document.getElementById("li"+idDispositivo).className.replaceAll(" green", " blue-300")
              }              

              if(tipoDispositivo === "PULSADOR"){
                document.getElementById("checkbox"+idDispositivo).checked = false
              }

            }

            if(document.getElementById("pulsador"+idDispositivo) !== null){
              document.getElementById("pulsador"+idDispositivo).className = document.getElementById("pulsador"+idDispositivo).className.replaceAll("loading", "")
            }

            //Si se trata de una PERSIANA
            if(document.getElementById("botonSubir"+idDispositivo) !== null ){ // Es una persiana
              
              document.getElementById("botonSubir"+idDispositivo).className = document.getElementById("botonSubir"+idDispositivo).className.replaceAll(" loading", "")
              document.getElementById("botonBajar"+idDispositivo).className = document.getElementById("botonBajar"+idDispositivo).className.replaceAll(" loading", "")

              if(nuevoEstado === "on"){                
                document.getElementById("botonSubir"+idDispositivo).className = document.getElementById("botonSubir"+idDispositivo).className.replaceAll(" hidden", "") + " hidden"
                document.getElementById("botonBajar"+idDispositivo).className = document.getElementById("botonBajar"+idDispositivo).className.replaceAll(" hidden", "")

                if( (tipoDispositivo === "PERSIANA") && (appDispositivo === "SHELLY") ){
                  document.getElementById("lectura"+idDispositivo).innerHTML = "100 %"
                }              

              }
              else{                
                document.getElementById("botonSubir"+idDispositivo).className = document.getElementById("botonSubir"+idDispositivo).className.replaceAll(" hidden", "")
                document.getElementById("botonBajar"+idDispositivo).className = document.getElementById("botonBajar"+idDispositivo).className.replaceAll(" hidden", "") + " hidden"

                if( (tipoDispositivo === "PERSIANA") && (appDispositivo === "SHELLY") ){
                  document.getElementById("lectura"+idDispositivo).innerHTML = "0 %"
                }              

              }              
              
            }

            if( (appDispositivo === "BROADLINK") && (tipoDispositivo === "AIRE_ACONDICIONADO")){
              document.getElementById("botonApagarAC"+idDispositivo).className = document.getElementById("botonApagarAC"+idDispositivo).className.replaceAll(" loading", "")
              document.getElementById("botonEncenderFrioAC"+idDispositivo).className = document.getElementById("botonEncenderFrioAC"+idDispositivo).className.replaceAll(" loading", "")
              document.getElementById("botonEncenderCalorAC"+idDispositivo).className = document.getElementById("botonEncenderCalorAC"+idDispositivo).className.replaceAll(" loading", "")              
              module.exports.actualizarEstadoFrontAC(idDispositivo,nuevoEstado.split("·")[0])                            
            }
            
            console.log("Dispositivos inteligentes cargados correctamente.")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);     
}

exports.actualizarControlDispositivo = function(dispositivo, nuevoValor){

  var valor = 0
  if(nuevoValor === ""){ valor = parseInt(dispositivo.Valor) }
  else{ valor = nuevoValor }

  if(dispositivo.MarcaDispositivo === "ECOFORESTCONTROL"){
    if(dispositivo.Nombre.includes("BIO+")){
      if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){

        if(valor >= 9){        
          document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
        }
        else if (valor <= 1){        
          document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
        }
        else if ((valor > 1) && (valor < 9)){
          document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
          document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
        }
  
        document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString()

      }
    }
  }
  else if(dispositivo.MarcaDispositivo === "BRONPI"){
    if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){
      if(valor >= 5){      
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
      }
      else if (valor <= 1){      
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
      }  
      else if ((valor > 1) && (valor < 5)){
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
      } 

      document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString()
    }
        
  }
  else if( ( (dispositivo.MarcaDispositivo === "SMARTLIFE") || (dispositivo.MarcaDispositivo === "TUYA") ) && (dispositivo.TipoDispositivo === "TERMOSTATO") ){

    if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){
      if(valor >= 40){      
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
      }
      else if (valor <= 5){      
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
      }  
      else if ((valor > 5) && (valor < 40)){
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
      } 

      document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString() + " °C"
    }        
  }
  else if(dispositivo.MarcaDispositivo === "HOME_ASSISTANT"){
    if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){
      if(valor >= 40){      
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
      }
      else if (valor <= 5){      
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
      }  
      else if ((valor > 5) && (valor < 40)){
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
      } 

      document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString()
    }
        
  }
  else if(dispositivo.MarcaDispositivo === "IAQUALINK"){
    if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){
      if(valor >= 32){      
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
      }
      else if (valor <= 15){      
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
      }  
      else if ((valor > 15) && (valor < 32)){
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
      } 

      document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString() + " °C"   
    }        
  }
  else if( (dispositivo.MarcaDispositivo === "MELCLOUD") || (dispositivo.MarcaDispositivo === "COMFORT_CLOUD")){
    if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){
      if(valor >= 31){      
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
      }
      else if (valor <= 16){      
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
      }  
      else if ((valor > 16) && (valor < 31)){
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
      } 

      document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString() + " °C"
    }        
  }
  else if(dispositivo.MarcaDispositivo === "ONECTA_DAIKIN"){
    if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){
      if(valor >= 30){      
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
      }
      else if (valor <= 18){      
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
      }  
      else if ((valor > 18) && (valor < 30)){
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
      } 

      document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString() + " °C"
    }        
  }
  else if( (dispositivo.MarcaDispositivo === "SHELLY") && (dispositivo.TipoDispositivo === "PERSIANA") ){
    if(document.getElementById("subir"+dispositivo.IdDispositivo) !== null){
      if(valor >= 100){      
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = true
      }
      else if (valor <= 0){      
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = true
      }  
      else if ((valor > 0) && (valor < 100)){
        document.getElementById("subir"+dispositivo.IdDispositivo).disabled = false
        document.getElementById("bajar"+dispositivo.IdDispositivo).disabled = false
      } 

      document.getElementById("lectura"+dispositivo.IdDispositivo).innerHTML = valor.toString() + " %"
    }        
  }
  

}

exports.modificarValorDispositivo = function(elemento,dispositivo,nuevoValor){

  var appDispositivo = dispositivo.MarcaDispositivo
  var idDispositivo = dispositivo.IdDispositivo
  var nombreDispositivo = dispositivo.Nombre
  var tipoDispositivo = dispositivo.TipoDispositivo

  nuevoValor = parseInt(nuevoValor)

  if(appDispositivo === "ECOFORESTCONTROL"){
    if(nombreDispositivo.includes("BIO+")){
      if(nuevoValor >= 9){ nuevoValor = 9 }
      else if (nuevoValor <= 1){ nuevoValor = 1 }      
    }
  }
  else if(appDispositivo === "BRONPI"){
    if(nuevoValor >= 5){ nuevoValor = 5 }
    else if (nuevoValor <= 1){ nuevoValor = 1 }  
  }
  else if( (appDispositivo === "TUYA") || (appDispositivo === "SMARTLIFE") ){
    if(nuevoValor >= 40){ nuevoValor = 40 }
    else if (nuevoValor <= 5){ nuevoValor = 5 }  
  }
  else if(appDispositivo === "HOME_ASSISTANT"){
    if(nuevoValor >= 40){ nuevoValor = 40 }
    else if (nuevoValor <= 5){ nuevoValor = 5 }  
  }
  else if( (appDispositivo === "MELCLOUD") || (dispositivo.MarcaDispositivo === "COMFORT_CLOUD") ){
    if(nuevoValor >= 31){ nuevoValor = 31 }
    else if (nuevoValor <= 16){ nuevoValor = 16 }  
  }
  else if( appDispositivo === "ONECTA_DAIKIN" ) {
    if(nuevoValor >= 30){ nuevoValor = 30 }
    else if (nuevoValor <= 18){ nuevoValor = 18 }  
  }
  else if( ( appDispositivo === "SHELLY" ) && ( tipoDispositivo === "PERSIANA") ) {
    if(nuevoValor >= 100){ nuevoValor = 100 }
    else if (nuevoValor <= 0){ nuevoValor = 0 }  
  }

  var tieneCuentaTelegram = "false"

  try{
    if(JSON.parse(localStorage.getItem("lastDashboardData")).GeneralData.TelegramAccount !== ""){
      tieneCuentaTelegram = "true"
    }
    else{
      tieneCuentaTelegram = "false"
    }
  }
  catch(error){/*Controlo caso de instalador*/}

  if(document.getElementById(elemento).disabled === false){
  
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

    document.getElementById(elemento).className = document.getElementById(elemento).className.replaceAll(" loading", "") + " loading"

    //Petición de datos para el paso actual    
    var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"), "installationName": localStorage.getItem("installationName").split("*")[1], "telegramAccount": tieneCuentaTelegram, "marcaDispositivo": appDispositivo,"comando": "modificarValor","idDispositivo": idDispositivo,"nuevoEstado": nuevoValor.toString()}

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postSmartDeviceCommandRequestURL, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)

          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{                    
            module.exports.actualizarControlDispositivo(dispositivo, nuevoValor)

            document.getElementById(elemento).className = document.getElementById(elemento).className.replaceAll(" loading", "")

            console.log("Dispositivo inteligente modificado correctamente.")
          }
        }

        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);     
  }
}

exports.obtenerIconoInstalacion = function(tipoInstalacion){
    
  var iconoInstalacion = ""

  if(tipoInstalacion.includes("PISO")){ iconoInstalacion = "home" }
  else if (tipoInstalacion.includes("CHALET")){ iconoInstalacion = "gite" }
  else if (tipoInstalacion.includes("EMPRESA")){ iconoInstalacion = "factory" }
  else if (tipoInstalacion.includes("COMUNIDAD")){ iconoInstalacion = "apartment" }

  return iconoInstalacion
}

exports.obtenerTipoDispositivo = function(idDispositivo, categoriaActividad){

  try{
    var tipoDispositivo = ""

    var listadoDispositivos = JSON.parse(localStorage.getItem("lastSmartDevicesStatus"))

    for(var x=0; x < listadoDispositivos.length; x++){
      if(idDispositivo === listadoDispositivos[x].IdDispositivo){
        tipoDispositivo = listadoDispositivos[x].TipoDispositivo
        break
      }
    }

    if(tipoDispositivo === ""){ //Compruebo si es de algún otro tipo conocido
      tipoDispositivo = categoriaActividad
    }
  }
  catch(errror){}

  return tipoDispositivo

}

exports.obtenerIconoGrupoDispositivos = function(tipoDispositivo){    
  var icono = ""

  //Tipos de dispositivo detallados
  if(tipoDispositivo === "PERSIANA"){icono = "blinds"}
  else if(tipoDispositivo === "ENCHUFE"){icono = "power"}
  else if(tipoDispositivo === "ENCHUFE_MONITOR"){icono = "electric_meter"}
  else if(tipoDispositivo === "MONITOR_CONSUMO"){icono = "electric_meter"}
  else if(tipoDispositivo === "MONITOR_CONSUMO_INTERRUPTOR"){icono = "electric_meter"}
  else if(tipoDispositivo === "INTERRUPTOR"){icono = "pause_presentation"}
  else if(tipoDispositivo === "RELE"){icono = "toggle_on"}
  else if(tipoDispositivo === "TEMPERATURA"){icono = "device_thermostat"}
  else if(tipoDispositivo === "HUMEDAD"){icono = "water_drop"}
  else if(tipoDispositivo === "AUTOMATICO_CUADRO_LUZ"){icono = "electric_bolt"}    
  else if(tipoDispositivo.includes("LUZ")){icono = "lightbulb"} //Mismo tipo con varios controles
  else if(tipoDispositivo === "TERMO"){icono = "bathroom"}  
  else if(tipoDispositivo === "ESTUFA"){icono = "fireplace"}    
  else if(tipoDispositivo === "REGULADOR_INTENSIDAD"){icono = "flourescent"} 
  else if(tipoDispositivo === "MANDO_IR_WIFI"){icono = "settings_remote"} 
  else if(tipoDispositivo === "TV"){icono = "tv"} 
  else if( (tipoDispositivo === "AIRE_ACONDICIONADO") || (tipoDispositivo === "AIRE_ACONDICIONADO*DIRECTO") ){icono = "ac_unit"} 
  else if(tipoDispositivo === "EQUIPO_SONIDO"){icono = "speaker"} 
  else if(tipoDispositivo === "VENTILADOR"){icono = "wind_power"} 
  else if(tipoDispositivo === "PROYECTOR"){icono = "connected_tv"} 
  else if(tipoDispositivo === "TERMOSTATO"){icono = "thermostat"} 
  else if(tipoDispositivo === "PULSADOR"){icono = "radio_button_checked"} 
  else if(tipoDispositivo === "SENSOR_TEMPERATURA"){icono = "thermostat"} 
  else if(tipoDispositivo === "SENSOR_HUMEDAD"){icono = "water_drop"}
  else if(tipoDispositivo === "SENSOR_VOC"){icono = "soup_kitchen"}
  else if(tipoDispositivo === "SENSOR_CH2O"){icono = "local_fire_department"}
  else if(tipoDispositivo === "SENSOR_CO2"){icono = "co2"}
  else if(tipoDispositivo === "MANDOS_A_DISTANCIA"){icono = "settings_remote"}
  else if(tipoDispositivo === "DECODIFICADOR"){icono = "home_max"}
  else if(tipoDispositivo === "TV_BOX"){icono = "home_max"}  
  else if(tipoDispositivo === "SENSOR_PUERTA_VENTANA"){icono = "sensor_door"}
  else if(tipoDispositivo === "ESCENA"){icono = "settings_suggest"}
  else if(tipoDispositivo === "CALENTADOR_PISCINA"){icono = "pool"}  
  else if(tipoDispositivo === "LAVADORA"){icono = "local_laundry_service"}  
  

  //Manejo otros tipos genéricos de dispositivo
  else if(tipoDispositivo === "Dispositivos"){icono = "devices_other"}
  else if(tipoDispositivo === "GrupoElectrogeno"){icono = "dynamic_form"}
  else if(tipoDispositivo === "Coche"){icono = "directions_car"}
  else if(tipoDispositivo === "Baterias"){icono = "battery_charging_full"}
  else if(tipoDispositivo === "Mensajeria"){
    icono = "telegram"
    icono = "email"
    //Comprobar si es Telegram o Email para cambiar el icono
  }  
  else if(tipoDispositivo === "RegistroActividad"){icono = "fact_check"}  
  else if(tipoDispositivo === "SERVIDOR_CAIDO"){icono = "report"}  
  else if(tipoDispositivo === "Energia"){icono = "electric_bolt"}  
  else { icono = "device_unknown" } 

  return icono
}

exports.obtenerColorIcono = function(categoriaActividad, statusDispositivo){    

  console.log(categoriaActividad)
  console.log(statusDispositivo)
  console.log("----")

  var icono = ""

  if( (statusDispositivo === "on") || 
      (statusDispositivo === "1") ||
      (statusDispositivo === "Encendido") ||
      (statusDispositivo === "iniciarCarga")||
      (statusDispositivo === "cargaBateriasDeRedActivada")||
      (statusDispositivo === "CALOR")||
      (statusDispositivo === "FRIO")
      ){ icono = "green"}
  else if(
    (statusDispositivo === "mensajeEnviado")||
    (statusDispositivo === "actividadRegistrada")||
    (statusDispositivo === "Subida")||
    (statusDispositivo === "Bajada")||
    (statusDispositivo === "ESCENA")||
    (statusDispositivo === "modificarAmperajeCarga") ||
    (statusDispositivo === "modificarValor")){
    icono = "cyan"
  }
  else { icono = "red"}

  return icono
}

exports.obtenerLiteralEstadoAccion = function(idAccionEstado){

  var literalEstado = ""

  if( (idAccionEstado === "0") || (idAccionEstado === "off") || (idAccionEstado === "Apagado") ){literalEstado = "Apagado"}
  else if( (idAccionEstado === "1") || (idAccionEstado === "on") || (idAccionEstado === "Encendido") ){literalEstado = "Encendido"}
  else if(idAccionEstado === "true") {literalEstado = "Activado"}
  else if(idAccionEstado === "false") {literalEstado = "Desactivado"}
  else if(idAccionEstado === "Online"){literalEstado = "Con conexión"}
  else if( (idAccionEstado === "Offline") || (idAccionEstado === "N/A") ){literalEstado = "Sin conexión"}
  else if(idAccionEstado === "iniciarCarga"){literalEstado = "Carga iniciada"}
  else if(idAccionEstado === "pararCarga"){literalEstado = "Carga parada"}  
  else if(idAccionEstado === "modificarAmperajeCarga"){literalEstado = "Amperaje de carga: "}    
  else if(idAccionEstado === "modificarValor"){literalEstado = "Valor modificado a"}  
  else if(idAccionEstado === "Subida"){literalEstado = "Subida"}  
  else if(idAccionEstado === "Bajada"){literalEstado = "Bajada"}  
  else if(idAccionEstado === "Pulsado"){literalEstado = "Pulsado"}  
  else if(idAccionEstado === "CALOR"){literalEstado = "Modo CALOR"}  
  else if(idAccionEstado === "FRIO"){literalEstado = "Modo FRIO"}  
  else if(idAccionEstado === "Abierto"){literalEstado = "Abierto"}  
  else if(idAccionEstado === "Cerrado"){literalEstado = "Cerrado"}    
  else if(idAccionEstado === "ESCENA"){literalEstado = "Activada"}   
  else if(idAccionEstado === "actividadRegistrada"){literalEstado = "Registro actividad"}  
  else if(idAccionEstado === "LavadoraLista"){literalEstado = "Lista para lavar"}  
  else if(idAccionEstado === "LavadoraRemotoDesactivado"){literalEstado = "Control remoto desactivado"}  
  else if(idAccionEstado === "LavadoraLavando"){literalEstado = "Lavando"}  
  else if(idAccionEstado === "cargaBateriasDeRedActivada"){literalEstado = "Carga desde la red activada"}  
  else if(idAccionEstado === "cargaBateriasDeRedDesactivada"){literalEstado = "Carga desde la red desactivada"}  
  

  return literalEstado
}

exports.obtenerUnidadAccion = function(actividad){

  var literalUnidad = ""

  if( (actividad.actionStatusId === "on") && (actividad.actionId === "postFUSIONSOLARCommand") && (actividad.deviceName === "Modo TOU") ){literalUnidad = "kWh"}
  
  return literalUnidad
}

exports.obtenerNombreDispositivo = function(categoriaActividad, nombreDispositivo){
  var literalNombreDispositivo = ""

  if(categoriaActividad === "Mensajeria"){literalNombreDispositivo = "Mensaje enviado"}
  else{literalNombreDispositivo = nombreDispositivo}

  return literalNombreDispositivo
}

exports.obtenerDatosUsuarioActivadorAccion = function(dato, valorActual){
  
  var elementosValorActual = valorActual.split("·")

  var datoUsuarioActivador = ""
  var elementosApellido = ""
  var iniciales = ""

  if(dato === "nombreCorto"){

    datoUsuarioActivador = elementosValorActual[1].charAt(0)+"." // Nombre
    
    elementosApellido = elementosValorActual[2].split(" ") // Apellidos

    for(var x=0; x<(elementosApellido.length); x++){
      iniciales = iniciales + elementosApellido[x].charAt(0).toUpperCase()

      if(x !== ((elementosApellido.length)-1)){
        iniciales = iniciales + "."
      }
    }

    datoUsuarioActivador = datoUsuarioActivador + iniciales

  }
  else if(dato === "nombreLargo"){
    datoUsuarioActivador = elementosValorActual[1] + " " + elementosValorActual[2] // Nombre y apellidos

  }
  else if(dato === "email"){
    datoUsuarioActivador = elementosValorActual[3] // Email
  } 

  return datoUsuarioActivador

}

exports.deshabilitarIconosWidgetInstalacion = function(idInstalacion){

  document.getElementById("figureAhorroGasto"+idInstalacion).className = document.getElementById("figureAhorroGasto"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureMonederoBaterias"+idInstalacion).className = document.getElementById("figureMonederoBaterias"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureAutoconsumo"+idInstalacion).className = document.getElementById("figureAutoconsumo"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureTomandoDeLaRed"+idInstalacion).className = document.getElementById("figureTomandoDeLaRed"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureFVGenerando"+idInstalacion).className = document.getElementById("figureFVGenerando"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureBateriasGenerando"+idInstalacion).className = document.getElementById("figureBateriasGenerando"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureGrupoGenerando"+idInstalacion).className = document.getElementById("figureGrupoGenerando"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureInstalacionConsumiendo"+idInstalacion).className = document.getElementById("figureInstalacionConsumiendo"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureBateriasConsumiendo"+idInstalacion).className = document.getElementById("figureBateriasConsumiendo"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureCocheConsumiendo"+idInstalacion).className = document.getElementById("figureCocheConsumiendo"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"
  document.getElementById("figureDevolviendoARed"+idInstalacion).className = document.getElementById("figureDevolviendoARed"+idInstalacion).className.replaceAll(" no-pointer", "") +  " no-pointer"

}

exports.cargarDatosInstalacionCompartidaInstalador = function(idInstalacion){

  document.getElementById("divWidgetTOTALES"+idInstalacion).className = document.getElementById("divWidgetTOTALES"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  //Petición de datos para el paso actual
  var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installerID": localStorage.getItem("installationId"), "installationID": idInstalacion }

  if(window.location.href.includes("Dashboard")){
    document.getElementById("loaderInstalacion"+idInstalacion).className = "contextual"
  }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postInstallerSharedInstallationDetail, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else if(jsonRespuesta.statusCode === "500"){
          document.getElementById("errorInstallationSelectionButton").className = document.getElementById("errorInstallationSelectionButton").className.replaceAll(" hidden", "")
          initialConfigCommonJS.mostrarErrorGeneral("report","ERROR",jsonRespuesta.responseMessage)      
        }
        else{          
          //Si recibo datos ya configurados lo cargo  

          if(typeof jsonRespuesta.body !== 'undefined'){
            
            console.log(jsonRespuesta)       
            
            if(jsonRespuesta.body.InstallationData !== undefined){

              if( (document.getElementById("detalleLateralOpcionInstalador").className.includes(" hidden")) && (window.location.href.includes("Dashboard")) ){
                module.exports.cargarWidgetTOTALESInstalador(jsonRespuesta.body, idInstalacion)                            
                module.exports.cargarScoring(jsonRespuesta.body, idInstalacion)
                module.exports.deshabilitarIconosWidgetInstalacion(idInstalacion)
              }
              else{
                localStorage.setItem("lastDashboardData", JSON.stringify(jsonRespuesta.body))
              }
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo("Esta instalación tiene problemas técnicos o de conectividad. Avise al propietario o proceda a su revisión in-situ.","negative")
              document.getElementById("details"+idInstalacion).removeAttribute("open")
            }
            
          }  

          if(window.location.href.includes("Dashboard")){
            document.getElementById("loaderInstalacion"+idInstalacion).className = "contextual hidden"
            document.getElementById("divWidgetTOTALES"+idInstalacion).className = document.getElementById("divWidgetTOTALES"+idInstalacion).className.replaceAll(" hidden", "")
          }

          //Si no hay datos configurados entonces no hago nada  
          console.log("Información de instalación compartida cargada correctamente.")
        }
      }

      if (this.readyState === 4 && this.status !== 200) {      
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data);     

}

exports.cargarWidgetTOTALESInstalador = function(jsonObjTOTAL, idInstalacion){

  //Muestro los iconos correspondientes en función de la configuración de la instalación

  if(jsonObjTOTAL.InstallationData.GeneralInfo.EnergyGridConnected === "true"){ 
    document.getElementById("etiquetaConsumoMaximoHistorico"+idInstalacion).innerHTML = "Consumo máximo histórico:"

    if(Object.keys(jsonObjTOTAL.FVData).length > 0){    
      document.getElementById("etiquetaConsumoMaximoHistorico"+idInstalacion).innerHTML = "Consumo máximo histórico red:"
    }
  }
  else{    
    document.getElementById("etiquetaConsumoMaximoHistorico"+idInstalacion).innerHTML = "Consumo máximo histórico:"
  }

  //Máximo hitórico consumo
  document.getElementById("consumoMaximoHistoricoTotal"+idInstalacion).innerHTML = jsonObjTOTAL.SelfConsumptionAndSavingsData.HistoricalMaxPowerConsumption.Value + " " + jsonObjTOTAL.SelfConsumptionAndSavingsData.HistoricalMaxPowerConsumption.Unit
 
  //Cargo los iconos para la FV
  if(Object.keys(jsonObjTOTAL.FVData).length > 0){
    if(parseInt(jsonObjTOTAL.FVData.GeneralWhFVGeneration.Value) > 0 ){
      document.getElementById("figureFVGenerando"+idInstalacion).className = "avatar size-l pink"
    }
    else{
      document.getElementById("figureFVGenerando"+idInstalacion).className = "avatar size-l disabled"
    }
  }
  else{
    document.getElementById("figureFVGenerando"+idInstalacion).className = " hidden"
  }
  
  //Cargo los iconos para las baterías
  if(Object.keys(jsonObjTOTAL.BatteriesData).length > 0){
    document.getElementById("figureBateriasGenerando"+idInstalacion).className = "avatar size-l percentage-indicator disabled"
    document.getElementById("figureBateriasConsumiendo"+idInstalacion).className = "avatar size-l percentage-indicator disabled"

    if(parseInt(jsonObjTOTAL.BatteriesData.BatteryWhConsumption.Value) !== 0){
      if(jsonObjTOTAL.BatteriesData.BatteryStatus === "Cargando"){
        document.getElementById("figureBateriasGenerando"+idInstalacion).className = "avatar size-l percentage-indicator disabled hidden"
        document.getElementById("figureBateriasConsumiendo"+idInstalacion).className = "avatar size-l percentage-indicator pink"              
  
      }    
      else if( (jsonObjTOTAL.BatteriesData.BatteryStatus === "Descargando") || (jsonObjTOTAL.BatteriesData.BatteryStatus === "Cargada") ){
        document.getElementById("figureBateriasGenerando"+idInstalacion).className = "avatar size-l percentage-indicator pink"
        document.getElementById("figureBateriasConsumiendo"+idInstalacion).className = "avatar size-l percentage-indicator disabled hidden"        
      }
    }
    else{
      if( (jsonObjTOTAL.BatteriesData.BatteryStatus === "Reposo") || (jsonObjTOTAL.BatteriesData.BatteryStatus === "N/A") || (jsonObjTOTAL.BatteriesData.BatteryStatus === "En reposo")){
        document.getElementById("figureBateriasGenerando"+idInstalacion).className = "avatar size-l percentage-indicator disabled"
        document.getElementById("figureBateriasConsumiendo"+idInstalacion).className = "avatar size-l percentage-indicator disabled hidden"        
      }      
      else if(jsonObjTOTAL.BatteriesData.BatteryStatus === "Cargada"){
        document.getElementById("figureBateriasGenerando"+idInstalacion).className = "avatar size-l percentage-indicator disabled"
        document.getElementById("figureBateriasConsumiendo"+idInstalacion).className = "avatar size-l percentage-indicator disabled hidden"        
      }      
    }

    document.getElementById("etiquetaPorcentajeBateriasGenerando"+idInstalacion).innerHTML = parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) + " " + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit
    document.getElementById("etiquetaPorcentajeBateriasGenerando"+idInstalacion).style = "--indicator-progress:"+jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit    
    document.getElementById("etiquetaPorcentajeBateriasConsumiendo"+idInstalacion).innerHTML = parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) + " " + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit
    document.getElementById("etiquetaPorcentajeBateriasConsumiendo"+idInstalacion).style = "--indicator-progress:"+jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value + jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Unit

    if(parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) <= 35){
      document.getElementById("etiquetaPorcentajeBateriasGenerando"+idInstalacion).className = "indicator low"
      document.getElementById("etiquetaPorcentajeBateriasConsumiendo"+idInstalacion).className = "indicator low"
    }
    else if( (parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) > 35) && (parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) <= 60)){
      document.getElementById("etiquetaPorcentajeBateriasGenerando"+idInstalacion).className = "indicator medium"
      document.getElementById("etiquetaPorcentajeBateriasConsumiendo"+idInstalacion).className = "indicator medium"
    }
    else if(parseInt(jsonObjTOTAL.BatteriesData.GeneralBatteryPercentage.Value) > 60){
      document.getElementById("etiquetaPorcentajeBateriasGenerando"+idInstalacion).className = "indicator high"
      document.getElementById("etiquetaPorcentajeBateriasConsumiendo"+idInstalacion).className = "indicator high"
    }
    
  }
  else{
    document.getElementById("figureBateriasGenerando"+idInstalacion).className = " hidden"
    document.getElementById("figureBateriasConsumiendo"+idInstalacion).className = " hidden"
  }

  //Cargo los iconos para el Grupo Electrógeno
  if(Object.keys(jsonObjTOTAL.GeneratorData).length > 0){
    document.getElementById("figureGrupoGenerando"+idInstalacion).className = "avatar size-l percentage-indicator disabled"
  
    if(parseInt(jsonObjTOTAL.GeneratorData.GeneralWhGeneratorTOTALGeneration.Value) > 0 ){
      document.getElementById("figureGrupoGenerando"+idInstalacion).className = "avatar size-l percentage-indicator pink"
    }

    document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).innerHTML = parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) + " " + jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Unit
    document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).style = "--indicator-progress:"+jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value + jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Unit    

    if(parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) <= 35){
      document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).className = "indicator low"
      document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).className = "indicator low"
    }
    else if( (parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) > 35) && (parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) <= 60)){
      document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).className = "indicator medium"
      document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).className = "indicator medium"
    }
    else if(parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) > 60){
      document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).className = "indicator high"
      document.getElementById("etiquetaPorcentajeGrupoGenerando"+idInstalacion).className = "indicator high"
    }

    if(parseInt(jsonObjTOTAL.GeneratorData.CurrentGeneratorTankPercentage.Value) < 25){      
      var estadoActualfigureGrupoGenerando = document.getElementById("figureGrupoGenerando"+idInstalacion).className
      document.getElementById("figureGrupoGenerando"+idInstalacion).className = "avatar size-l percentage-indicator orange blink"
      setTimeout(() => {try{document.getElementById("figureGrupoGenerando"+idInstalacion).className = estadoActualfigureGrupoGenerando} catch (error) {console.error(error);} },3000);	      
    }    
    
  }
  else{
    document.getElementById("figureGrupoGenerando"+idInstalacion).className = " hidden"
  }

  //Cargo los iconos para la instalación
  if(Object.keys(jsonObjTOTAL.InstallationData.GeneralInfo).length > 0){
    document.getElementById("figureInstalacionConsumiendo"+idInstalacion).className = "avatar size-l disabled"
  
    if(parseInt(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALConsumption.Value) > 0 ){
      document.getElementById("figureInstalacionConsumiendo"+idInstalacion).className = "avatar size-l green"
    }
  }
  else{
    document.getElementById("figureInstalacionConsumiendo"+idInstalacion).className = " hidden"
  }

  //Cargo los iconos para el coche
  try{
    if(Object.keys(jsonObjTOTAL.CarsData).length > 0){

      document.getElementById("figureCocheConsumiendo"+idInstalacion).className = "avatar size-l percentage-indicator disabled"
    
      if(parseInt(jsonObjTOTAL.CarsData[0].ChargePower.Value) > 0 ){
        document.getElementById("figureCocheConsumiendo"+idInstalacion).className = "avatar size-l percentage-indicator pink"
      }

      document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).innerHTML = parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) + " " + jsonObjTOTAL.CarsData[0].ChargeLevel.Unit
      document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).style = "--indicator-progress:"+jsonObjTOTAL.CarsData[0].ChargeLevel.Value + jsonObjTOTAL.CarsData[0].ChargeLevel.Unit    

      if(parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) <= 35){
        document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).className = "indicator low"
        document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).className = "indicator low"
      }
      else if( (parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) > 35) && (parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) <= 60)){
        document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).className = "indicator medium"
        document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).className = "indicator medium"
      }
      else if(parseInt(jsonObjTOTAL.CarsData[0].ChargeLevel.Value) > 60){
        document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).className = "indicator high"
        document.getElementById("etiquetaPorcentajeCocheConsumiendo"+idInstalacion).className = "indicator high"
      }

    }
    else{
      document.getElementById("figureCocheConsumiendo"+idInstalacion).className = " hidden"
    }
  }
  catch(error){console.log(error)}

  document.getElementById("potenciaTOTALDisponible"+idInstalacion).innerHTML = jsonObjTOTAL.GeneralData.TotalMaximunGeneration.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalMaximunGeneration.Unit
  document.getElementById("generacionTOTALActual"+idInstalacion).innerHTML = jsonObjTOTAL.GeneralData.TotalBulkGeneration.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalBulkGeneration.Unit
  
  // Si tengo capacitiva pongo 0 para no confundir al usuario.
  if(jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value < 0){
    jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value = "0"
  }

  document.getElementById("consumoTOTALActual"+idInstalacion).innerHTML = jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value + " " + jsonObjTOTAL.GeneralData.TotalBulkConsumption.Unit   
  document.getElementById("potenciaActual"+idInstalacion).innerHTML = jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value + " " + jsonObjTOTAL.GeneralData.TotalBulkConsumption.Unit   
  
  //Gestiono la visualización de los datos de carga/volcado de la red y energía residual

  // Por defecto muestro tanto tomando como devolviendo oculto
  document.getElementById("divTomandoDeLaRed"+idInstalacion).className = document.getElementById("divTomandoDeLaRed"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"        
  document.getElementById("divDevolviendoARed"+idInstalacion).className = document.getElementById("divDevolviendoARed"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"        
  
  document.getElementById("etiquetaTomandoDeLaRed"+idInstalacion).innerHTML = ""        
  document.getElementById("etiquetaDevolviendoARed"+idInstalacion).innerHTML = ""        
  
  document.getElementById("figureTomandoDeLaRed"+idInstalacion).className = "avatar size-l disabled"                
  document.getElementById("figureDevolviendoARed"+idInstalacion).className = "avatar size-l disabled"                
  
  document.getElementById("spanFigureTomandoDeLaRed"+idInstalacion).innerHTML = ""                        
  document.getElementById("spanFigureDevolviendoARed"+idInstalacion).innerHTML = ""                        
  
  document.getElementById("tomandoDeLaRed"+idInstalacion).innerHTML = "0 Wh"
  document.getElementById("devolviendoARed"+idInstalacion).innerHTML = "0 Wh"

  if(jsonObjTOTAL.InstallationData.GeneralInfo.EnergyGridConnected === "true"){      
    
    // Ahora si tomo de la red lo muestro
    if(parseInt(jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Value) > 0){        
      document.getElementById("etiquetaTomandoDeLaRed"+idInstalacion).innerHTML = "Tomando de la red"
      document.getElementById("figureTomandoDeLaRed"+idInstalacion).className = "avatar size-l cyan"                
      document.getElementById("spanFigureTomandoDeLaRed"+idInstalacion).innerHTML = "power_input" 
      document.getElementById("divTomandoDeLaRed"+idInstalacion).className = document.getElementById("divTomandoDeLaRed"+idInstalacion).className.replaceAll(" hidden", "")
      document.getElementById("tomandoDeLaRed"+idInstalacion).innerHTML = jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Value.replace("-","") + " " + jsonObjTOTAL.InstallationData.GeneralInfo.GeneralWhInstallationTOTALGeneration.Unit
    }
    
    // Y si devuelvo también
    if(parseInt(jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value) > 0){    
      document.getElementById("etiquetaDevolviendoARed"+idInstalacion).innerHTML = "Devolviendo a la red"
      document.getElementById("figureDevolviendoARed"+idInstalacion).className = "avatar size-l cyan"     
      document.getElementById("spanFigureDevolviendoARed"+idInstalacion).innerHTML = "output" 
      document.getElementById("divDevolviendoARed"+idInstalacion).className = document.getElementById("divDevolviendoARed"+idInstalacion).className.replaceAll(" hidden", "")    
      document.getElementById("devolviendoARed"+idInstalacion).innerHTML = jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalWastedEnergy.Unit
    }

  }
  else{

    if(parseInt(jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value) > 0){            
      document.getElementById("divDevolviendoARed"+idInstalacion).className = document.getElementById("divDevolviendoARed"+idInstalacion).className.replaceAll(" hidden", "")
      document.getElementById("etiquetaDevolviendoARed"+idInstalacion).innerHTML = "Perdiendo / Residual"         
      document.getElementById("figureDevolviendoARed"+idInstalacion).className = "avatar size-l cyan"        
      document.getElementById("spanFigureDevolviendoARed"+idInstalacion).innerHTML = "output"                            
      document.getElementById("devolviendoARed"+idInstalacion).innerHTML = jsonObjTOTAL.GeneralData.TotalWastedEnergy.Value.replace("-","") + " " + jsonObjTOTAL.GeneralData.TotalWastedEnergy.Unit
    }

  }

  var consumoActualTotal = parseInt(jsonObjTOTAL.GeneralData.TotalBulkConsumption.Value.replace("-",""+idInstalacion).replaceAll(".", ""))  
  var generacionMaximaInstalacion = parseInt(jsonObjTOTAL.GeneralData.TotalMaximunGeneration.Value.replace("-",""+idInstalacion).replaceAll(".", ""))

  document.getElementById("resumenGeneralConsumoMeter"+idInstalacion).min = "0"
  document.getElementById("resumenGeneralConsumoMeter"+idInstalacion).max = generacionMaximaInstalacion
  document.getElementById("resumenGeneralConsumoMeter"+idInstalacion).value = consumoActualTotal

  var porcentajeConsumoInstalacion = (consumoActualTotal * 100) / generacionMaximaInstalacion

  if ( (0 <= porcentajeConsumoInstalacion) && (porcentajeConsumoInstalacion <= 50) ){
    document.getElementById("resumenGeneralConsumoMeter"+idInstalacion).className = "fill green"
  }
  else if ( (50 < porcentajeConsumoInstalacion) && (porcentajeConsumoInstalacion <= 80) ){
    document.getElementById("resumenGeneralConsumoMeter"+idInstalacion).className = "fill orange"
  }
  else if ( (80 < porcentajeConsumoInstalacion) && (porcentajeConsumoInstalacion <= 100) ){
    document.getElementById("resumenGeneralConsumoMeter"+idInstalacion).className = "fill red"    
  }
  else if (porcentajeConsumoInstalacion > 100){
    document.getElementById("resumenGeneralConsumoMeter"+idInstalacion).className = "fill red blink"    
  }

  //Tras pintar todo, simplifico datos en caso de red básica conectada a la red general
  if( (Object.keys(jsonObjTOTAL.FVData).length === 0) && (Object.keys(jsonObjTOTAL.BatteriesData).length === 0) && (Object.keys(jsonObjTOTAL.GeneratorData).length === 0) ){
    document.getElementById("contenedorBotoneraInferiorDashboard"+idInstalacion).className = document.getElementById("contenedorBotoneraInferiorDashboard"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("divTomandoDeLaRed"+idInstalacion).className = document.getElementById("divTomandoDeLaRed"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("divConsumiendo"+idInstalacion).className = document.getElementById("divConsumiendo"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"

    if(Object.keys(jsonObjTOTAL.CarsData).length > 0){
      if(jsonObjTOTAL.InstallationData.GeneralInfo.EnergyGridConnected === "true"){       
        document.getElementById("contenedorBotoneraInferiorDashboard"+idInstalacion).className = document.getElementById("contenedorBotoneraInferiorDashboard"+idInstalacion).className.replaceAll(" hidden", "") 
        document.getElementById("divTomandoDeLaRed"+idInstalacion).className = document.getElementById("divTomandoDeLaRed"+idInstalacion).className.replaceAll(" hidden", "")
      }
      document.getElementById("divConsumiendo"+idInstalacion).className = document.getElementById("divConsumiendo"+idInstalacion).className.replaceAll(" hidden", "")
    }    
  }

  var generacionActualTotal = parseInt(jsonObjTOTAL.GeneralData.TotalBulkGeneration.Value.replaceAll(".",""))  

  if( (Object.keys(jsonObjTOTAL.FVData).length > 0) || (Object.keys(jsonObjTOTAL.BatteriesData).length > 0) || (Object.keys(jsonObjTOTAL.GeneratorData).length > 0) ){
    //Si tengo algún elemento de generación aun no habiendo generación lo muestro para mantener el icono de acceso al detalle
    document.getElementById("divGenerando"+idInstalacion).className = document.getElementById("divGenerando"+idInstalacion).className.replaceAll(" hidden", "")
  }
  else{ // Sino oculto la generación si procede
    if(generacionActualTotal === 0){
      document.getElementById("divGenerando"+idInstalacion).className = document.getElementById("divGenerando"+idInstalacion).className.replaceAll(" hidden", "") + " hidden"
    }    
    else{
      document.getElementById("divGenerando"+idInstalacion).className = document.getElementById("divGenerando"+idInstalacion).className.replaceAll(" hidden", "")
    }
  }  

}

exports.mostrarPestañaAutoconsumoAhorro = function(nombrePestaña){

  if( nombrePestaña === "pestañaHoy" ){    
    document.getElementById("pestañaHoy").checked = true
    document.getElementById("ulPestañaHoy").className = document.getElementById("ulPestañaHoy").className.replaceAll(" hidden", "")
    document.getElementById("ulPestañaMes").className += " hidden"
    document.getElementById("ulPestañaAño").className += " hidden"
    document.getElementById("ulPestañaDesdeRegistro").className += " hidden"

    if(document.getElementById("pestañaFacturaHoy").checked === true){ 
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaFactura","Hoy")
    }
    else{
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Hoy")
    }

  }
  else if( nombrePestaña === "pestañaMes" ){
    document.getElementById("pestañaMes").checked = true
    document.getElementById("ulPestañaHoy").className += " hidden"
    document.getElementById("ulPestañaMes").className = document.getElementById("ulPestañaMes").className.replaceAll(" hidden", "")
    document.getElementById("ulPestañaAño").className += " hidden"
    document.getElementById("ulPestañaDesdeRegistro").className += " hidden"          
    
    if(document.getElementById("pestañaFacturaMes").checked === true){ 
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaFactura","Mes")
    }
    else{
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Mes")
    }
    
  }
  else if( nombrePestaña === "pestañaAno" ){
    document.getElementById("pestañaAno").checked = true
    document.getElementById("ulPestañaHoy").className += " hidden"
    document.getElementById("ulPestañaMes").className += " hidden"
    document.getElementById("ulPestañaAño").className = document.getElementById("ulPestañaAño").className.replaceAll(" hidden", "")
    document.getElementById("ulPestañaDesdeRegistro").className += " hidden"

    if(document.getElementById("pestañaFacturaAño").checked === true){ 
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaFactura","Año")
    }
    else{
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Año")
    }

  }
  else if( nombrePestaña === "pestañaDesdeRegistro" ){
    document.getElementById("pestañaDesdeRegistro").checked = true
    document.getElementById("ulPestañaHoy").className += " hidden"
    document.getElementById("ulPestañaMes").className += " hidden"
    document.getElementById("ulPestañaAño").className += " hidden"
    document.getElementById("ulPestañaDesdeRegistro").className = document.getElementById("ulPestañaDesdeRegistro").className.replaceAll(" hidden", "")

    if(document.getElementById("pestañaFacturaDesdeRegistro").checked === true){ 
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaFactura","DesdeRegistro")
    }
    else{
      module.exports.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","DesdeRegistro")
    }

  }

}

exports.mostrarPestañaEnergiaInstalacion = function(nombrePestaña){

  if( nombrePestaña === "pestañaGeneracion" ){    
    document.getElementById("pestañaGeneracion").checked = true
    document.getElementById("pestañaConsumo").checked = false    
    document.getElementById("pestañaDevuelto").checked = false
    document.getElementById("ulPestañaGeneracion").className = document.getElementById("ulPestañaGeneracion").className.replaceAll(" hidden", "")
    document.getElementById("ulPestañaConsumo").className += " hidden"    
    document.getElementById("ulPestañaDevuelto").className += " hidden"    
  }
  else if( nombrePestaña === "pestañaConsumo" ){
    document.getElementById("pestañaGeneracion").checked = false    
    document.getElementById("pestañaConsumo").checked = true
    document.getElementById("pestañaDevuelto").checked = false
    document.getElementById("ulPestañaGeneracion").className += " hidden"
    document.getElementById("ulPestañaConsumo").className = document.getElementById("ulPestañaConsumo").className.replaceAll(" hidden", "")
    document.getElementById("ulPestañaDevuelto").className += " hidden"         
    
  }
  else if( nombrePestaña === "pestañaDevuelto" ){
    document.getElementById("pestañaGeneracion").checked = false
    document.getElementById("pestañaConsumo").checked = false
    document.getElementById("pestañaDevuelto").checked = true
    document.getElementById("ulPestañaGeneracion").className += " hidden"
    document.getElementById("ulPestañaConsumo").className += " hidden"
    document.getElementById("ulPestañaDevuelto").className = document.getElementById("ulPestañaDevuelto").className.replaceAll(" hidden", "")
  }

}

exports.mostrarPestañaAutoconsumoFactura = function(nombrePestaña, periodo){

  if( nombrePestaña.includes("pestañaFactura") ){    
    document.getElementById("pestañaFactura"+periodo).checked = true
    document.getElementById("pestañaAutoconsumo"+periodo).checked = false        
    document.getElementById("ulPestañaFactura"+periodo).className = document.getElementById("ulPestañaFactura"+periodo).className.replaceAll(" hidden", "")
    document.getElementById("ulPestañaAutoconsumo"+periodo).className += " hidden"    
    

    
  }
  else if( nombrePestaña.includes("pestañaAutoconsumo") ){
    document.getElementById("pestañaFactura"+periodo).checked = false    
    document.getElementById("pestañaAutoconsumo"+periodo).checked = true    
    document.getElementById("ulPestañaFactura"+periodo).className += " hidden"
    document.getElementById("ulPestañaAutoconsumo"+periodo).className = document.getElementById("ulPestañaAutoconsumo"+periodo).className.replaceAll(" hidden", "")

    

  }

}

exports.volverDashboardInstalador = function(seleccionarOpcionMenu){

  localStorage.removeItem("lastDashboardData")

  document.getElementById("cabeceraHelias").className = document.getElementById("cabeceraHelias").className.replaceAll(" hidden", "")
  seleccionarOpcionMenu("opcionMenuDashboard")

}

exports.inicializarCajaBusqueda = function(idCajaBusqueda, tipoBuscador, tipoBusqueda){

  document.getElementById(idCajaBusqueda).value = ""  

  if(tipoBuscador === "INSTALACIONES_INSTALADOR"){
    module.exports.filtrarInstalaciones()
  }
  else if ((tipoBuscador === "REGLAS_INSTALADOR")){
    rulesCommonJS.filtrarReglasInstalador("searchInstallerRule")
  }
  else if ((tipoBuscador === "REGLAS_USUARIO")){
    rulesCommonJS.filtrarReglasUsuario(tipoBusqueda)
  }
  else if ((tipoBuscador === "APLICACIONES_DISPONIBLES")){
    initialConfigCommonJS.filtrarAplicaciones()
  }
  else if ((tipoBuscador === "BUSCADOR_INSTALADORES")){
    document.getElementById("resultadoBusqueda").className += " hidden"
  }
  else if ((tipoBuscador === "SELECCION_ELEMENTOS_REGLAS")){
    rulesCommonJS.filtrarElementosSeleccionReglas()
  }
  

}

exports.filtrarInstalaciones = function(){
  var cadenaFiltrado = document.getElementById("search").value   
  try{
    var listadoInstalacionesBuscador = document.getElementById("listadoInstalacionesCompartidas").children

    var idElementoTemp = ""    
  
    for (var i = 0; i < listadoInstalacionesBuscador.length; i++) {
      
      idElementoTemp = listadoInstalacionesBuscador[i].id
      
      if( document.getElementById(idElementoTemp).getAttribute("searchdata").includes(cadenaFiltrado.toLowerCase())){
        document.getElementById(idElementoTemp).className = document.getElementById(idElementoTemp).className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById(idElementoTemp).className = document.getElementById(idElementoTemp).className.replaceAll(" hidden", "") + " hidden"
      }
  
    }    
  
  }
  catch(error){console.log(error)}
  
}

exports.ajustarMonederoSolar = function(){

  var jsonDashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))

  var fechaActivacionMonedero = jsonDashboardData.FVData.SolarWalletActivationDate

  if(fechaActivacionMonedero === undefined){ //Se trata de una instalación sin autoconsumo actualizando monedero de bonificaciones
    fechaActivacionMonedero = "1981-07-09" //Gran día :)
  }

  var fechaDesdeUltimaFactura = ""
  try{
    fechaDesdeUltimaFactura = document.getElementById("fechaDesdeFacturaMonedero").value
  }
  catch(error){
    console.log(error)
    fechaDesdeUltimaFactura = ""
  }
  
  var saldoPeticion = ""
  try{
    saldoPeticion = document.getElementById("valorSaldoMonedero").value
  }
  catch(error){
    console.log(error)
    saldoPeticion = ""
  }

  if(saldoPeticion === ""){ // Actualización automática
    //fechaActivacionMonedero la dejo igual
    fechaDesdeUltimaFactura = ""    
  }
  else{ //Actualización manual

    var elementosFechaActual = new Date().toJSON().split("T")[0].split("-");      
    var elementosFechaActivacion = fechaActivacionMonedero.split("-")

    if( (parseInt(elementosFechaActual[1]) === parseInt(elementosFechaActivacion[1])) && (parseInt(elementosFechaActual[0]) === parseInt(elementosFechaActivacion[0])) ){ //Monedero activado este mes y año
      console.log("Actualizacion manual mes activacion")
      //fechaActivacionMonedero la dejo igual
      fechaDesdeUltimaFactura = ""    
    }
    else{ //Monedero activado meses anteriores
      console.log("Actualizacion manual mes DIFERENTE a activación")
      fechaActivacionMonedero = ""
      //fechaDesdeUltimaFactura lo dejo igual
    }

  }
  
  if(Object.keys(jsonDashboardData.FVData).length === 0){  //Instalación sin FV actualizando monedero bonificación
    
    var elementosFechaUltimaFactura = fechaDesdeUltimaFactura.split("-")

    if(parseInt(elementosFechaActual[1]) === parseInt(elementosFechaUltimaFactura[1])){ // Mes actual
      fechaActivacionMonedero = fechaDesdeUltimaFactura
      fechaDesdeUltimaFactura = ""
    }
    else{ // Otro mes
      fechaActivacionMonedero = ""
      //fechaDesdeUltimaFactura = fechaDesdeUltimaFactura
    }


  }

  //Procedo al ajuste

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  document.getElementById("loaderGeneralAplicacion").className="loader overlay"

  //Petición de datos 
  var jsonPeticion = {
    "accountID": localStorage.getItem("accountID"),
    "installationId": localStorage.getItem("installationId"),
    "activationDate":  fechaActivacionMonedero,
    "billDate": fechaDesdeUltimaFactura,
    "sollarWalletAmount": saldoPeticion.replaceAll(",",".")
  }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postUpdateSolarWallet, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {
      var jsonRespuesta = JSON.parse(this.responseText)

      if(jsonRespuesta.statusCode === "403"){                   
        initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
      }
      else{          
        //Si recibo datos ya configurados lo cargo  

        initialConfigCommonJS.mostrarMensajeInformativo("Monedero solar actualizado correctamente. La página se refrescará en 5 segundos para mostrar los datos actualizados.","positive")
        
        localStorage.setItem("forceUpdate", "true")
        setTimeout(() => {window.location.reload()},5000);	

        console.log("Monedero solar actualizado correctamente.")
        
      }

      document.getElementById("loaderGeneralAplicacion").className="loader hidden"

    }

    if (this.readyState === 4 && this.status !== 200) {   
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
    }
  }
  xhttp.send(data); 

}

exports.cambiarAMonederoManual = function(){

  document.getElementById("fieldsetFechaFacturaMonedero").className = document.getElementById("fieldsetFechaFacturaMonedero").className.replaceAll(" hidden", "") + " hidden"
  document.getElementById("fieldsetUltimoSaldoMonedero").className = document.getElementById("fieldsetUltimoSaldoMonedero").className.replaceAll(" hidden", "") 
  document.getElementById("mensajeInformativoPrimerMesActivacion").className = document.getElementById("mensajeInformativoPrimerMesActivacion").className.replaceAll(" hidden", "") + " hidden"
  document.getElementById("mensajeAclaracionBonificacionMonedero").className = document.getElementById("mensajeAclaracionBonificacionMonedero").className.replaceAll(" hidden", "")
  document.getElementById("botonManualMonedero").className = document.getElementById("botonManualMonedero").className.replaceAll(" hidden", "") + " hidden"  

  var fechaActual = new Date().toJSON().split("T")[0];      
  document.getElementById("fechaDesdeFacturaMonedero").value = fechaActual
  document.getElementById("valorSaldoMonedero").value = ""

}

exports.visibilidadConfiguracionMonedero = function(){

  try{ // Monedero solar / baterías
    var mesActivacion = parseInt(JSON.parse(localStorage.getItem("lastDashboardData")).FVData.SolarWalletActivationDate.split("-")[1])
    var añoActivacion = parseInt(JSON.parse(localStorage.getItem("lastDashboardData")).FVData.SolarWalletActivationDate.split("-")[0])
    var mesActual = parseInt(new Date().getMonth() + 1);
    var añoActual = parseInt(new Date().getFullYear())

    if(document.getElementById("divWidgetAjusteMonedero").className.includes(" hidden")){
        document.getElementById("divWidgetAjusteMonedero").className = document.getElementById("divWidgetAjusteMonedero").className.replaceAll(" hidden", "")
        document.getElementById("imagenBotonEditarMonedero").innerHTML = "close"

        if( (mesActivacion === mesActual) && (añoActivacion === añoActual) ){
            //No hago nada ya que asumo saldo 0 a fecha de activación y autocalcularé los nuevos valores energéticos.            
            document.getElementById("fieldsetFechaFacturaMonedero").className = document.getElementById("fieldsetFechaFacturaMonedero").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("fieldsetUltimoSaldoMonedero").className = document.getElementById("fieldsetUltimoSaldoMonedero").className.replaceAll(" hidden", "") + " hidden"                    
            document.getElementById("mensajeInformativoPrimerMesActivacion").className = document.getElementById("mensajeInformativoPrimerMesActivacion").className.replaceAll(" hidden", "")          
            document.getElementById("mensajeAclaracionBonificacionMonedero").className = document.getElementById("mensajeAclaracionBonificacionMonedero").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("botonManualMonedero").className = document.getElementById("botonManualMonedero").className.replaceAll(" hidden", "")
        }
        else{
            //En caso de ser otro mes le muestro el saldo por si lo tuviera de alguna factura anterior.            
            document.getElementById("fieldsetFechaFacturaMonedero").className = document.getElementById("fieldsetFechaFacturaMonedero").className.replaceAll(" hidden", "")
            document.getElementById("fieldsetUltimoSaldoMonedero").className = document.getElementById("fieldsetUltimoSaldoMonedero").className.replaceAll(" hidden", "")                 
            document.getElementById("mensajeInformativoPrimerMesActivacion").className = document.getElementById("mensajeInformativoPrimerMesActivacion").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("mensajeAclaracionBonificacionMonedero").className = document.getElementById("mensajeAclaracionBonificacionMonedero").className.replaceAll(" hidden", "")
            document.getElementById("botonManualMonedero").className = document.getElementById("botonManualMonedero").className.replaceAll(" hidden", "") + " hidden"          
        }

    }
    else{
        document.getElementById("divWidgetAjusteMonedero").className = document.getElementById("divWidgetAjusteMonedero").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("imagenBotonEditarMonedero").innerHTML = "edit"

    }
  }
  catch(error){ // Monedero bonificaciones
    console.log(error)
    if(document.getElementById("divWidgetAjusteMonedero").className.includes(" hidden")){
      document.getElementById("divWidgetAjusteMonedero").className = document.getElementById("divWidgetAjusteMonedero").className.replaceAll(" hidden", "")
      document.getElementById("imagenBotonEditarMonedero").innerHTML = "close"
      document.getElementById("fieldsetFechaFacturaMonedero").className = document.getElementById("fieldsetFechaFacturaMonedero").className.replaceAll(" hidden", "")
      document.getElementById("fieldsetUltimoSaldoMonedero").className = document.getElementById("fieldsetUltimoSaldoMonedero").className.replaceAll(" hidden", "")                 
      document.getElementById("mensajeInformativoPrimerMesActivacion").className = document.getElementById("mensajeInformativoPrimerMesActivacion").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("mensajeAclaracionBonificacionMonedero").className = document.getElementById("mensajeAclaracionBonificacionMonedero").className.replaceAll(" hidden", "")
      document.getElementById("botonManualMonedero").className = document.getElementById("botonManualMonedero").className.replaceAll(" hidden", "") + " hidden"                
    }
    else{
      document.getElementById("divWidgetAjusteMonedero").className = document.getElementById("divWidgetAjusteMonedero").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("imagenBotonEditarMonedero").innerHTML = "edit"
    }
  }

}

